window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type=' + type + ']').forEach(function(container, index){
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });


      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateOptions(variant);
      this._updateSKU(variant);
      this._updateBinNumber(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when available variant options change.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantOptionChange
     */
    _updateOptions: function(variant) {
      if (!variant) {
        return;
      }

      this.$container.trigger({
        type: 'variantOptionChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant metafields bin number changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantBinNumberChange
     */
         _updateBinNumber: function(variant) {
          this.$container.trigger({
            type: 'variantBinNumberChange',
            variant: variant
          });
        },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }
      var newurl = theme.utils.updateQueryStringParameter("variant", variant.id)
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Global ================*/
/*============================================================================
  Helper utilities
==============================================================================*/
window.theme = window.theme || {};

theme.utils = {

  /**
   * Locks the page scroll.
   *
   * @param      {element}  scrollEl  optional
   */
  lockPageScroll: function(scrollElements) {

    document.documentElement.classList.add('scroll-locked');
  },

    /**
   * Unlocks the page scroll.
   */
  unlockPageScroll: function(scrollElements) {

    document.documentElement.classList.remove('scroll-locked');
  },

  /**
   * Turns a string into a handle. Mimics Shopify's format.
   */
  handleize: function(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  /**
   * Cross-browser URL query param getter
   */
  getQueryParams: function(qs) {
    qs = qs || document.location.search;

    if (!qs) {
      return;
    }

    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },

  updateQueryStringParameter: function(key, value, url) {
    if (!url) url = window.location.href;

    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
    hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null)
        return url.replace(re, '$1' + key + "=" + value + '$2$3');
      else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
    } else {
      if (typeof value !== 'undefined' && value !== null) {
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
      else
        return url;
    }
  },

  getYoutubeId: function(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  },

  getProductJSON: function(handle, callback) {
    return $.get('/products/' + handle + '?view=json', null, callback );
  },

  hexToRgb: function(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  flash: function(elements, color, duration) {
    var opacity = 100;
    color = color || '255, 255, 136';
    duration = duration || 1500;

    if (color.indexOf('#') > -1) {
      var rgbColor = theme.utils.hexToRgb(color);
      color = [rgbColor.r,rgbColor.g,rgbColor.b].join(',');
    }

    var interval = setInterval(function() {
      opacity -= 2.5;

      $(elements).css({ background: 'rgba(' + color + ', ' + opacity / 100 + ')' });

      if (opacity <= 0) {
        clearInterval(interval);
        return;
      }
    }, duration / 40);
  },

  // Gets the rendered size of an image using object-fit
  getRenderedImgSize: function(contains, cWidth, cHeight, width, height, pos){
    var oRatio = width / height,
    cRatio = cWidth / cHeight;
    return function() {
      if (contains ? (oRatio > cRatio) : (oRatio < cRatio)) {
        this.width = cWidth;
        this.height = cWidth / oRatio;
      } else {
        this.width = cHeight * oRatio;
        this.height = cHeight;
      }
      this.left = (cWidth - this.width)*(pos/100);
      this.right = this.width + this.left;
      return this;
    }.call({});
  },

  // Returns size info for an image rendered with object-fit
  getImgSizeInfo: function(img) {
    var pos = window.getComputedStyle(img).getPropertyValue('object-position').split(' ');
    return theme.utils.getRenderedImgSize(true,
      img.width,
      img.height,
      img.naturalWidth,
      img.naturalHeight,
      parseInt(pos[0]));
  },

  // Returns content of template placed into snippets/js-tempales.liquid
  getTemplate: function(template) {
    return $('[data-template-for="' + template + '"]').html();
  },

  //
  createElementFromHTML: function(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  },

  // Returns deep differences between objects, ignoring functions
  difference: function(object, base) {
    function changes(object, base) {
      return _.transform(object, function(result, value, key) {
        if (typeof value !== 'function' && !_.isEqual(value, base[key])) {
          var comparison = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;

          if (!_.isNil(comparison)) {
            result[key] = comparison;
          }
        }
      });
    }
    return changes(object, base);
  },

  // Adds syntax highlighting to JSON output
  syntaxHighlight: function(json) {
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    json = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      var cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    });
    json = json.replace(/([\n\r]|^)(\s*){/g, '<span class="group">$2<span class="group-handle">{</span>').replace(/([\n\r]|^)(\s*)}(,|)/g, '$1$2}$3</span>');
    json = json.replace(/(<\/span>|^)(\s*)\[/g, '$1<span class="group group--inline">$2<span class="group-handle">[</span>').replace(/([\n\r]|^)(\s*)](,|)/g, '$2]$3</span>');
    return json;
  },

  getStyleValue: function(variable) {
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(variable);
    if (value) {
      return value.trim();
    }
    return '';
  },

  errorTippy: function(target, message) {
    var $el = $(target);
    var tip = tippy($el[0], {
      showOnInit: true,
      content: message,
      theme: 'light',
      animation: 'shift-away',
      arrow: true,
      delay: [0, 1000],
      onHidden: function(e) {
        e.destroy();
      }
    });
  },

  showError: function(message) {
    iziToast.show({
      message: message,
      color: 'red',
      position: 'bottomCenter'
    });
  },

};

if ('tinybind' in window) {
  tinybind.formatters.includes = function(value, search) {
    return value && value.indexOf(search) > -1
  };

  tinybind.formatters.replace = function(value, search, replace) {
    return value.replace(search, replace);
  };

  tinybind.formatters.handle = function(string) {
    return theme.utils.handleize(string);
  };

  tinybind.formatters.convert = function(amount, from, to) {
    return Currency.convert(amount, from, to);
  };

  tinybind.formatters.convertToCurrentCurrency = function(amount, from, to) {
    return Currency.convert(amount, "NZD", Currency.currentCurrency);
  };

  tinybind.formatters.currentCurrency = function(amount) {
    return amount + ' ' + Shopify.currency.active;
  };

  tinybind.formatters.noSaleTotal = function(total, items) {
    var total = 0;
    var hasNonGiftItems = false;
    items.forEach(item => {
      if(!item.gift_card && item.product_type != "Voucher") {
        hasNonGiftItems = true;
      }
    })
    items.forEach(item => {
      var isGiftVoucher = (item.gift_card || item.product_type == "Voucher") && !hasNonGiftItems
      var isSale = item.properties && item.properties['_is_sale_item'];
      var isGwpExcluded = item.properties && item.properties['_is_gwp_excluded'];

      var isDiscountedBundle = item.vendor.toLowerCase() == "gift bundle product" && item.discounts.length;
      if(!isDiscountedBundle && !isGiftVoucher && !isGwpExcluded && !isSale) total = total + item.final_line_price
    })
    return total;
  };

  tinybind.formatters.srQualifies = function(items) {
    var total = 0
    items.forEach(item => {
      if(item.vendor == "Sweat Republic") total = total + item.line_price
    })
    return total > 10000;
  };


  tinybind.formatters.bcfmQualifies = function(items, hasBCFM) {
    var total = 0
    if(items === true) return true
    items.forEach(item => {
      if(item.properties._is_sale_item) total = total + item.line_price
    })
    console.log('bcfmQualifies', total)
    return total >= 14900;
  };


  tinybind.formatters.visibleProperties = function(properties) {
    var visibleProps =  _.filter(properties, function(prop) {
      if(prop.name.indexOf('_') !== 0) return prop
    })
    return visibleProps;
  };

  tinybind.formatters.startsWith = function(value, prefix) {
    return value.indexOf(prefix) === 0;
  };

  tinybind.formatters.endsWith = function(value, suffix) {
    return value.indexOf(suffix, value.length - suffix.length) !== -1;
  };

  tinybind.formatters.gte = function(a, b) {
    return a >= b;
  };

  tinybind.formatters.equal = function(a, b) {
    return a == b;
  };

  tinybind.formatters.or = function(a, b) {
    return a || b;
  };

  tinybind.formatters.and = function(a, b) {
    return a && b;
  };

  tinybind.formatters.size = function(a) {
    return _.size(a);
  };

  tinybind.formatters.max = function(a, b) {
    return a > b ? b : a;
  };

  tinybind.formatters.between = function(a, b, c) {
    return ((a > b) && (a < c))
  };

  tinybind.formatters.min = function(a) {
    return a < b ? b : a;
  };

  tinybind.formatters.moreThan = function(a, b) {
    if (a) {
      return parseInt(a) >= b;
    } else {
      return false
    }
  };

  tinybind.formatters.style = function(a, b) {
    return b + ': ' + a + ';'
  };
  tinybind.formatters.length = tinybind.formatters.size;

  tinybind.formatters.stripHtml = function(html) {
    var parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    return parsedHtml.body.textContent || "";
  };

  tinybind.formatters.escape = function(string) {
    return JSON.stringify(string).replace(/(^"|"$)/g, '');
  };

  tinybind.formatters.json = function(a) {
    return JSON.stringify(a);
  };

  tinybind.formatters.log = function(value) {
    console.log(value);
    return value;
  };

  tinybind.formatters.string_from_property_array = function(obj, option) {
    var newArr = [];
    for (let i = 0; i < obj.length; i++) {
      newArr.push( obj[i].option )
    }
    return newArr.join('|');
  };

  tinybind.formatters.values_in_options_with_values = function(arr, index) {
    return arr[index].values;
  };

  tinybind.formatters.imagesInArray = function(arr, index) {
    if ( index > 0 ) {
      return arr[index - 1].src;
    } else {
      return '#';
    }
  }

  tinybind.formatters['price_with_addons'] = function (line_item) {
    var linePrice = line_item.line_price;

    for (var i = 0; i < CartJS.cart.items.length; i++) {
      if (line_item.properties == undefined || line_item.properties._optionGroup == undefined){
        continue;
      }
      if (
        CartJS.cart.items[i].key != line_item.key &&
        CartJS.cart.items[i].properties._optionGroup ==
          line_item.properties._optionGroup &&
          line_item.properties._optionGroup != undefined
      ) {
        linePrice += CartJS.cart.items[i].line_price;
      }
    }
    return linePrice;
  };

  tinybind.formatters['sale_gift_price'] = function (line_item) {
    var linePriceGen = line_item.price;

    for (var i = 0; i < CartJS.cart.items.length; i++) {
      if (line_item.properties == undefined || line_item.properties._optionGroup == undefined){
        continue;
      }
      if (
        CartJS.cart.items[i].key != line_item.key &&
        CartJS.cart.items[i].properties._optionGroup ==
          line_item.properties._optionGroup &&
          line_item.properties._optionGroup != undefined
      ) {
        linePriceGen += CartJS.cart.items[i].price;
      }
    }
    return linePriceGen;
  };

  tinybind.formatters['show_sale_gift_price'] = function (line_item) {
    var linePriceGen = line_item.price;
    var linePrice = line_item.line_price;
    var result = false;
    for (var i = 0; i < CartJS.cart.items.length; i++) {
      if (line_item.properties == undefined || line_item.properties._optionGroup == undefined){
        continue;
      }
      if (
        CartJS.cart.items[i].key != line_item.key &&
        CartJS.cart.items[i].properties._optionGroup ==
          line_item.properties._optionGroup &&
          line_item.properties._optionGroup != undefined
      ) {
        linePriceGen += CartJS.cart.items[i].price;
        linePrice += CartJS.cart.items[i].line_price;
      }
    }
    if(linePriceGen>linePrice){
      result = true;
    }
    return result;
  };

  tinybind.formatters.money = function(value) {
    Currency.formatMoney(value, "");
    return Currency.formatMoney(value, "");
  };

  tinybind.formatters.hasGiftMessageByIndex = function(items, index) {
    const giftItemLineProperty = 'Message'

    return items[index].properties[giftItemLineProperty];
  };

  tinybind.formatters.hasGiftMessage = function(items) {
    const giftItemLineProperty = 'Message'
    const cartItemIndex = items
      .findIndex(item =>
        (Object.keys(item.properties).findIndex(prop => prop == giftItemLineProperty) > -1)
      )
    return cartItemIndex > -1 ? items[cartItemIndex].properties[giftItemLineProperty] : null;
  };

  tinybind.formatters.noGiftMessage = function(items) {
    var total = 0
    items.forEach(item => {
      if(!(item.properties && item.properties['_is_sale_item'])) total = total + item.final_line_price
    })
    var freeGiftInCart = _.find(items, function(item) {
      return (item.properties && (item.properties['_is_regular_free_gift'] || item.properties['_is_luxury_free_gift']))
    });
    return (total > 10000 && !freeGiftInCart)
  };

  tinybind.formatters.hasGiftCard = function(items) {
    return tinybind.formatters.hasItemWithProperty(items, '_is_gift_card');
  };

  tinybind.formatters.hasGiftWrap = function(items) {
    return tinybind.formatters.hasItemWithProperty(items, '_is_gift_wrapping');
  };

  tinybind.formatters.hasGiftBundle = function(items) {
    return tinybind.formatters.hasItemWithProperty(items, '_bundleQuan');
  };

  tinybind.formatters.hasItemWithProperty = function(items, property) {
    return items
      .findIndex(item =>
        (Object.keys(item.properties).findIndex(prop => prop == property) > -1)
      ) > -1
  }
  tinybind.formatters.noGiftItems = function(items) {
    let gift = tinybind.formatters.hasGiftBundle(items);
    if(gift){
    const giftCard = tinybind.formatters.hasGiftCard(items);
    const giftWrap = tinybind.formatters.hasGiftWrap(items);

    return !giftCard || !giftWrap;
    }else{
      return false;
    }

  };

  tinybind.formatters.hasGiftBox = function(items) {
    const giftBoxVendor = 'GIFT BOX'
    const cartItemIndex = items
      .findIndex(item =>
        item.vendor == giftBoxVendor
      )
    //console.log('items', cartItemIndex);
    return cartItemIndex > -1;
  };

  tinybind.formatters.hasGiftItem = function(items, giftVariantId, type) {
    var hasGiftItem = false;
    switch (type) {
      case 'luxury': type = '_is_luxury_free_gift'; break;
      case 'regular': type = '_is_regular_free_gift'; break;
      case 'wrapping': type = '_is_gift_wrapping'; break;
      case 'card': type = '_is_gift_card'; break;
      case 'garment': type = '_is_garment_bag'; break;
      default:
        break;
    }
    if(type) {
      const cartItem = items
        .findIndex(item => item.variant_id == giftVariantId &&
          (Object.keys(item.properties).findIndex(prop => prop == type) > -1)
        )
      if(cartItem > -1) {
        hasGiftItem = true;
      }
    }
    return hasGiftItem;
  };

  tinybind.formatters.bundleHasItemType = function(items, bundle, giftItemType) {
    var bundledItem =  tinybind.formatters.hasItemWithPropertyAndValue(items, '_optionGroup', bundle);
    var requiredType = tinybind.formatters.hasItemWithPropertyAndValue(bundledItem, '_type', giftItemType);
    return requiredType.length > 0
  };

  tinybind.formatters.hasItemWithPropertyAndValue = function(items, property, value) {
    return items
      .filter(item => {
        return item.properties[property] == value
      })
  }

  tinybind.formatters.checkInCart = function(id, prop, cart) {
    let inCart = false;
    for (let i = 0; i < cart.length; i++) {
      if ( cart[i].id == id && cart[i].properties._optionGroup == prop ) {
        inCart = true;
      }
    }
    return inCart;
  };

  tinybind.formatters.array_position = function(array, value) {
    return (value >= 0 ? array[value] : array[array.length + value]);
  };

  tinybind.formatters.percentage_of = function(a, b) {
    return b / a * 100;
  };

  tinybind.formatters.contains = function(a, b) {
    if(!a) return false;
    return (a.indexOf(b) > -1);
  };

  tinybind.formatters.imageExists = function(a) {
    return (a && a.indexOf('no-image') == -1);
  };

  tinybind.formatters.part = function(a, b) {
    return a / b;
  };

  tinybind.formatters.addPrefixStr = function(val, str) {
    return str + val;
  };

  tinybind.formatters.sort = function(a,b) {
    console.log(a);
    console.log(b);
  };


  tinybind.formatters.getstars = function(a) {
    var star = '<svg height="12px" viewBox="0 -10 511.99143 511" width="12px" xmlns="http://www.w3.org/2000/svg"><path d="m510.652344 185.882812c-3.371094-10.367187-12.566406-17.707031-23.402344-18.6875l-147.796875-13.417968-58.410156-136.75c-4.3125-10.046875-14.125-16.53125-25.046875-16.53125s-20.738282 6.484375-25.023438 16.53125l-58.410156 136.75-147.820312 13.417968c-10.835938 1-20.011719 8.339844-23.402344 18.6875-3.371094 10.367188-.257813 21.738282 7.9375 28.925782l111.722656 97.964844-32.941406 145.085937c-2.410156 10.667969 1.730468 21.699219 10.582031 28.097656 4.757813 3.457031 10.347656 5.183594 15.957031 5.183594 4.820313 0 9.644532-1.28125 13.953125-3.859375l127.445313-76.203125 127.421875 76.203125c9.347656 5.585938 21.101562 5.074219 29.933593-1.324219 8.851563-6.398437 12.992188-17.429687 10.582032-28.097656l-32.941406-145.085937 111.722656-97.964844c8.191406-7.1875 11.308594-18.535156 7.9375-28.925782zm-252.203125 223.722657"/></svg>';
    var result = '';
    for (var i = a - 1; i >= 0; i--) {
      result += star;
    }
    return result;
  };

  tinybind.formatters.split = function (string, splitter) {
    return string ? string.split(splitter) : []
  }

  tinybind.formatters.join = function (array, joiner) {
    return array ? array.join(joiner) : ''
  }

  tinybind.formatters.where = function (array, key, operator, value) {
    return !array || !Array.isArray(array) ? [] : array.filter(function (item) {
      if (typeof !item[key] === 'undefined') {
        return
      };

      switch (operator) {
        case '==':
          return item[key] == value;
        case '!=':
          return item[key] != value;
        case '===':
          return item[key] === value;
        case '!==':
          return item[key] !== value;
        case '<':
          return item[key] < value;
        case '<=':
          return item[key] <= value;
        case '>':
          return item[key] > value;
        case '>=':
          return item[key] >= value;
        default:
          throw 'Invalid operator'
      }

    })
  }

  tinybind.binders.selected = function(el, value) {
    if (value) {
      el.selected = 'selected';
    }
  };

  tinybind.binders.get = function(obj, property) {
    if(!obj) return null
    return obj[property]
  };

  tinybind.binders['scroll-to'] = function(el, value) {
    var parent;

    if (value) {
      parent = el.parentElement;
      $(parent).scrollTo(el, {
          duration: 500,
          interrupt: !isMobile.apple.device,
          offset: -20
      });
    }
  };

  tinybind.formatters.updateSrcset = function(image, widthsString) {
    if (!image || !widthsString) {
      return;
    }

    if (typeof widthsString !== 'string') return;

    const widths = widthsString.split(',')

    let srcset = '';
    for (let i = 0; i < widths.length; i++) {
      let width = widths[i];

      if (!image) return;

      let src = Shopify.Image.getSizedImageUrl(image, width + 'x');
      srcset += `${src} ${width}w`;
      if (i < widths.length - 1) {
        srcset += ', ';
      }
    }

    return srcset;
  }

  tinybind.formatters.lazyLoadBasedOnIndex = function(index) {
    if (window.innerWidth >= 1200) {
      return index < 4 ? 'eager' : 'lazy';
    } else if (window.innerWidth >= 768) {
      return index < 3 ? 'eager' : 'lazy';
    }

    return index < 2 ? 'eager' : 'lazy';
  }
}

window.theme = window.theme || {};
window.theme.drawers = window.theme.drawers || {};
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {

  if ('Hammer' in window && isMobile.any) {
    theme.pageSwipeObject = new Hammer.Manager(document.getElementById('PageContainer'), {
      touchAction: 'auto',
      inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchMouseInput,
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_HORIZONTAL
        }]
      ]
    });

    theme.pageSwipeObject.on('swiperight', function(evt) {
      if ($('body').hasClass('js-drawer-open-right')) {
        console.log('js-drawer-open-right');
        var $drawer = $('.drawer.drawer--right');
        theme[$drawer.attr('id')].close();
        console.log('close');
        return;
      }

      var $drawer = $('.drawer.drawer--left');
      if (!$drawer.length) {
        return;
      }
      var delta_x = evt.deltaX;
      var final_x = evt.srcEvent.pageX || evt.srcEvent.screenX || 0;
      var startPosition = final_x - delta_x;
      if (startPosition >= 0 && startPosition <= 25) {
        theme[$drawer.attr('id')].open();
        console.log('open');
      }
      return false;
    });

    theme.pageSwipeObject.on('swipeleft', function(evt) {
      if ($('body').hasClass('js-drawer-open-left')) {
        console.log('js-drawer-open-left');
        var $drawer = $('.drawer.drawer--left');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--right');
      if (!$drawer.length) {
        return;
      }
      var delta_x = evt.deltaX;
      var final_x = evt.center.x || 0;
      var startPosition = final_x + -delta_x;
      var windowWidthOffset = $(window).width() - 25;
      if (startPosition >= windowWidthOffset) {
        theme[$drawer.attr('id')].open();
      }
      return false;
    });
  }

  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position,
      pageContentSelector: '#PageContent',
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $(this.config.pageContentSelector)
    };

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    theme.drawers[id] = this;

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.closeAllDrawers = function(evt) {
    // Close all drawers
    _.forEach(theme.drawers, function(drawer) {
      if (drawer.drawerIsOpen) {
        drawer.close();
      }
    });
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    this.closeAllDrawers();

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    let scrollElements = this.$drawer[0].querySelectorAll('.tabs-group__tabs, .gift-item-selector__gifts');
    theme.utils.lockPageScroll(scrollElements);

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    let scrollElements = this.$drawer[0].querySelectorAll('.tabs-group__tabs, .gift-item-selector__gifts');
    theme.utils.unlockPageScroll(scrollElements);

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerClose && typeof this.config.onDrawerClose === 'function') {
      this.config.onDrawerClose();
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    this.nodes.$page.on('click.drawer', $.proxy(function() {
      if (!this.$drawer[0].contains(event.target)) {
        this.close();
      }
    }, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

window.theme = window.theme || {};

theme.Index = (function(last, first) {

  var self = {
    version: '1.0.5',
    loop: false,
    removed: [],
    added: [],
    active: [],
    first: first || 0,
    last: last,
    span: last - (first || 0) + 1,
    back: [],

    set: function(index) {

      self.curr = clip(index);

      // set active indices
      var active = [self.curr];
      (self.prev = self.curr - 1) < self.first || active.unshift(self.prev);
      (self.next = self.curr + 1) > self.last || active.push(self.next);

      self.prev = clip(self.prev);
      self.next = clip(self.next);


      // save to self
      if(typeof _ === 'function') { // features only available with Underscore

        self.removed = _.difference(self.active, active),
        self.added = _.difference(active, self.active);
      }
      self.active = active;

      // direction
      if(self.back[0]) self.direction = self.curr > self.back[0].prev ? 1 : -1;

      // keep a history of past indices
      self.back.unshift({
        prev: self.prev,
        curr: self.curr,
        next: self.next,
      });

      return self;
    },
  },

  clip = function(index) {

    if(self.loop) {

      if(index > self.last) return self.first;
      else if(index < self.first) return self.last;
      else return index;
    }
    else return Math.min(Math.max(index, self.first), self.last);
  };

  return self;

});

theme.Modal = (function() {

  var config = {

  };

  function Modal(content, options) {

    this.modalContent = content;
    this.options = options || {};
    this._createNewModal = _createNewModal.bind(this);
    this.modal = this._createNewModal();

  }

  function _createNewModal() {

    var featherlightOptions = this.options.featherlightOptions;
    var modal = $.odModal($(this.modalContent), featherlightOptions);

    if (this.options.positionX || this.options.positionY) {
      modal.$instance.addClass('od-modal--' + this.options.positionX);
      modal.$instance.addClass('od-modal--' + this.options.positionY);
    }


    return modal;
  }

  Modal.prototype = $.extend({}, Modal.prototype, {
    _createNewModal: function() {

      var featherlightOptions = this.options.featherlightOptions;
      var modal = $.odModal($(this.modalContent), featherlightOptions);

      if (this.options.positionX || this.options.positionY) {
        modal.$instance.addClass('od-modal--' + this.options.positionX);
        modal.$instance.addClass('od-modal--' + this.options.positionY);
      }


      return modal;
    }

  });

  return Modal;
})();

/*============================================================================
  Modal modules
==============================================================================*/
theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $(id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body')
    };
    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.init();
  }

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal.addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.removeClass(this.config.openClass);
    this.nodes.$parent.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', $.proxy(function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');
  };

  return Modal;
})();

(function() {
  var selectors = {
    tabHandles: '.tabs-menu a'
  };

  var classes = {
    qtySelector: 'js-qty-select'
  };

  var $tabHandles = $(selectors.tabHandles);

  if (!$tabHandles.length) {
    return;
  }

  $(selectors.tabHandles).click(function(e) {
    e.preventDefault();
    var $this = $(this);
    $this.parent().addClass("current");
    $this.parent().siblings().removeClass("current");
    var tab = $this.attr("href");
    $(".tab-content").not(tab).css("display", "none");
    $(tab).fadeIn();
  });
})();

window.theme = window.theme || {};

theme.TabAccordions = (function() {

  function TabAccordion(element, options) {
    var count = 0;
    var defaults = {
      namespace: 'ODTabAccordion',
    };

    this.$element = $(element);

    if (!this.$element.length) {
      return false;
    }

    this.config = $.extend(defaults, options);
    this.namespace = this.config.namespace + '-' + count++;
    this.type = (this.$element.hasClass('accordion') && 'accordion') || (this.$element.hasClass('tabs') && 'tabs');
    return this.create();
  }

  TabAccordion.prototype.create = function() {
    this.$panels = this.$element.children();
    this.$tabs = this.$panels.children(':first-child');

    if(this.index) var prev = this.index.curr;
    (this.index = theme.Index(this.$panels.length - 1)).loop = true; // <- index looping for keyboard accessibility
    if(prev) this.index.set(prev);

    if(this.type === 'tabs') this.$element.prepend((this.$tabs = this.tabsCreateTablist(this.$tabs).children()).end());

    this.$tablist = (this.type === 'tabs' ? this.$tabs.parent() : this.$element).attr('role', 'tablist');

    this.$tabs.attr({
      'id': function(index) {
        return this.id || this.namespace + '-tab-' + index;
      },
      'role': 'tab',
    });

    var self = this;

    (this.$content = this.$panels.map(function(index) {
      return $(this)
      .attr({
        'aria-labelledby': self.$tabs[index].id,
        'id': self.id || self.namespace + '-panel-' + index,
        'role': 'tabpanel',
      })
      .children()
      .slice(1)
      .wrapAll('<div><div></div></div>')
      .parent()
      .parent()
      .get();
    }))
    .each($.proxy(this.collapse, this));

    $(window).on('resize.' + this.namespace, $.debounce(250, $.proxy(this.resize, this)));

    this.$element.attr({
      'id': this.$element.id || this.namespace,
      'tabindex': 0
    })
    .on('click.' + this.namespace, this.type === 'accordion' && '> * > :first-child' || '> :first-child > *', function(event) {
      self.goTo(self.$tabs.index($(event.target).closest(self.$tabs)));
    })
    .on('keydown.' + this.namespace, function(event) {

      // event.target should be the element and not a descendant
      if(event.target !== self.$element) return;

      var match = {
        37: 'prev',
        38: 'prev',
        39: 'next',
        40: 'next',
      }[event.keyCode];

      if(match) {

        event.preventDefault();

        self.goTo(self.index[match]);
      }
    })
    .trigger('create');

    if(this.config.saveState) this.extensions.saveState.bind(this, this.config.saveState) && this.extensions.saveState();
    if(this.config.responsiveSwitch) this.extensions.responsiveSwitch.bind(this, this.config.responsiveSwitch) && this.extensions.responsiveSwitch();
    if(this.config.hashWatch) this.extensions.hashWatch.call(this);
    if(this.config.pauseMedia) this.extensions.pauseMedia.call(this);

    if(typeof this.index.curr !== 'number') this.index.set(0);

    setTimeout(function() {
      self.$element.addClass('transition');
    });

    return this.expand(this.index.curr);
  };

  TabAccordion.prototype.destroy = function(keepData) {
    if(this.type === 'tabs') {
      this.$element.height('auto');
      this.$tablist.remove();
    } else {
      this.$tabs.removeAttr('role').filter('[id^="' + this.namespace + '"]').removeAttr('id');
      this.$tablist.removeAttr('role');
    }

    this.$panels
    .removeAttr('aria-expanded aria-labelledby role')
    .filter('[id^="' + this.namespace + '"]').removeAttr('id');

    this.$content
    .children()
    .children()
    .unwrap()
    .unwrap();

    if(!keepData)
    this.$element
    .removeData(namespace)
    .removeData('responsiveBreakpoint.' + this.namespace);

    this.$element
    .add([window, document.body])
    .off('.' + this.namespace)
    .end()
    .removeAttr('aria-activedescendant tabindex')
    .removeClass(this.type)
    .filter('[id^="' + this.namespace + '"]').removeAttr('id')
    .end()
    .trigger('destroy');

    return this;
  };

  TabAccordion.prototype.resize = function() {
    if(this.type === 'tabs') this.$element.height(this.$tablist.outerHeight() + this.$panels.eq(this.index.curr).outerHeight());
    else if(this.type === 'accordion' && this.$panels[this.index.curr].ariaExpanded)
    this.$content
    .eq(this.index.curr)
    .height(this.$content.eq(this.index.curr).children().outerHeight());

    return this;
  };

  TabAccordion.prototype.expand = function(index) {
    var $panel = this.$panels.eq(index).attr('aria-expanded', this.$panels[index].ariaExpanded = true);

    if(this.resize().type === 'tabs') this.$tabs.eq(index).addClass('current');

    this.$element.attr('aria-activedescendant', this.$panels[this.index.curr].id).trigger('expand', [index, $panel]);

    return this;
  };

  TabAccordion.prototype.collapse = function(index) {
    var $panel = this.$panels.eq(index).attr('aria-expanded', this.$panels[index].ariaExpanded = false);

    if(this.type === 'tabs') {
      this.$tabs.eq(index).removeClass('current');
    } else {
      this.$content.eq(index).height(0);
    }

    this.$element.trigger('collapse', [index, $panel]);

    return this;
  };

  TabAccordion.prototype.goTo = function(index) {
    if(this.index.curr !== index && typeof this.index.curr === 'number') this.collapse(this.index.curr);
    this.index.set(index);

    return this[this.type === 'accordion' && this.$panels.eq(index).prop('ariaExpanded') ? 'collapse' : 'expand'](this.index.curr);
  };

  TabAccordion.prototype.tabsCreateTablist = function(titles) {
    if (typeof this.config.tabsCreateTablist === "function") {
      return this.config.tabsCreateTablist();
    }

    for(var i = 0, li = ''; i < titles.length; i++) li += '<li>' + titles[i].innerHTML + '</li>';
    return $('<ul>' + li + '</ul>');
  };

  TabAccordion.prototype.extensions = {
    hashWatch: function() {

      var that = {
        changeHash: function(hash, $target) {

          var id = $target[0].id;

          $target[0].id = '';
          location.hash = hash;
          $target[0].id = id;

          return that;
        },

        expand: function(hash, event) {

          var $target = this.$element.find(hash);

          if($target.length) {

            var $panel = $target.closest(this.$panels);

            if($panel.length) {

              if(event) event.preventDefault();

              this.goTo(this.$panels.index($panel));
              that.changeHash(hash, $target);

              if(event)
              setTimeout(function() {

                $html
                .add(document.body)
                .animate({
                  scrollTop: $target.offset().top,
                });
              },
              250);
            }
          }

          return that;
        },
      };

      // hash anchor activation
      $(document.body).on('click.' + this.namespace, 'a[href^="#"]:not([href="#"])', function(event) {
        that.expand.call(self, $(event.target).attr('href'), event);
      })

      // navigation e.g. back button
      .on('hashchange.' + this.namespace, function() {
        that.expand.call(self, location.hash);
      });

      return that.expand.call(this, location.hash);
    },

    saveStateLoaded: false,
    saveState: function(storage) {

      if(typeof storage !== 'object') return;

      var state = {
        remove: function() {

          storage.removeItem(this.namespace);
        },

        load: function() {

          var item = storage.getItem(this.namespace),
            data = JSON.parse(item);

          if(data && data.current) this.index.set(data.current);

          this.extensions.saveStateLoaded = true;
        },

        save: function() {

          storage.setItem(this.namespace, JSON.stringify({current: this.index.curr, expanded: this.$panels[this.index.curr].ariaExpanded}));
        },
      };

      // load only once per instance per page load
      if(!this.extensions.saveStateLoaded) state.load();

      $(window).on('unload.' + this.namespace, state.save);

      return state;
    },

    responsiveSwitch: function(breakpoint) {
      if(breakpoint === 'tablist') {
        if(this.type === 'tabs') this.$element.data('responsiveBreakpoint.' + this.namespace, breakpoint = getTablistWidth());
        else breakpoint = this.$element.data('responsiveBreakpoint.' + this.namespace);
      }

      function getTablistWidth() {
        for(var i = 0, width = 0; i < this.$tabs.length; i++) width += this.$tabs.eq(i).outerWidth(true);
        return width;
      }

      function switchTo(type) {
        var current = this.index.curr,
            expanded = this.$panels[current].ariaExpanded;

        this.destroy(true);

        this.$element.addClass(this.type = type);

        this.index.set(current);
        this.create();

        this.$element.trigger('typechange', type);
      }

      function checkBreakpoint() {
        var type = this.$element.outerWidth() <= breakpoint ? 'accordion' : 'tabs';
        if(this.type !== type) switchTo(type);
      }

      $(window).on('resize.' + this.namespace, $.debounce(250, checkBreakpoint));
    },

    pauseMedia: function() {
      if(typeof Modernizr === 'undefined' || !Modernizr.audio || !Modernizr.video || !this.$element.find('audio, video').length) return;

      this.$element.on('collapse.' + this.namespace, function(event, index, $panel) {
        $panel.find('audio, video').each(function() {
          this.pause();
        });
      });
    },
  };

  return TabAccordion;
})();

window.theme = window.theme || {};
window.theme.tabsGroups = window.theme.tabsGroups || {};

/*============================================================================
  TAB GROUPS
==============================================================================*/

theme.TabsGroup = (function() {

  var selectors = {
    container: '.tabs-group',
    tab: '.tabs-group__tab'
  };

  var defaultOptions = {
    activeTab: 1,
    tabsActiveClass: 'tabs-group--active',
    navContainerClass: 'tabs-group__nav',
    tabNavItemClass: 'tabs-group__nav-item',
    accordionNavItemClass: 'tabs-group__accordion-nav-item',
    breakpoint: 990,
    transitionDuration: 0.5
  };

  function TabsGroup(el, options) {
    this.$tabsGroup = $(el);

    if (!this.$tabsGroup.length) {
      return;
    }

    this.options = _.defaults(options, defaultOptions);

    this.config = {
      mediaQueryAccordion: 'screen and (max-width: ' + this.options.breakpoint + 'px)',
      mediaQueryTabs: 'screen and (min-width:  ' + (this.options.breakpoint + 1) + 'px)'
    };

    this.$tabs          = this.$tabsGroup.find(selectors.tab);
    this.$navContainer = $('<div></div>').addClass(this.options.navContainerClass);

    // Set initial tab states
    for (var j =  this.$tabs.length - 1; j >= 0; j--) {
      var $tab = $(this.$tabs[j]);
      var tabId = $tab.data('tab');
      var tabTitle = $tab.data('tabTitle');

      var $navItem = $('<div></div>')
                      .attr('data-target', tabId)
                      .attr('data-target-title', tabTitle)
                      .html(tabTitle);
      if (tabTitle == 'My Cart'){
        $navItem.prepend(`<svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.38232 5.35294V3.52771C4.38232 2.13172 5.33033 1 6.5001 1C7.66955 1 8.61755 2.13172 8.61755 3.52771V5.35294" stroke="#1A1919" stroke-linecap="round"/>
        <path d="M2.64277 4.22058H10.3574C10.6147 4.22058 10.8301 4.41598 10.855 4.67216L11.7192 13.5545C11.7478 13.8484 11.5169 14.1029 11.2216 14.1029H1.77853C1.48326 14.1029 1.25229 13.8484 1.28088 13.5545L2.14512 4.67216C2.17004 4.41598 2.38538 4.22058 2.64277 4.22058Z" stroke="#1A1919"/>
        </svg>`);
      }

      if (tabTitle == 'Wishlist'){
        $navItem.prepend(`<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2208 4.26105C15.1929 1.88105 13.2944 -0.0258153 10.9786 0.000291552C9.86241 -0.00377613 8.79324 0.447081 8.00003 1.24078C7.20669 0.44708 6.13663 -0.00378014 5.01435 0.000264353C2.70573 -0.0258153 0.807197 1.88105 0.779299 4.26105C0.778346 5.24211 1.10837 6.18739 1.71251 6.93972C1.75479 6.99092 2.81112 8.20643 4.67951 10.3549L6.71124 12.691L7.63476 13.7527C7.8296 13.9766 8.17067 13.9766 8.36544 13.7525L14.2751 6.9547C14.8917 6.18739 15.2217 5.24211 15.2208 4.26663L15.2208 4.26105ZM8.38626 2.30345C9.01019 1.48227 9.96858 1.00383 10.9823 1.00749C12.7634 0.987459 14.218 2.44751 14.2408 4.2704C14.2409 5.01057 13.9902 5.72769 13.5318 6.29859L7.99996 12.6613L7.44187 12.0197L5.41021 9.68372L5.4087 9.68198C3.64118 7.64948 2.49242 6.32761 2.46378 6.29299C2.00933 5.72698 1.75858 5.00876 1.75928 4.26761C1.78063 2.449 3.23579 0.987449 5.01071 1.00746C6.03154 1.00383 6.98993 1.48227 7.61386 2.30345C7.81004 2.56166 8.19008 2.56166 8.38626 2.30345Z" fill="#1A1919"/>
        </svg>
        `);
      }

      if (tabId == this.options.activeTab) {
        this.activeTab = tabId;
        $tab.attr('data-active', 'true');
        $navItem.attr('data-active', 'true');
      } else {
        $tab.attr('data-active', 'false');
        $navItem.attr('data-active', 'false');
      }

      var $tabNavItem = $navItem;
      var $accordionNavItem = $navItem.clone();

      $tabNavItem.addClass(this.options.tabNavItemClass);
      this.$navContainer.prepend($tabNavItem);

      $accordionNavItem.addClass(this.options.accordionNavItemClass).insertBefore($tab);

    }

    this.$tabsGroup.prepend(this.$navContainer);
    this.$navItems = this.$tabsGroup.find('[data-target]');

    var self = this;

    enquire.register(this.config.mediaQueryAccordion, {
      match: function() {
        self.$tabsGroup.attr('data-tabs-type', 'accordion');
      }
    });

    enquire.register(this.config.mediaQueryTabs, {
      match: function() {
        self.$tabsGroup.attr('data-tabs-type', 'tabs');
      }
    });

    // Bind nav click events
    $(this.$navItems).on('click',function() {
      var target = $(this).data('target');

      if (self.activeTab == target) {
        self._closeAll();
      } else {
        self._goTo(target);
        self.activeTab = target;
      }

    });

    $(this.$tabsGroup).addClass(this.options.tabsActiveClass);
  }

  TabsGroup.prototype = $.extend({}, TabsGroup.prototype, {

    _closeAll: function() {
      var self = this;

      if (self.$tabsGroup.attr('data-tabs-type') != 'accordion') {
        return;
      }

      var $activeTab = $('[data-tab="' + self.activeTab + '"]', self.$tabsGroup);

      var animate = false;
      if ($(window).width() < this.options.breakpoint) {
        animate = true;
      }

      var height = {
        active: {}
      };

      if (animate) {
        height.active.current = $activeTab.height();
        $activeTab.css('height', height.active.current);
      }

      $(self.$tabs).attr('data-active', 'false');
      $(self.$navItems).attr('data-active', 'false');

      if (animate) {
        height.active.new = 0;

        $activeTab.height(height.active.current);

        $activeTab.height(height.active.new);

        setTimeout(function(){
          $activeTab.css('height','');
         }, self.options.transitionDuration * 1000);
      }

      self.activeTab = false;

    },
    _goTo: function(target) {
      var self = this;

      this.$tabsGroup.trigger({
        type: 'tabChange',
        tabIndex: target
      });

      var $tab = $('[data-tab="' + target + '"]', self.$tabsGroup);
      var $activeTab = $('[data-tab="' + self.activeTab + '"]', self.$tabsGroup);

      var animate = false;
      if ($(window).width() < this.options.breakpoint) {
        animate = true;
      }

      var height = {
        target: {},
        active: {}
      };

      if (animate) {
        height.target.current = 0;
        $tab.css('height', height.target.current);

        height.active.current = $activeTab.height();
        $activeTab.css('height', height.active.current);
      }

      $(self.$tabs).attr('data-active', 'false');
      $(self.$navItems).attr('data-active', 'false');

      var $target = self.$tabsGroup.find('[data-tab=' + target + ']');
      $($target).attr('data-active', 'true');

      var $targetNav = self.$tabsGroup.find('[data-target=' + target + ']');
      $($targetNav).attr('data-active', 'true');

      if (animate) {
        height.target.new = $tab.css('height','auto').get(0).scrollHeight;
        height.active.new = 0;

        $tab.height(height.target.current);
        $activeTab.height(height.active.current);

        $tab.height(height.target.new);
        $activeTab.height(height.active.new);

        setTimeout(function(){
          $tab.css('height','');
          $activeTab.css('height','');

          $(window).scrollTo($target, {
            duration: self.options.transitionDuration * 1000,
            interrupt: !isMobile.apple.device,
            offset: -100
          });

         }, self.options.transitionDuration * 1000);
      }

      self.activeTab = target;
    }

  })

  return TabsGroup;
})();

window.theme = window.theme || {};
window.accordions = window.accordions || {};

theme.SimpleAccordion = (function() {

  var defaults = {
    activeClass: 'active',
    accordionClass: 'simple-accordion',
    accordionTitleClass: 'simple-accordion__title',
  };

  var selectors = {
    accordion: '[data-simple-accordion]',
    title: '.' + defaults.accordionTitleClass,
    productPageAccordionItem: '.product-single__details-accordion .simple-accordion__item'
  };

  function SimpleAccordion(el) {

    this.$el = $(el);

    var mediaQuery = this.$el.data('simpleAccordion');

    if (mediaQuery) {
      this.mediaQuery = theme.settings.mediaQuery[mediaQuery];
    }

    var styleValue = theme.utils.getStyleValue('--accordion-transition-duration') || '0.5s';

    this.animationDuration = styleValue.replace('s', '') * 1000;

    this.$titles = this.$el.find(selectors.title);
    if (!this.$titles.length) {
      this.$titles = this.$el.children().first();
      this.$titles.addClass(defaults.accordionTitleClass);
    }


    var self = this;

    if (self.mediaQuery) {
      _registerBreakpoints(self.mediaQuery);
    } else {
      initAccordion();
    }

    function initAccordion() {
      self.$el.addClass(defaults.accordionClass);
      self.$titles.on('click.accordion', _openClose);
      if(self.$el.hasClass('product-single__details-accordion')) {
        $(selectors.productPageAccordionItem).on('click', checkClick)
      }
    }

    function checkClick() {
      $(this).find(selectors.title).trigger('click.accordion');
    }

    function destroyAccordion() {
      self.$el.removeClass(defaults.accordionClass);
      self.$titles.off('click.accordion');
    }

    function _registerBreakpoints(mediaQuery) {

      enquire.register(mediaQuery, {
        match: function() {
          initAccordion();
        },
        unmatch: function() {
          destroyAccordion();
        }
      });

    }

    function _openClose() {
      var $target = $(this).next();
      var $active = self.$titles.filter('.' + defaults.activeClass).next();

      var close = false;
      if ($target[0] == $active[0]) {
        close = true;

        // Don't do anything if a link is clicked
        if (event.target.href) {
          window.location.href = event.target.href;
          return;
        }
      }

      event.preventDefault();

      self.$titles.removeClass(defaults.activeClass);

      var height = {
        target: {},
        active: {}
      };

      height.target.current = $target.height();
      height.active.new = 0;
      height.active.current = $active.height();

      $active.height(height.active.current);

      if (!close) {
        $(this).addClass(defaults.activeClass);
        $target.height(height.target.current);
        $target.addClass(defaults.activeClass);
      }

      $active.removeClass(defaults.activeClass);

      if (!close) {
        height.target.new = $target.height('auto').get(0).scrollHeight;
        $target.height(height.target.current);
        $target.height(height.target.new);
      }

      $active.height(height.active.new);

      setTimeout(function(){
        $target.height('');
        $active.height('');
       }, self.animationDuration);

      return;
    }
  }

  (function init() {
    var $accordions = $(selectors.accordion);
    if (!$accordions.length) {
      return;
    }
    for (var i = $accordions.length - 1; i >= 0; i--) {
      window.accordions[i] = new SimpleAccordion($accordions[i]);
    }
  })();

  return 
});

new theme.SimpleAccordion()
/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.QuantitySelector = (function() {
  var selectors = {
    qtyInputs: 'input[type="number"]',
    excludeInputs: '#cart input[type="number"], .js-qty-select input[type="number"], .product-grid-item input[type="number"]',
    qtySelector: '.js-qty-select',
    qtyButtonAdd: '.js-qty-select-add',
    qtyButtonSubtract: '.js-qty-select-sub',
  };

  var classes = {
    qtySelector: 'js-qty-select',
    qtyButtonAdd: 'js-qty-select-add',
    qtyButtonSubtract: 'js-qty-select-sub',
  };

  var defaults = {
    template: 'quantity-selector',
    formatAsSize: false
  };

  function QuantitySelector(inputEl, userOptions) {
    if (!inputEl) {
      return false;
    }

    this.inputEl = inputEl;

    var parent,
        template,
        el,
        options;

    options = _.defaults(userOptions, defaults);

    parent = inputEl.parentNode;
    template = theme.utils.getTemplate(options.template);
    el = theme.utils.createElementFromHTML(template);

    this.data = {
      formatAsSize: (options.variantSize ? options.formatAsSize : false),
      variantSize: options.variantSize
    };

    this.data.input = {
      value: inputEl.value ? parseInt(inputEl.value) : 0,
      id: inputEl.id,
      class: inputEl.classList.toString(),
      max: inputEl.max ? parseInt(inputEl.max) : 10000,
      min: inputEl.min ? parseInt(inputEl.min) : 0,
      name: inputEl.name,
      pattern: inputEl.pattern,
    };

    inputEl.classList.add('hidden');
    parent.appendChild(el);

    tinybind.bind(el, {
      data: this.data,
      methods: {
        subtract: this.subtract.bind(this),
        add: this.add.bind(this),
      }
    });

    this.update();
  }

  QuantitySelector.prototype = _.extend({}, QuantitySelector.prototype, {

    subtract: function() {
      event.preventDefault();
      this.set((this.data.input.value - 1));
      this.update("-");
    },

    add: function() {
      event.preventDefault();
      this.set((this.data.input.value + 1));
      this.update("+");
    },

    set: function(value) {
      // #todo
      var updateEvent;

      if (this.data.input.value < this.data.input.min) {
        value = this.data.input.min;
      } else if (this.data.input.value > this.data.input.max) {
        value = this.data.input.max;
      }

      var product_item_price = $(
        ".product-single .product__price .product_item_price"
      ).text();
      $(".simple-product-price-calc").text(
        `$${(value * product_item_price).toFixed(2)}`
      );
      $(".simple-product-price-calc-btn").text(
        `$${(value * product_item_price).toFixed(2)}`
      );

      this.data.quantity = value;
      this.data.input.value = value;
      this.inputEl.value = value;

      $(this.inputEl).trigger('valueUpdated', value);

    },

    update: function (a) {
      if (theme.current.bundleTotal != undefined) {
        switch (a) {
          case "+":
            theme.current.bundleTotal += parseInt(this.inputEl.dataset.price);
            break;

          case "-":
            theme.current.bundleTotal -= parseInt(this.inputEl.dataset.price);
            break;
        }

        $(`input[data-id="${this.inputEl.dataset.for}"`).val(
          this.data.input.value
        );
      }
    },
  });

  return QuantitySelector;
})();

(function() {
  var classes = {
    notificationHidden: 'notification-message--hidden'
  };

  var queryParams = theme.utils.getQueryParams();

  if (queryParams === undefined || queryParams.status === undefined) {
    return;
  }

  $('[data-notification="' + queryParams.status + '"]').removeClass(classes.notificationHidden);

})();

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname
  },
  name: 'currency',
  write: function(currency) {
    localStorage.setItem(this.name, currency);
  },
  read: function() {
    return localStorage.getItem(this.name);
  },
  destroy: function() {
    localStorage.removeItem(this.name);
  }
};

Currency.moneyFormats = {
  "NZD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} NZD"
  },
  "USD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} USD"
  },
  "EUR":{
    "money_format":"&euro;{{amount}}",
    "money_with_currency_format":"&euro;{{amount}} EUR"
  },
  "GBP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} GBP"
  },
  "CAD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} CAD"
  },
  "ALL":{
    "money_format":"Lek {{amount}}",
    "money_with_currency_format":"Lek {{amount}} ALL"
  },
  "DZD":{
    "money_format":"DA {{amount}}",
    "money_with_currency_format":"DA {{amount}} DZD"
  },
  "AOA":{
    "money_format":"Kz{{amount}}",
    "money_with_currency_format":"Kz{{amount}} AOA"
  },
  "ARS":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} ARS"
  },
  "AMD":{
    "money_format":"{{amount}} AMD",
    "money_with_currency_format":"{{amount}} AMD"
  },
  "AWG":{
    "money_format":"Afl{{amount}}",
    "money_with_currency_format":"Afl{{amount}} AWG"
  },
  "AUD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} AUD"
  },
  "BBD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} Bds"
  },
  "AZN":{
    "money_format":"m.{{amount}}",
    "money_with_currency_format":"m.{{amount}} AZN"
  },
  "BDT":{
    "money_format":"Tk {{amount}}",
    "money_with_currency_format":"Tk {{amount}} BDT"
  },
  "BSD":{
    "money_format":"BS${{amount}}",
    "money_with_currency_format":"BS${{amount}} BSD"
  },
  "BHD":{
    "money_format":"{{amount}}0 BD",
    "money_with_currency_format":"{{amount}}0 BHD"
  },
  "BYR":{
    "money_format":"Br {{amount}}",
    "money_with_currency_format":"Br {{amount}} BYR"
  },
  "BZD":{
    "money_format":"BZ${{amount}}",
    "money_with_currency_format":"BZ${{amount}} BZD"
  },
  "BTN":{
    "money_format":"Nu {{amount}}",
    "money_with_currency_format":"Nu {{amount}} BTN"
  },
  "BAM":{
    "money_format":"KM {{amount_with_comma_separator}}",
    "money_with_currency_format":"KM {{amount_with_comma_separator}} BAM"
  },
  "BRL":{
    "money_format":"R$ {{amount_with_comma_separator}}",
    "money_with_currency_format":"R$ {{amount_with_comma_separator}} BRL"
  },
  "BOB":{
    "money_format":"Bs{{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs{{amount_with_comma_separator}} BOB"
  },
  "BWP":{
    "money_format":"P{{amount}}",
    "money_with_currency_format":"P{{amount}} BWP"
  },
  "BND":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} BND"
  },
  "BGN":{
    "money_format":"{{amount}} лв",
    "money_with_currency_format":"{{amount}} лв BGN"
  },
  "MMK":{
    "money_format":"K{{amount}}",
    "money_with_currency_format":"K{{amount}} MMK"
  },
  "KHR":{
    "money_format":"KHR{{amount}}",
    "money_with_currency_format":"KHR{{amount}}"
  },
  "KYD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} KYD"
  },
  "XAF":{
    "money_format":"FCFA{{amount}}",
    "money_with_currency_format":"FCFA{{amount}} XAF"
  },
  "CLP":{
    "money_format":"${{amount_no_decimals}}",
    "money_with_currency_format":"${{amount_no_decimals}} CLP"
  },
  "CNY":{
    "money_format":"&#165;{{amount}}",
    "money_with_currency_format":"&#165;{{amount}} CNY"
  },
  "COP":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} COP"
  },
  "CRC":{
    "money_format":"&#8353; {{amount_with_comma_separator}}",
    "money_with_currency_format":"&#8353; {{amount_with_comma_separator}} CRC"
  },
  "HRK":{
    "money_format":"{{amount_with_comma_separator}} kn",
    "money_with_currency_format":"{{amount_with_comma_separator}} kn HRK"
  },
  "CZK":{
    "money_format":"{{amount_with_comma_separator}} K&#269;",
    "money_with_currency_format":"{{amount_with_comma_separator}} K&#269;"
  },
  "DKK":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"kr.{{amount_with_comma_separator}}"
  },
  "DOP":{
    "money_format":"RD$ {{amount}}",
    "money_with_currency_format":"RD$ {{amount}}"
  },
  "XCD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"EC${{amount}}"
  },
  "EGP":{
    "money_format":"LE {{amount}}",
    "money_with_currency_format":"LE {{amount}} EGP"
  },
  "ETB":{
    "money_format":"Br{{amount}}",
    "money_with_currency_format":"Br{{amount}} ETB"
  },
  "XPF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}} XPF",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} XPF"
  },
  "FJD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"FJ${{amount}}"
  },
  "GMD":{
    "money_format":"D {{amount}}",
    "money_with_currency_format":"D {{amount}} GMD"
  },
  "GHS":{
    "money_format":"GH&#8373;{{amount}}",
    "money_with_currency_format":"GH&#8373;{{amount}}"
  },
  "GTQ":{
    "money_format":"Q{{amount}}",
    "money_with_currency_format":"{{amount}} GTQ"
  },
  "GYD":{
    "money_format":"G${{amount}}",
    "money_with_currency_format":"${{amount}} GYD"
  },
  "GEL":{
    "money_format":"{{amount}} GEL",
    "money_with_currency_format":"{{amount}} GEL"
  },
  "HNL":{
    "money_format":"L {{amount}}",
    "money_with_currency_format":"L {{amount}} HNL"
  },
  "HKD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"HK${{amount}}"
  },
  "HUF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} Ft"
  },
  "ISK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr ISK"
  },
  "INR":{
    "money_format":"Rs. {{amount}}",
    "money_with_currency_format":"Rs. {{amount}}"
  },
  "IDR":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"Rp {{amount_with_comma_separator}}"
  },
  "ILS":{
    "money_format":"{{amount}} NIS",
    "money_with_currency_format":"{{amount}} NIS"
  },
  "JMD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} JMD"
  },
  "JPY":{
    "money_format":"&#165;{{amount_no_decimals}}",
    "money_with_currency_format":"&#165;{{amount_no_decimals}} JPY"
  },
  "JEP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} JEP"
  },
  "JOD":{
    "money_format":"{{amount}}0 JD",
    "money_with_currency_format":"{{amount}}0 JOD"
  },
  "KZT":{
    "money_format":"{{amount}} KZT",
    "money_with_currency_format":"{{amount}} KZT"
  },
  "KES":{
    "money_format":"KSh{{amount}}",
    "money_with_currency_format":"KSh{{amount}}"
  },
  "KWD":{
    "money_format":"{{amount}}0 KD",
    "money_with_currency_format":"{{amount}}0 KWD"
  },
  "KGS":{
    "money_format":"лв{{amount}}",
    "money_with_currency_format":"лв{{amount}}"
  },
  "LVL":{
    "money_format":"Ls {{amount}}",
    "money_with_currency_format":"Ls {{amount}} LVL"
  },
  "LBP":{
    "money_format":"L&pound;{{amount}}",
    "money_with_currency_format":"L&pound;{{amount}} LBP"
  },
  "LTL":{
    "money_format":"{{amount}} Lt",
    "money_with_currency_format":"{{amount}} Lt"
  },
  "MGA":{
    "money_format":"Ar {{amount}}",
    "money_with_currency_format":"Ar {{amount}} MGA"
  },
  "MKD":{
    "money_format":"ден {{amount}}",
    "money_with_currency_format":"ден {{amount}} MKD"
  },
  "MOP":{
    "money_format":"MOP${{amount}}",
    "money_with_currency_format":"MOP${{amount}}"
  },
  "MVR":{
    "money_format":"Rf{{amount}}",
    "money_with_currency_format":"Rf{{amount}} MRf"
  },
  "MXN":{
    "money_format":"$ {{amount}}",
    "money_with_currency_format":"$ {{amount}} MXN"
  },
  "MYR":{
    "money_format":"RM{{amount}} MYR",
    "money_with_currency_format":"RM{{amount}} MYR"
  },
  "MUR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} MUR"
  },
  "MDL":{
    "money_format":"{{amount}} MDL",
    "money_with_currency_format":"{{amount}} MDL"
  },
  "MAD":{
    "money_format":"{{amount}} dh",
    "money_with_currency_format":"Dh {{amount}} MAD"
  },
  "MNT":{
    "money_format":"{{amount_no_decimals}} &#8366",
    "money_with_currency_format":"{{amount_no_decimals}} MNT"
  },
  "MZN":{
    "money_format":"{{amount}} Mt",
    "money_with_currency_format":"Mt {{amount}} MZN"
  },
  "NAD":{
    "money_format":"N${{amount}}",
    "money_with_currency_format":"N${{amount}} NAD"
  },
  "NPR":{
    "money_format":"Rs{{amount}}",
    "money_with_currency_format":"Rs{{amount}} NPR"
  },
  "ANG":{
    "money_format":"&fnof;{{amount}}",
    "money_with_currency_format":"{{amount}} NA&fnof;"
  },
  "NIO":{
    "money_format":"C${{amount}}",
    "money_with_currency_format":"C${{amount}} NIO"
  },
  "NGN":{
    "money_format":"&#8358;{{amount}}",
    "money_with_currency_format":"&#8358;{{amount}} NGN"
  },
  "NOK":{
    "money_format":"kr {{amount_with_comma_separator}}",
    "money_with_currency_format":"kr {{amount_with_comma_separator}} NOK"
  },
  "OMR":{
    "money_format":"{{amount_with_comma_separator}} OMR",
    "money_with_currency_format":"{{amount_with_comma_separator}} OMR"
  },
  "PKR":{
    "money_format":"Rs.{{amount}}",
    "money_with_currency_format":"Rs.{{amount}} PKR"
  },
  "PGK":{
    "money_format":"K {{amount}}",
    "money_with_currency_format":"K {{amount}} PGK"
  },
  "PYG":{
    "money_format":"Gs. {{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"Gs. {{amount_no_decimals_with_comma_separator}} PYG"
  },
  "PEN":{
    "money_format":"S/. {{amount}}",
    "money_with_currency_format":"S/. {{amount}} PEN"
  },
  "PHP":{
    "money_format":"&#8369;{{amount}}",
    "money_with_currency_format":"&#8369;{{amount}} PHP"
  },
  "PLN":{
    "money_format":"{{amount_with_comma_separator}} zl",
    "money_with_currency_format":"{{amount_with_comma_separator}} zl PLN"
  },
  "QAR":{
    "money_format":"QAR {{amount_with_comma_separator}}",
    "money_with_currency_format":"QAR {{amount_with_comma_separator}}"
  },
  "RON":{
    "money_format":"{{amount_with_comma_separator}} lei",
    "money_with_currency_format":"{{amount_with_comma_separator}} lei RON"
  },
  "RUB":{
    "money_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    "money_with_currency_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
  },
  "RWF":{
    "money_format":"{{amount_no_decimals}} RF",
    "money_with_currency_format":"{{amount_no_decimals}} RWF"
  },
  "WST":{
    "money_format":"WS$ {{amount}}",
    "money_with_currency_format":"WS$ {{amount}} WST"
  },
  "SAR":{
    "money_format":"{{amount}} SR",
    "money_with_currency_format":"{{amount}} SAR"
  },
  "STD":{
    "money_format":"Db {{amount}}",
    "money_with_currency_format":"Db {{amount}} STD"
  },
  "RSD":{
    "money_format":"{{amount}} RSD",
    "money_with_currency_format":"{{amount}} RSD"
  },
  "SCR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} SCR"
  },
  "SGD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} SGD"
  },
  "SYP":{
    "money_format":"S&pound;{{amount}}",
    "money_with_currency_format":"S&pound;{{amount}} SYP"
  },
  "ZAR":{
    "money_format":"R {{amount}}",
    "money_with_currency_format":"R {{amount}} ZAR"
  },
  "KRW":{
    "money_format":"&#8361;{{amount_no_decimals}}",
    "money_with_currency_format":"&#8361;{{amount_no_decimals}} KRW"
  },
  "LKR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} LKR"
  },
  "SEK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr SEK"
  },
  "CHF":{
    "money_format":"SFr. {{amount}}",
    "money_with_currency_format":"SFr. {{amount}} CHF"
  },
  "TWD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TWD"
  },
  "THB":{
    "money_format":"{{amount}} &#xe3f;",
    "money_with_currency_format":"{{amount}} &#xe3f; THB"
  },
  "TZS":{
    "money_format":"{{amount}} TZS",
    "money_with_currency_format":"{{amount}} TZS"
  },
  "TTD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TTD"
  },
  "TND":{
    "money_format":"{{amount}}",
    "money_with_currency_format":"{{amount}} DT"
  },
  "TRY":{
    "money_format":"{{amount}}TL",
    "money_with_currency_format":"{{amount}}TL"
  },
  "UGX":{
    "money_format":"Ush {{amount_no_decimals}}",
    "money_with_currency_format":"Ush {{amount_no_decimals}} UGX"
  },
  "UAH":{
    "money_format":"₴{{amount}}",
    "money_with_currency_format":"₴{{amount}} UAH"
  },
  "AED":{
    "money_format":"Dhs. {{amount}}",
    "money_with_currency_format":"Dhs. {{amount}} AED"
  },
  "UYU":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} UYU"
  },
  "VUV":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}}VT"
  },
  "VEF":{
    "money_format":"Bs. {{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs. {{amount_with_comma_separator}} VEF"
  },
  "VND":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}&#8363;",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} VND"
  },
  "XBT":{
    "money_format":"{{amount_no_decimals}} BTC",
    "money_with_currency_format":"{{amount_no_decimals}} BTC"
  },
  "XOF":{
    "money_format":"CFA{{amount}}",
    "money_with_currency_format":"CFA{{amount}} XOF"
  },
  "ZMW":{
    "money_format":"K{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"ZMW{{amount_no_decimals_with_comma_separator}}"
  }
};

Currency.formatMoney = function(cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function(oldCurrency, newCurrency, selector, format) {
  if (newCurrency === undefined) {
    return;
  }

  $(selector || 'span.money').each(function() {
    // If the amount has already been converted, we leave it alone.
    if ($(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if ($(this).attr('data-currency-'+newCurrency)) {
      $(this).html($(this).attr('data-currency-'+newCurrency));
    }
    else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
      var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10)*100, oldCurrency, newCurrency);
      }
      else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10)/10, oldCurrency, newCurrency);
      }
      else {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
      }
      var newFormattedAmount = Currency.formatMoney(cents, newFormat);
      $(this).html(newFormattedAmount);
      $(this).attr('data-currency-'+newCurrency, newFormattedAmount);
    }
    // We record the new currency locally.
    $(this).attr('data-currency', newCurrency);
  });
  this.currentFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
};

/*============================================================================
  Scroll to utility
==============================================================================*/
window.theme = window.theme || {};

theme.scrollTo = (function() {

  var options = {

    scrollTo: {
      duration: 700,
      interrupt: !isMobile.apple.device, // Don't allow interupt on iOS
      offset: -150
    }

  }

  function init() {

    $('a[href^="#"]').click(function(e) {
      e.preventDefault();
      $(window).stop(true).scrollTo(this.hash, options.scrollTo);
    });

    if (document.location.search && theme.utils.getQueryParams().scrollto) {
      $(window).stop(true).scrollTo('#' + theme.utils.getQueryParams().scrollto, options.scrollTo);
      history.replaceState(null, '', theme.utils.updateQueryStringParameter('scrollto', null));
    }

  }


  init();

  return;

})();
/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.ProductGridItem = (function() {
  var cache = {};

  var selectors = {
    orderForm: '.product-grid-item__order-form',
    orderSubmitButton: '.product-grid-item__order-submit',
    productJson: '[data-product-json]',
    productMetafieldsJson: '[data-product-metafields-json]',
    productVariantInventoryJson: '[data-product-variant-inventory-json]',
    swatch: '.product-grid-item__available-colours span',
    gridItemLink: '.product-grid-item a'
  };

  function ProductGridItem(container) {
    this.$container = $(container);

    if (!this.$container.length) {
      return;
    }

    this._cacheSelectors();

    this.productSingleObject = cache.$productJson.length ? JSON.parse(cache.$productJson.html()) : {};
    this.productSingleObject.metafields = cache.$productMetafieldsJson.length ? JSON.parse(cache.$productMetafieldsJson.html()) : {};

    var self = this;

    if (cache.$productVariantInventoryJson.length) {
      var productVariantInventoryJson = cache.$productVariantInventoryJson.length ? JSON.parse(cache.$productVariantInventoryJson.html()) : {};

      this.productSingleObject.variants.forEach(function(variant, index) {
        var inventoryObject = _.find(productVariantInventoryJson, ['id', variant.id]);
        self.productSingleObject.variants[index] = _.merge(self.productSingleObject.variants[index], inventoryObject);
      });
    }

    this.$orderForms = $(selectors.orderForm, this.$container);
    this.$orderSubmitButton = $(selectors.orderSubmitButton, this.$container);

    $(document).on('click', selectors.swatch, this._gotToSwatchProductPage);
    if (!this.$orderForms.length || !this.$orderSubmitButton.length) {
      return false;
    }

    this._bindSubmitButton();
    this._initQuantitySelectors();


  }

  ProductGridItem.prototype = $.extend({}, ProductGridItem.prototype, {
    _bindSubmitButton: function() {
      var self = this;

      // Submit all forms
      this.$orderSubmitButton.on('click.product-grid-item', function() {
        self.$orderForms.each(function() {
          $(this).submit();
        });
      });
    },

    _gotToSwatchProductPage: function(event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = "/products/" + event.target.dataset.handle;
    },

    _cacheSelectors: function() {
      cache = {
        $productJson: $(selectors.productJson, this.$container),
        $productMetafieldsJson: $(selectors.productMetafieldsJson, this.$container),
        $productVariantInventoryJson: $(selectors.productVariantInventoryJson, this.$container),
      };
    },

    _initQuantitySelectors: function() {
      var self = this;

      this.$orderForms.each(function() {
        var $form = $(this);
        var varaintId = $form.data('varaintId');
        var variant = _.find(self.productSingleObject.variants, ['id', varaintId]);
        var $quantitySelector = $('input[type="number"]', $form);
        $quantitySelector.attr('max', variant.inventory_quantity);
        theme.QuantitySelector.init($quantitySelector);
      });
    }
  });

  return ProductGridItem;

})();

theme.productGridItems = (function() {
  var selectors = {
    productGridItem: '.product-grid-item'
  };

  var $productGridItems = $(selectors.productGridItem);

  $productGridItems.each(function(){
    new theme.ProductGridItem(this);
  });

})();

window.theme = window.theme || {};

theme.current.selected = theme.current.selected || [];

theme.SelectedVariantCache = (function() {

  var defaults = {
    quantity: 1
  };

  function SelectedVariantCache(variantId) {

    if (!variantId) {
      return false;
    }

    this.id = variantId;
    this.quantity = defaults.quantity;

    this.quantitySelectors = [];

    this._restore();
    theme.current.selected.push(this);

    return this;

  }

  SelectedVariantCache.prototype = _.extend({}, SelectedVariantCache.prototype, {

    add: function() {

      this.quantity += 1;
      this._save();
      this._updateQuantitySelectors();

    },

    subtract: function() {

      this.quantity -= 1;
      this._save();
      this._updateQuantitySelectors();

    },

    set: function(value) {

      if (this.quantity == value) { return };

      this.quantity = value;
      this._save();
      this._updateQuantitySelectors();

    },

    addQuantitySelector: function(quantitySelector) {

      var self = this;

      $(quantitySelector.inputEl).on('valueUpdated', function(event, value) {
        self.set(value);
      })

      this.quantitySelectors.push(quantitySelector);
      this._updateQuantitySelectors()
    },

    _updateQuantitySelectors: function() {

      var self = this;
      _.each(this.quantitySelectors, function(quantitySelector) {
        quantitySelector.set(self.quantity);
      });

    },

    _save: function() {

      var dataJSON,
          data,
          variantIndex,
          variantData;

      dataJSON = sessionStorage.getItem('selected-variant-cache');
      data = (dataJSON ? JSON.parse(dataJSON) : []);

      variantIndex = _.findIndex(data, {'id': this.id });

      variantData = {
        id: this.id,
        quantity: this.quantity,
      };

      if (variantIndex > -1) {
        data[variantIndex] = variantData;
      } else {
        data.push(variantData);
      }

      sessionStorage.setItem('selected-variant-cache', JSON.stringify(data));

    },

    _restore: function() {

      var dataJSON,
          data,
          variantIndex,
          variantData;

      dataJSON = sessionStorage.getItem('selected-variant-cache');
      data = (dataJSON ? JSON.parse(dataJSON) : []);

      variantData = _.find(data, {'id': this.id });

      if (variantData) {
        this.set(variantData.quantity);
      }

    }

  });

  return SelectedVariantCache;
})();


/*================ Modules ================*/
window.theme = window.theme || {};

theme.AjaxCart = (function() {
  var selectors = {
    addToCartBtn: '[type="submit"]',
    addToCartForm: 'form[action="/cart/add"]',
    cartCount: '.site-header__cart',
    cartToggle: '.cart__toggle',
    cartDrawer: '.cart-drawer',
    cartDrawerOpen: '.cart-drawer--open',
    cartDrawerTabs: '.cart-drawer__tabs',
    noGiftSelectedMessage: '.cart-drawer__free-gift-message',
    cartDrawerClose: '.cart-drawer .js-drawer-close',
    noGiftItemSelectedMessage: '.cart-drawer__free-gift-message--gift-items',
    checkoutButtonMask: '.cart-drawer__checkout-button-mask'
  };

  var settings = {
    // 'aboveForm' for top of add to cart form,
    // 'belowForm' for below the add to cart form,
    // 'nextButton' for next to add to cart button and
    // 'afterBody' for after the main body content (used for fixed notifications).
    feedbackPosition: 'afterBody'
  };

  var options = {
    requestBodyClass: 'cart-loading',
    moneyFormat: window.shop.moneyFormat,
    moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
    weightUnit: 'kg', // g, kg, oz, lb
    weightPrecision: 0,
    tinybindModels: {
      'customer': window.shop.customer,
      'wishlistProducts': window.shop.wishlistProducts,
      'wishlistLoading': window.shop.wishlistLoading
    },
    errorHandling: {
      cartError: function() {
        console.log('error')
        $('.cart-loader.loading').removeClass('loading');
      }
    }
  };

  var cache = {
    previousCartItems: [],
    updatedItems: []
  };

  function init() {
    if (!$(selectors.cartDrawer).length) {
      return;
    }
    var self = this;

    var cart = shop.cart;

    var displayQuantity = 0;
    var _ref = cart.items;

    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      item = _ref[_i];

      if (
        !item.properties ||
        (item.properties && typeof item.properties._hidden == 'undefined')
      ) {
        displayQuantity += item.quantity;
      }

    }

    cart.item_count_display = displayQuantity;

    var $tabsGroup = $(selectors.cartDrawerTabs);
    $.each($tabsGroup, function(index, tabsGroup) {
      window.theme.tabsGroups[tabsGroup] = new theme.TabsGroup(tabsGroup, {
        breakpoint: 0
      });
    });

    $(document).on('click', '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-update-id], [data-cart-remove]', function(evt){
      var $this = $(this);
      var progressElementSelector = $this.data('progress-element');
      var $progressElement = progressElementSelector ? $(progressElementSelector) : $this;
      if (!$this.is('.disabled')) {
        if ($progressElement.length) {
          $progressElement.addClass('cart-loader loading');
        }
      } else {
        evt.preventDefault();
        evt.stopPropagation();

        $progressElement.addClass('error');
        window.setTimeout(function(){
          $progressElement.removeClass('error');
        }, 1500);

        var highlightElements = $this.data('enable-requirements');
        if (highlightElements) {
          theme.utils.flash(highlightElements);
        }
      }
      initAccordion();
    });


    $(document).on('click', '[data-cart-remove-custom]', function(e){
      e.preventDefault();
      var el = $(this);
      var cartItems = CartJS.cart.items;
      var dataProp = el.parent().parent().attr('data-prodbundle');
      var dataLine = parseInt( el.parent().parent().attr('data-prod-id') );

      if ( dataProp ) {
        var upd = {};
        for (let i = 0; i < cartItems.length; i++) {
          var el = cartItems[i];
          if ( el.properties._optionGroup == dataProp ){
            upd[el.id] = el.quantity - 1
          }
        }
        CartJS.updateItemQuantitiesById(upd);

      } else {
        CartJS.removeItem(dataLine + 1);

      }
      let submitBtn = $('.template-product-gift-bundle .js__submit_bundle');
      let currentId = $('.original_product_bundle [data-name="id"]').val();
      if($(`#cart-drawer-item-${currentId}`).length>0){
        submitBtn.addClass('hide-btn');
        $('.added-btn').removeClass('hide-btn');
      }else{
        submitBtn.removeClass('hide-btn');
        $('.added-btn').addClass('hide-btn');
      }
    });

    $(document).on('change', '#mini_cart_quantity_selector', function(e){
      var index = e.target.querySelector("[value='"+e.target.value+"']").getAttribute("data-index")
      var line_number = parseInt(index);
      var quantity = parseInt(e.target.value);
      CartJS.updateItem(line_number, quantity);
    });


    $(document).on('click', '[data-opens-cart-drawer]', function(evt){
      $('body').addClass('cart-loading--opens-drawer');
      console.log('if statment 2');

    });

    $(document).on('input', '.bundle-gift-card-note', function(e){
      $(this).closest('.cart_gift_el_wrap').find('.js-character-count').text($(this).val().length);
    });

    $(document).on('input', '#gift-card-note', function(e){
      $(this).closest('.gift-card-container-normal').find('.js-character-count').text($(this).val().length);
    });

    // add / remove free gift in bundle
    $(document).on('click', '[data-add-gift-in-bundle]', function(e){
      e.preventDefault();
      let self = $(this);
      let id = parseInt( self.attr('data-variant-id') );
      let type = self.attr('data-type');
      let title = self.attr('data-title');
      let note = self.parents('.cart_gift_el_wrap').find('.bundle-gift-card-note').val();
      let prop = {};
      prop['_optionGroup'] = self.attr('data-props');
      prop['_hidden'] = true;
      prop['_cart_note'] = note;
      prop['_type'] = type;
      if(type=="card"){
        prop['_is_gift_card'] = true;
      }
      if(type=="wrapping"){
        prop['_is_gift_wrapping'] = true;
      }

      prop['Bundle'] = self.attr('data-props')

      if ( this.classList.contains('gone') ) {
        self.removeClass('gone');
        let cartItems = CartJS.cart.items;
        for (let i = 0; i < cartItems.length; i++) {
          if ( cartItems[i].id == id && cartItems[i].properties._optionGroup == self.attr('data-props') ) {
            console.log('removing', i);
            CartJS.removeItem( i + 1);
          }
        }
        removeGiftBundleProperty(self.attr('data-props'), title)
        $('.item-add-bundle.inactive').removeClass('inactive');
      } else {
        self.addClass('gone');
        CartJS.addItem(id, 1, prop, {'success': function(data) { addGiftBundleProperty(data, self.attr('data-props'), title, "1") }});
        self.parents('.gift-item').siblings('.gift-item').find('.item-add-bundle').addClass('inactive');
        iziToast.show({
          message: 'Gift item added to bundle',
          heme: 'light',
          position: 'bottomCenter'
        });
      }

    });


    initDrawer();


    tippy('.cart-drawer', {
      target: '.cart-drawer-item__remove--button, .cart-drawer__close',
      theme: 'light',
      placement: 'left',
      animation: 'shift-away',
      arrow: true,
      offset: 0,
      distance: 5,
      trigger: 'mouseenter',
      lazy: false,
      onShow: function(instance) {
        if (isMobile.any) {
          return false;
        }
      }
    });

    CartJS.init(window.shop.cart, options);

    $('#cart-drawer-note, #cart-note').on('blur', function() {
      var note = $(this).val();
      if (note) {
        CartJS.setNote(note);
      } else {
        CartJS.setNote('');
      }
    });

    $('.cart-drawer__submit').click(function(){
      $(document.body).addClass('checkout-activated');
    });

    $(document).on('wishlistLoaded', function(event) {
      enableWishlistLoading();
      getFullProductData(event);
    });

    $(document).on('click', '[data-move-to-cart]', function(event){
      let variantId = event.currentTarget.dataset.moveToCart;

      let product = findMatchingWishlistProduct(variantId);
      if (!product){
        console.log('unable to move to cart');
        return;
      }
      enableItemLoading(event);
      moveToCart(product,removeFromWishlist,event);
    });

    $(document).on('change', '[data-update-quantity]', function(event){
      let lineNumber = event.currentTarget.dataset.lineNumber;
      let quantity = event.currentTarget.options[event.currentTarget.selectedIndex].value;
      
      let validQuantity = event.currentTarget.dataset.quantity;
      let validIndex = 0;
      Array.from(event.currentTarget.options).forEach(function(item,index){
        if (item.value == validQuantity){
          validIndex = index;
        }
      });
      if (!lineNumber || !quantity){
        console.log('unable to update quantity');
        return;
      }
      enableItemLoading(event);
      updateItemQuantity(parseInt(lineNumber),parseInt(quantity),event,validIndex);
    });
    

    $(document).on('click', '[data-remove-from-wishlist]', function(event){
      let variantId = event.currentTarget.dataset.removeFromWishlist;

      let product = findMatchingWishlistProduct(variantId);
      if (!product){
        console.log('unable to move to cart');
        return;
      }
      enableItemLoading(event);
      removeFromWishlist(product,event);
    });

    $(document).on('click', '[data-move-to-wishlist]', function(event){
      let variantId = event.currentTarget.dataset.moveToWishlist;
      let index = event.currentTarget.dataset.index;

      let product = findMatchingShopifyProduct(variantId);
      if (!product || !index){
        console.log('unable to move to wishllist');
        return;
      }
      enableItemLoading(event);
      moveToWishlist(product,index,addToWishlist,event);
    });

    function enableItemLoading(event){
      if (!event){
        return
      }
      let item = event.currentTarget.closest('.cart-drawer-item');
      if (item){
        item.classList.add('loading');
      }
    }

    function disableItemLoading(event){
      if (!event){
        return
      }
      let item = event.currentTarget.closest('.cart-drawer-item');
      if (item){
        item.classList.remove('loading');
      }
    }

    function findMatchingWishlistProduct(variantId){
      if (!variantId){
        console.log('invalid variantId: ' + variantId);
        return;
      }

      let data = window.shop.wishlistProducts.find(function(item){
        if (item.selected_variant_id.toString() == variantId){
          return item;
        }
      })

      if (!data){
        console.log('invalid variantId: ' + variantId);
        return;
      }

      let product = {
       epi: parseInt(variantId), // variant id 
       empi: parseInt(data.id),  // Master product id / Product Id 
       du: window.location.host + data.url // cannonical product url
      };

      return product; 
    }

    function findMatchingShopifyProduct(variantId){
      if (!variantId){
        console.log('invalid variantId: ' + variantId);
        return;
      }

      let data = CartJS.cart.items.find(function(item){
        if (item.variant_id.toString() == variantId){
          return item;
        }
      })

      if (!data){
        console.log('invalid variantId: ' + variantId);
        return;
      }

      let product = {
       epi: parseInt(variantId), // variant id 
       empi: parseInt(data.product_id),  // Master product id / Product Id 
       du: 'https://' + window.location.host + data.url // cannonical product url
      };

      return product; 
    }

    function getFullProductData(event){
      let query = '';
      let wishlistProducts = event.detail.products;
      
      if (!event.detail.products){
        console.log('unable to load wishlist products');
        return;
      }

      wishlistProducts.forEach(function(wishlistProduct){
        query = query + 'id:' + wishlistProduct.empi + ' OR '
      });

      fetch(`/search?view=data&q='` + query)
      .then(res => res.text())
      .then(data => {
        var shopifyProducts = JSON.parse(data);

        resetWishlistList();
        mergeProductsData(shopifyProducts,wishlistProducts);
        disableWishlistLoading();
      })
      .catch(function(error) {
        console.log(error);
      });
    }

    function moveToWishlist(product,index,callback,event){
      CartJS.removeItem(parseInt(index), {
        "success": function(data, textStatus, jqXHR) {
          callback(product,event);
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log('Error: ' + errorThrown + '!');
          iziToast.error({
            title: jqXHR.responseJSON.description,
            position: 'bottomCenter',
            theme: 'light',
          });
          disableItemLoading(event);
        }
      });
    }

    function moveToCart(product,callback,event){
      CartJS.addItem(product.epi,1,{}, {
        "success": function(data, textStatus, jqXHR) {
          callback(product,event);
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log('Error: ' + errorThrown + '!');
          iziToast.error({
            title: jqXHR.responseJSON.description,
            position: 'bottomCenter',
            theme: 'light',
          });
          disableItemLoading(event);
        }
      });
    }


    $(document).on('cart.requestComplete', function(event, cart) {
      const orderTotal = cart.original_total_price; // Assuming the total price is in cents
      const price_general = slate.Currency.formatMoney(general_shipping_value, shop.moneyFormat);

      if (orderTotal <= free_shipping_threshold) {
        $('.shipping-value').text(price_general);
      } else {
        $('.shipping-value').text('FREE');
      }
      console.info('shipping check');
    });

    function updateItemQuantity(lineNumber,quantity,event,index){
      CartJS.updateItem(lineNumber, quantity, {}, {
        "success": function(data, textStatus, jqXHR) {
          console.log('updated');
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log('Error: ' + errorThrown + '!');
          iziToast.error({
            title: 'Unable to update quantity',
            position: 'bottomCenter',
            theme: 'light',
          });
          event.currentTarget.selectedIndex = index;
          disableItemLoading(event);
        }
      });
    }

    function removeFromWishlist(product,event){
      document.dispatchEvent(new CustomEvent('removeWishlistItem', {detail: product}));
      setTimeout(function(event){
        disableItemLoading(event);
      },1000);
    }

    function addToWishlist(product,event){
      document.dispatchEvent(new CustomEvent('addWishlistItem', {detail: product}));
      setTimeout(function(event){
        disableItemLoading(event);
      },1000);
    }

    function enableWishlistLoading(){
      // must empty arrays with method and not = as = wont update tinybind
      window.shop.wishlistLoading.splice(0,window.shop.wishlistLoading.length);
    }

    function disableWishlistLoading(){
      window.shop.wishlistLoading.push({});
    }

    function mergeProductsData(shopifyProducts,wishlistProducts){
      
      wishlistProducts.forEach(function(wishlistProduct){
        let product = shopifyProducts.find(function(item){
          if (item.id == wishlistProduct.empi){
            return item;
          }
        });
        let newProduct = parseProductData(product,wishlistProduct);
        window.shop.wishlistProducts.push(newProduct);
      });
    }

    function resetWishlistList(){
      // must empty arrays with method and not = as = wont update tinybind
      window.shop.wishlistProducts.splice(0,window.shop.wishlistProducts.length);
    }

    function parseProductData(product,wishlistProduct){
      var parsedProduct = product;
      product.image = product.images[0];
      product.product_title = product.title;
      product.line_price = product.price;

      product.option = product.variants.find(function(item){
        if(item.id == wishlistProduct.epi){
          return item;
        }
      });
      
      product.option_name = product.options[0];
      product.selected_variant_id = wishlistProduct.epi;
      product.url = '/products/' + product.handle + '?variant=' + product.selected_variant_id;
      return parsedProduct;
    }


    $(document).on('cart.requestStarted', function(event, cart) {
      cache.previousCartItems = _.values(_.omit(cart.items, _.functions(cart.items)));

      if ('NProgress' in window) {
        NProgress.start();
      }
    });

    $(document).on('cart.requestComplete', function(event, cart) {
      if ('NProgress' in window) {
        NProgress.done();
      }

      $('.cart-loader.loading').removeClass('loading');

      cache.updatedItems = cart.updatedLineItems;

      if (cart.errors.length) {
        for (var i = cart.errors.length - 1; i >= 0; i--) {
          showFeedback('error', cart.errors[i].description);
        }
      }

      shop.cart = cart;

      if (theme.Favicon !== undefined) {

        if (cart.item_count_display > 0) {
          theme.Favicon.set(cart.item_count_display);
        } else {
          theme.Favicon.reset();
        }
      }

      var opensDrawer = $('body').is('.cart-loading--opens-drawer');

      if (opensDrawer !== undefined && opensDrawer) {
        if ((theme.cartQueue === undefined || theme.cartQueue.length == 0) && theme.cartQueueProcessing == false) {
          if (!theme.CartDrawer.drawerIsOpen) {
            $('body').removeClass('cart-loading--opens-drawer');
            theme.CartDrawer.open();
            console.log('opening cart drawer');
          }
        }
      }
    });


  }

  function removeGiftBundleProperty(bundle, property) {
    var itemIndex = CartJS.cart.items.findIndex(function(item) {
      return item.properties['_optionGroup'] == bundle && item.vendor == 'gift-bundles'
    });
    if(itemIndex > -1) {
      var item = CartJS.cart.items[itemIndex]
      var newProps = Object.assign(item.properties);
      delete newProps[property]
      CartJS.updateItem(itemIndex, item.quantity, newProps);
    }
  }

  function addGiftBundleProperty(cart, bundle, property, value) {
    var itemIndex = CartJS.cart.items.findIndex(function(item) {
      return item.properties['_optionGroup'] == bundle && item.vendor == 'gift-bundles'
    });
    if(itemIndex > -1) {
      var item = CartJS.cart.items[itemIndex]
      var newProps = Object.assign(item.properties, {
        [property]: value
      });
      CartJS.updateItem(itemIndex + 2, item.quantity, newProps);
    }
  }


  function initAccordion(){
    $('#CartDrawer [data-prodbundle], #CartPage [data-prodbundle]').off('click').on('click','.simple-accordion__title', function(){
      if ( this.classList.contains('active') ){
        $(this).removeClass('active').siblings('.content').removeClass('active');
      } else {
        $(this).addClass('active').siblings('.content').addClass('active');
      }
    });

    let cartItems = CartJS.cart.items;
    let count_collection_jewellery_in_products = 0;
    let count_collection_sweat_republic_in_products = 0;
    let count_items = CartJS.cart.items.length;
    let total_price = CartJS.cart.total_price/100;
    for (let item in cartItems) {
      if (parseInt(item) >= 0) {
        let response = $.get('/pages/product-collections/'+cartItems[item].handle, function(data) {
          let collections = JSON.parse($($.parseHTML(data)).find('#MainContent').find('#data-product-collections')[0].innerHTML)
          let collections_str = '|';
          for (collection of collections) {
            collections_str += collection.handle+'|';
          }
          if (collections_str.includes('augustine-jewellery'))
            count_collection_jewellery_in_products += 1;

          if (collections_str.includes('sweat-republic'))
            count_collection_sweat_republic_in_products += 1;

        }).always(function() {
          if (count_items-1 == item) {
          }
        });
      }
    }
  }

  function initDrawer() {
    $('#MainContent').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');

    theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
      onDrawerOpen: cartDrawerOpen,
    });
    $('#CartDrawer .js-drawer-close').on('click', function(event){
      theme.CartDrawer.close()
      console.log('this is click close');
    })
  }

  function getWishlistProducts() {
    window._swat.fetch(function (usersWishlist) {
      // call the global function to build wishlist grid items
      buildWishlistGridItems(usersWishlist);
    }, function (error) {
      console.log("There was an error while fetching the wishlist", error)
    });
  }

  function buildWishlistGridItems() {
    var productContainer = document.getElementById("product-container");
    productContainer.innerHTML = ''; // clear existing items

    for (var i = 0; i < window.shop.wishlistProducts.length; i++) {
      var product = wishlistProducts[i];
      var productInfo = document.createElement("div");
      var WishlstBtnAddToCart = "<button id='AddToCart-product' data-add-to-cart class='add-to-cart__mini-cart-wishlist'>Add to cart</button>"
      var Size = "<li class='cart-drawer-item__property'>SIZE: " + product.vi + "</li>"

      productInfo.innerHTML = "<div class='cart-drawer-item cart-drawer-item__wishlist'><div class='cart-drawer-item__image'><img src='" + product.iu + "' loading='lazy'></div><div class='cart-drawer-item__details'><div class='title-n-close'><span class='cart-drawer-item__title'>" + product.dt + "</span><button class='remove-from-mini-cart-wishlist'><sapn class='wishlist_delete'>&#x2715</sapn></button></div><div class='size-price__wrapper'><ul class='cart-drawer-item__properties'>" + Size + "</ul><div class='cart-drawer-item__price'>$" + product.pr + "</div></div><div class='add-to-cart__wishlist_tab'>" + WishlstBtnAddToCart + "</div></div>";
      productContainer.appendChild(productInfo);

      var removeButton = productInfo.getElementsByClassName("remove-from-mini-cart-wishlist")[0];
      removeButton.addEventListener("click", (function (product) {
        return function () {
          let wishlistProduct = {
            epi: product.epi,
            empi: product.empi,
            du: product.du
          }

          // Call the API to remove the product from the wishlist for the above "wishlistProduct."
          window._swat.removeFromWishList(wishlistProduct, function (response) {
            console.log("Product successfully removed from wishlist", response);
          }, function (error) {
            console.log("There was an error while removing the product from wishlist", error);
          });
        };
      })(product));

      $('.remove-from-mini-cart-wishlist').each(function () {
        $(this).on('click', function () {
          var $this = $(this);
          var $parent = $this.closest('.cart-drawer-item.cart-drawer-item__wishlist');
          $parent.remove();
        });
      });
    }

    console.log("Successfully fetched the wishlist", wishlistProducts);
  }

// Replace the contents of the cart tab with the new markup
  function addToCartFromWishlist() {
    if (window.shop.wishlistProducts.length > 0) {  
      var addToCartButtons = document.querySelectorAll(".add-to-cart__mini-cart-wishlist");
      for (var i = 0; i < wishlistProducts.length; i++) {
        var product = wishlistProducts[i];  
        (function(product) {
          addToCartButtons[i].addEventListener('click', function(e) {
            e.preventDefault();
            var $this = $(this);
            var $parent = $this.closest('.cart-drawer-item__wishlist');
            $parent.remove();
  
            var productToAdd = {
              epi: product.epi,
              empi: product.empi,
              du: product.du,
            }
  
            fetch('/cart/add.js', {
              method: 'POST',
              body: JSON.stringify({id: product.epi, quantity: 1}),
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(response => response.json())
              .then(data => {
                console.log('Product successfully added to cart', data);
                if (typeof CartJS !== 'undefined' && typeof CartJS.update === 'function') {
                  CartJS.update(true);
                } else {
                  console.warn('CartJS is not available or does not have an update method');
                }
              })
              .catch(error => {
                console.error('Error adding product to cart', error);
              });

              window._swat.removeFromWishList(productToAdd, function(response) {
                console.log("Product successfully removed from wishlist", response);
            }, function(error) {
                console.log("There was an error while removing the product from wishlist", error);
            });
            
          });
        })(product);
      }
    }
  }
  function cartDrawerOpen() {
    document.dispatchEvent(new CustomEvent('getWishlist'));

    // close accordion on mobile
    if (isMobile.any){
      let accordionButtons = document.querySelectorAll('.gift-item-selector__header.active');
      accordionButtons.forEach(function(accordionButton){
        if (accordionButton){
          accordionButton.click();
        }
      })
      
    }
  }

  function getCartItems() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        console.log('Cart items:', data.items);
        data.items.forEach(item => {
          console.log('Item ID:', item.id);
        });
        return data.items;
      })
      .catch(error => {
        console.error('Error getting cart items', error);
        return [];
      });
  }
  
  function addToWishlist() {
    getCartItems().then(cartItems => {
      var addToWishlistButtons = document.querySelectorAll(".add-to-wishlist-button");
      addToWishlistButtons.forEach((button, index) => {
        button.addEventListener("click", function(e) {
          e.preventDefault();
          var $this = $(this);
          var $parent = $this.closest('.cart-drawer-item');
          $parent.remove();
  
          var item = cartItems[index];
          var productId = item.id;
          var productVariantId = item.variant_id;
          var productUrl = item.url;
  
          console.log('Adding product to wishlist:', item);
  
          var productToAdd = {
            epi: productId,
            empi: productVariantId,
            du: productUrl,
          };
          console.log('before addToWishList');
          console.log('productToAdd', productToAdd);
          
          window._swat.addToWishList(productToAdd, function(response) {
            console.log('Product added to wishlist:', response);
            console.log('after addToWishList', response );
          }, function(error) {
            console.error('Error adding product to wishlist:', error);
          });
          
        });
      });
    });
  }
  

  function cartDrawerClose() {
    console.log('this is cartDrawerClose');
  }

  function noGiftItemSelectedPopup(event) {
    $(selectors.noGiftItemSelectedMessage).removeClass('hide')
    $(selectors.checkoutButtonMask).addClass('inactive');
  }

  function showFeedback(status, response, $addToCartForm) {
    $('.ajax-cart-feedback').remove();
    var feedback = '<div class="ajax-cart-feedback ' + status + '">' + response + '</div>';

    if ($addToCartForm !== undefined && $addToCartForm.length > 0) {
      switch (settings.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'afterBody':
          $(document.body).append(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(selectors.addToCartBtn).after(feedback);
          break;
      }
    } else {
      iziToast.show({
        message: response,
        color: 'red',
        position: 'bottomCenter'
      });
    }

    var $feedbackElement = $('.ajax-cart-feedback');

    $feedbackElement.offset(); // redraw
    $feedbackElement.addClass('active');
    window.setTimeout(function(){
      $feedbackElement.removeClass('active');
    }, 6500);
  };

  return {
    init: init
  };
})();

theme.AjaxCart.init();

theme.cartQueue = [];
theme.cartQueueProcessing = false;
theme.processCartQueue = function() {
  // If there's something in the queue, process it
  if (theme.cartQueue.length) {
    theme.cartQueueProcessing = true;
    var request = theme.cartQueue.shift();
    var requestType = request.type || 'add';

    if (requestType == 'add') {
      CartJS.addItem(request.variant_id, request.quantity, request.properties, {
        "success": function(data, textStatus, jqXHR) {
          theme.processCartQueue();

        }

      });
    } else if (requestType == 'update') {
      CartJS.updateItem(line_number, quantity, properties = {}, options = {})
    }


    ShopifyAPI.addItem(request.variant_id, request.quantity, request.properties, ShopifyAPI.processQueue, requestType);
  }
  else {
    theme.cartQueueProcessing = false;
  }
};

// disable gifts
$(window).on('load', function(e){
  setTimeout(function(){
    $('.gift-item-selector__wraps').each(function(){
      $(this).find('.item-add-bundle.gone').parents('.gift-item').siblings('.gift-item').find('.item-add-bundle').addClass('inactive');
    });
  },3000);
});

window.theme = window.theme || {};

theme.Header = (function() {

  var selectors = {
    body: 'body',
    navigation: '.site-nav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link, .site-nav__grandchild-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavChildLinkWithChildren: '.site-nav__child-link--parent',
  };

  var config = {
    hoverClass: 'site-nav--hover',
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    submenuVisibleOnHover: true,
    firstParentClickNavigates: true, // Overridden for mobile devices
    secondParentClickClosesSubmenu: false, // Relies on previous option being disabled for non-mobile devices
  };

  var $container;
  var cache = {
    isMobile: isMobile.any
  };

  function init(container) {
    $container = this.$container = $(container);
    cacheSelectors();

    if (!cache.$dropdownParents.length) {
      return;
    }

    if (config.submenuVisibleOnHover && cache.isMobile == false) {
      cache.$dropdownParents.on('mouseenter.siteNav', function(evt) {
        var $el = $(this);
        showDropdown($el);
      });

      cache.$dropdownParents.on('mouseleave.siteNav', function(evt) {
        var $el = $(this);
        hideDropdown($el);
      });
    }

    if (cache.$nav.is('[data-disable-parent-navigation]')) {
      // Override standard click events
      cache.$childLinksWithChildren.on('click.siteNav', function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      });
      config.firstParentClickNavigates = false;
      config.secondParentClickClosesSubmenu = true;
    }

    cache.$dropdownParents.on('click.siteNav', function(evt) {
      var $el = $(this);

      if (config.firstParentClickNavigates && cache.isMobile == false) {
        return;
      }

      if (config.secondParentClickClosesSubmenu || !config.secondParentClickClosesSubmenu && !$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      if (config.secondParentClickClosesSubmenu && $el.hasClass(config.activeClass)) {
        hideDropdown($el);
        return;
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = _.assignIn({}, cache, {
      $nav: $(selectors.navigation, $container),
      $topLevel: $(selectors.siteNavLinkMain, $container),
      $dropdownParents: $(selectors.navigation, $container).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks, $container),
      $activeDropdown: $(selectors.siteNavActiveDropdown, $container),
      $childLinksWithChildren: $(selectors.siteNavChildLinkWithChildren, $container),
    });
  }

  function showDropdown($el) {
    $el.addClass(config.hoverClass);
    var dropdownActivationDelay = cache.isMobile ? 0 : 150;

    setTimeout(function() {
      if ($el.hasClass(config.hoverClass) || cache.isMobile) {
        $el.addClass(config.activeClass);

        // close open dropdowns
        if (cache.$activeDropdown.length) {
          hideDropdown(cache.$activeDropdown);
        }

        cache.$activeDropdown = $el;

        // set expanded on open dropdown
        $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

        $(window).on('keyup.siteNav', function(evt) {
          if (evt.keyCode === 27) {
            hideDropdown($el);
          }
        });

        $(selectors.body).on('click.siteNav', function() {
          hideDropdown($el);
        });
      } else {
        hideDropdown($el);
      }
    }, dropdownActivationDelay);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);
    $el.removeClass(config.hoverClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$dropdownParents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu',
    closeButton: '.mobile-nav-wrapper.js-menu--is-open .close-button'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = theme.settings.mediaQuery.small;

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    $(classes.closeButton).on('click', toggleMobileNav)
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContent'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var headerHeight = cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;

    cache.$mobileNavContainer
      .prepareTransition()
      .addClass(classes.navOpen);

    cache.$pageContainer.addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, 0, 0)',
      'padding-top': headerHeight + 'px'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNav
        .find('.' + classes.navLinkWrapper + ':first')
        .find('.' + classes.navLink),
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$pageContainer.removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(-100%, 0, 0)'
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {

    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav
        .prepareTransition()
        .addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu[0].scrollHeight;
    if (!target) {
      translateMenuHeight = $targetMenu.outerHeight();
    }

    var openNavClass = menuLevel > 2
      ? classes.thirdNavShowing
      : classes.subNavShowing;

    var newContainerHeight = translateMenuHeight + cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;
    cache.$mobileNavContainer
      .css('height', newContainerHeight + 'px')
      .removeClass(classes.thirdNavShowing)
      .addClass('is-transitioning')
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        if ($elementToFocus.length > 1) {
          slate.a11y.trapFocus({
            $container: $targetMenu,
            $elementToFocus: $elementToFocus,
            namespace: 'subNavFocus'
          });
        } else {
          slate.a11y.trapFocus({
            $container: cache.$sectionHeader,
            $elementToFocus: cache.$mobileNav
              .find('.' + classes.navLinkWrapper + ':first')
              .find('.' + classes.navLink),
            namespace: 'navFocus'
          });
        }

        cache.$mobileNavContainer.off('.subnavToggle');
        cache.$mobileNavContainer.removeClass('is-transitioning');
        isTransitioning = false;
      }
    );

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

/**
 * Free Gift Product
 * ------------------------------------------------------------------------------
 */

theme.GiftProduct = (function() {

  var selectors = {
    dataJsonContainer: '[data-free-gift-json]',
    addToCart: '.item-add-to-cart:not(.item-add-to-cart--added)',
    closeCharityModal: '.charity-dontation-modal .close-modal',
    charityModal: '.charity-dontation-modal',
    charityInfoIcon: '.gift-item .charity-info-icon',
    charityInfoTitleIcon: '.cart-drawer-item__title .charity-info-icon'
  };

  function GiftProduct(container) {
    console.log('GiftProduct')

    this.container = container;
    this.namespace = '.giftProduct';
    if (!this.container) {
      return;
    }

    this.data = this._getData();
    if (!this.data.length) {
      return;
    }

    this._bindCart();
    this._bindCartEventListener();
    this._addModalListeners();
  }

  GiftProduct.prototype = $.extend({}, GiftProduct.prototype, {

    _addGiftProductToCart: function(event) {
      var element = event.target;
      if(!element.dataset.length) element = element.parentElement
      this.cart.gift_loading = element.dataset.variantId;
      var freeGiftIndex = _.findIndex(this.data,
        function(el) {return el.variantId === element.dataset.variantId
      });
      var type = element.dataset.type;
      var charity = element.dataset.charity && element.dataset.charity == "true";
      if (this._cartIsEligible(this.cart, type)) {
        var props = {
          '_disable-line-item-edit': 'true',
          '_secret': this.data[freeGiftIndex].secret
        }
        if(charity) {
          props = {
            ...props,
            '_is_charity': 'true'
          }
        }
        if(type == "regular") {
          props = {
            ...props,
            '_is_regular_free_gift': 'true'
          }
        } else if (type == "luxury") {
          props = {
            ...props,
            '_is_luxury_free_gift': 'true'
          }
        }
        CartJS.addItem(this.data[freeGiftIndex].variantId, 1, props);
        iziToast.show({
          title: 'Gift Item added to cart',
          position: 'bottomCenter',
          theme: 'light',
        });
      } else {
        this.cart.gift_loading = null;
        iziToast.error({
          title: 'You can\'t add more gift products to your cart.',
          position: 'bottomCenter',
          theme: 'light',
        });
      }
    },
    _bindCart: function() {
      this.cart = CartJS.cart;
    },

    _addModalListeners: function() {
      $(selectors.closeCharityModal).on('click', function() { $(selectors.charityModal).toggleClass('open') });
      $(selectors.charityInfoIcon).on('click', function() { $(selectors.charityModal).toggleClass('open') });
      $(document).on('click', selectors.charityInfoTitleIcon, function() { $(selectors.charityModal).toggleClass('open') })
    },

    _removeLoadingState: function(event, cart) {
      cart.gift_loading = null
    },

    _bindCartEventListener: function() {
      $(document).on('cart.requestComplete' + this.namespace, this._removeLoadingState.bind(this));
      $(this.container.querySelectorAll(selectors.addToCart)).on('click', this._addGiftProductToCart.bind(this))
    },

    _cartIsEligible: function(cart, type) {
      var i = cart.items.length, item;
      const luxuryItems = cart.items.filter(item => item.properties && item.properties['_is_luxury_free_gift']);
      const luxuryItemsCount = luxuryItems.length;
      const regularItems = cart.items.filter(item => item.properties && item.properties['_is_regular_free_gift']);
      const regularItemsCount = regularItems.length;
      return (luxuryItemsCount + regularItemsCount) < 1;
    },

    _getData: function() {
      var dataJsonContainer = this.container.querySelectorAll(selectors.dataJsonContainer);
      if (!dataJsonContainer) {
        return
      }
      return _.map(dataJsonContainer, function(element) { return JSON.parse(element.innerHTML)});
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(document).off(this.namespace);
    }
  });

  return new GiftProduct(document.getElementById('gift-item-selector--free-gifts'));
})();

theme.GarmentBag = (function() {

  var selectors = {
    dataJsonContainer: '[data-free-gift-json]',
    addToCart: '.item-add-to-cart:not(.item-add-to-cart--added)',
  };

  function GarmentBag(container) {
    this.container = container;
    this.namespace = '.garmentBag';
    if (!this.container) {
      return;
    }

    this.data = this._getData();
    if (!this.data.length) {
      return;
    }

    this._bindCart();
    this._bindCartEventListener();
  }

  GarmentBag.prototype = $.extend({}, GarmentBag.prototype, {
    _addGarmentBagToCart: function(event) {
      var element = event.target;
      if(!element.dataset.length) element = element.parentElement
      this.cart.gift_loading = element.dataset.variantId;
      var garmentBagIndex = _.findIndex(this.data,
        function(el) { return el.variantId === element.dataset.variantId
      });
      var type = element.dataset.type;
      if (this._cartIsEligible(this.cart, type)) {
        var props = {
          _is_garment_bag: true
        }
        CartJS.addItem(this.data[garmentBagIndex].variantId, 1, props);
      } else {
        this.cart.gift_loading = null;
        iziToast.error({
          title: 'Error while adding.',
          position: 'bottomCenter',
          theme: 'light',
        });
      }
    },
    _bindCart: function() {
      this.cart = CartJS.cart;
    },

    _bindCartEventListener: function() {
      $(this.container.querySelectorAll(selectors.addToCart)).on('click', this._addGarmentBagToCart.bind(this))
    },

    _cartIsEligible: function(cart, type) {
      return true;
    },

    _getData: function() {
      var dataJsonContainer = this.container.querySelectorAll(selectors.dataJsonContainer);
      if (!dataJsonContainer) {
        return
      }
      return _.map(dataJsonContainer, function(element) { return JSON.parse(element.innerHTML)});
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(document).off(this.namespace);
    }
  });

  return new GarmentBag(document.getElementById('gift-item-selector--garment-bag'));
})();

/**
 * Gift Wrapping Product
 * ------------------------------------------------------------------------------
 */

theme.GiftWrapping = (function() {

  var selectors = {
    dataJsonContainer: '[data-free-gift-json]',
    addToCart: '.item-add-to-cart:not(.item-add-to-cart--added)',
  };

  function GiftWrapping(container) {
    this.container = container;
    this.namespace = '.giftWrapping';
    if (!this.container) {
      return;
    }

    this.data = this._getData();
    if (!this.data.length) {
      return;
    }

    this._bindCart();
    this._bindCartEventListener();
  }

  GiftWrapping.prototype = $.extend({}, GiftWrapping.prototype, {

    _addGiftWrappingToCart: function(event) {
      var element = event.target;
      if(!element.dataset.length) element = element.parentElement
      this.cart.gift_loading = element.dataset.variantId;
      var giftWrappingIndex = _.findIndex(this.data,
        function(el) { return el.variantId === element.dataset.variantId
      });
      var type = element.dataset.type;
      if (this._cartIsEligible(this.cart, type)) {
        var props = {
          '_disable-line-item-edit': 'true',
          '_secret': this.data[giftWrappingIndex].secret,
          '_is_gift_wrapping': 'true'
        }
        CartJS.addItem(this.data[giftWrappingIndex].variantId, 1, props);
      } else {
        this.cart.gift_loading = null;
        iziToast.error({
          title: 'First remove currently selected gift wrapping from your cart.',
          position: 'bottomCenter',
          theme: 'light',
        });
      }
    },
    _bindCart: function() {
      this.cart = CartJS.cart;
    },

    _bindCartEventListener: function() {
      $(this.container.querySelectorAll(selectors.addToCart)).on('click', this._addGiftWrappingToCart.bind(this))
    },

    _cartIsEligible: function(cart, type) {
      var currentWrappingCount =  _.filter(cart.items, function(item) {
        if( Object.keys(item.properties).indexOf('_is_gift_wrapping') > -1) return item
      }).length
      return currentWrappingCount < 1;
    },

    _getData: function() {
      var dataJsonContainer = this.container.querySelectorAll(selectors.dataJsonContainer);
      if (!dataJsonContainer) {
        return
      }
      return _.map(dataJsonContainer, function(element) { return JSON.parse(element.innerHTML)});
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(document).off(this.namespace);
    }
  });

  return new GiftWrapping(document.getElementById('gift-item-selector--gift-wrapping'));
})();

/**
 * Gift Wrapping Product
 * ------------------------------------------------------------------------------
 */

theme.GiftCard = (function() {

  var selectors = {
    dataJsonContainer: '[data-free-gift-json]',
    addToCart: '.item-add-to-cart:not(.item-add-to-cart--added)',
    messageField: '.bundle-gift-card-note',
    appendProductId: 'data-product-id-to-append',
    addMessageButton: '.save-message'
  };

  function GiftCard() {
    this.namespace = '.giftCards';

    this._bindCart();
    this._bindAddMessageListener();
  }

  GiftCard.prototype = $.extend({}, GiftCard.prototype, {

    _addMessageToCart: function(event) {
      console.log(123);
      let index = $(event.target).attr('data-prod-id-index');
      console.log(index);
      let parent = $(event.target).parent();
      let messageBox = parent.find(selectors.messageField);
      var message = messageBox.val();
      if(message) {
        var giftCardItem = this.cart.items[index];
        if(giftCardItem) {
          var newProps = Object.assign(giftCardItem.properties, {
            'Message': message
          });
          console.log('add');
          CartJS.updateItem(parseInt(index)+1, 1, newProps);
        }
        iziToast.success({
          title: 'Message added!',
          position: 'bottomCenter',
          theme: 'light',
        });
      } else {
        iziToast.error({
          title: 'Message cannot be empty',
          position: 'bottomCenter',
          theme: 'light',
        });
      }
    },

    _bindCart: function() {
      this.cart = CartJS.cart;
      this.cart.gift_loading = null;
    },

    _bindAddMessageListener: function() {
      $(document).on('click', selectors.addMessageButton, this._addMessageToCart.bind(this));
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(document).off(this.namespace);
    }
  });

  return new GiftCard();
})();




/*============================================================================
  Wishlist
  For Wishlist King App
==============================================================================*/
window.theme = window.theme || {};

theme.wishlist = (function() {

  var selectors = {
    addToWishlist: '.wishlist-add button',
  };

  var cache = {
    buttons: []
  };

  // Initialise and prepare buttons
  function init() {
    $(selectors.addToWishlist).on('click', addToWishlist)
  }

  function addToWishlist() {
      console.log('add');
  }


  return {
    init: init
  };

})();

window.theme = window.theme || {};

theme.ProductFilter = (function() {

  var selectors = {
    collection: '.collection',
    collectionTitle: '[data-collection-title]',
    collectionDescription: '[data-collection-description]',
    collectionGrid: '.collection-grid',
    collectionGridRow: '.collection-grid .row',
    collectionSection: '.template-collection',
    pageHeader: '.page-header',
    filterTitle: '.bc-sf-filter-block-title h3',
    filterOptionMenuItem: '.bc-sf-filter-option-block',
    filtersDesktop: '.js-filter',
    filteredProductsContainer: '#bc-sf-filter-products',
    collectionVendorsData: '#collection-vendors-data',
    productGridItem: '.product-grid-item',
    productGridItemAnchor: '.anchor',
  };

  var options = {
    displayCollectionDescription: true,
    animateHeaderHeight: false
  };

  var cache = {
    headerHeightCurrent: 0,
    headerHeightNew: 0,
    sort: false,
    $vendorSections: {},
    vendorProducts: {},
    vendorData: {},
    viewBound: false,
    bundleProducts: []
  };

  function init() {
    if ('BCSfFilter' in window) {
      window.bcsffilter = new BCSfFilter();
      window.bcsffilter.init();

      if (theme.current.template.name == 'collection' || theme.current.template.name == 'search') {
        window.bcsffilter.initFilter();
      }

      window.bcsffilter.initSearchBox();
    }
  }

  function toggleBackInStockModal(event) {
    if(!BIS) return
    event.preventDefault();
    event.stopPropagation();
    var prodHandle = $(this).data('handle');
    var productData = theme.current.collection.products.find(function(p) { return p.handle == prodHandle })

    BIS.popover = BIS.createPopover({
      productHandle: prodHandle,
      product: productData,
      button: {
        visible: false
      }
    })
    BIS.popover.toggle()
  }

  function getBundleProductData(handle) {
    return new Promise((res, rej) => {

    })
  }

  function getBundlesData(data, eventType) {

    const bundleHandles = theme.current.collection.products.map(prod => prod.bundle_products);
    const uniqueHandles = _.compact(_.uniq(_.flatten(bundleHandles)));
    if(!uniqueHandles.length) return;
    Promise.all(uniqueHandles.map(handle => {
      const cachedProduct = cache.bundleProducts.find(prod => prod.handle === handle);
      if(cachedProduct) return cachedProduct
      return theme.utils.getProductJSON(handle).catch(err => {
        return null
      })
    })).then(response => {
      const bundleProducts = _.compact(response.map(res => {
        try {
          const parsed = JSON.parse(res);
          return parsed
        } catch (error) {
          return res
        }
      }));
      cache.bundleProducts = bundleProducts
      for (let i = 0; i < theme.current.collection.products.length; i++) {
        const product = theme.current.collection.products[i];
        var total_bundle_price = 0;
        var bundle_products_jsons = [];
        if(product.bundle_products && product.bundle_products.length) {
          for (const bundle_product_handle of product.bundle_products) {
            var bundle_product_json = bundleProducts.find(prod => prod.handle === bundle_product_handle);
            if(bundle_product_json) {
              total_bundle_price = total_bundle_price + bundle_product_json.price
              bundle_products_jsons.push(bundle_product_json)
            }
          }
        }
        theme.current.collection.products[i].compare_at_price = total_bundle_price;
        theme.current.collection.products[i].price = total_bundle_price * 0.9;
        theme.current.collection.products[i].total_bundle_price = total_bundle_price;
        theme.current.collection.products[i].bundle_products_jsons = bundle_products_jsons;
  
      }
    })

  }

  function buildCollectionPage(data, eventType) {

    if (!$(selectors.collection).length) {
      return;
    }

    if (!cache.viewBound) {

      var $collectionSection = $(selectors.collectionSection);
 
	  if(!$collectionSection.length) $collectionSection = $(".template-search");
      if ($collectionSection.length) {
        tinybind.bind($collectionSection, {
          ...theme,
          methods: {
            toggleBackinStock: toggleBackInStockModal
          }
        });
        cache.viewBound = true;
      }
    }

    cache.sort = bcsffilter.queryParams.sort;
    $(selectors.collection).attr('data-sort', cache.sort);

  }

  return {
    init: init,
    buildCollectionPage: buildCollectionPage,
    toggleBackInStockModal: toggleBackInStockModal,
    getBundlesData: getBundlesData
  };

})();

theme.ProductFilter.init();

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.js-search-toggle',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    pageContent: '#PageContent'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open',
    mobileSearchIsOpen: 'js-search--is-open'
  };

  var searchIsOpen = false;

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    $(selectors.searchSubmit).on('click', function(evt) {
      searchIsOpen = false;
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });

    $(selectors.siteHeaderSearchToggle).on('click', activateSearch);

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus', activateSearch);
    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('blur', deactivateSearch);
  }

  function activateSearch(evt) {
    if (evt.type != 'focus') {
      searchFocus($(selectors.searchInput));
    }
    searchIsOpen = true;

    $(selectors.searchHeader).addClass(classes.focus);
    $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
  }

  function deactivateSearch() {
    searchIsOpen = false;

    $(selectors.searchHeader).removeClass(classes.focus);
    $(selectors.pageContent).removeClass(classes.mobileSearchIsOpen);
  }

  function toggleSearch() {
    if (searchIsOpen) {

    } else {
      searchFocus($(selectors.searchInput));
      searchIsOpen = true;

      $(selectors.searchHeader).addClass(classes.focus);
      $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };
  // #TODO: Make these more global
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMedium: theme.settings.mediaQuery.medium,
    mediaQueryLargeUp: theme.settings.mediaQuery.largeUp
  };
  var defaults = {
    accessibility: true,
    adaptiveHeight: false,
    arrows: false,
    asNavFor: null,
    autoplay: false,
    autoplaySpeed: 7000,
    centerMode: false,
    centerPadding: '40px',
    dots: false,
    draggable: true,
    fade: false,
    infinite: true,
    rows: 0,
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    swipeToSlide: true,
    touchThreshold: 20,
  };

  function slideshow(el) {
    this.$slideshow = $(el);

    if (!this.$slideshow.length) {
      return;
    }

    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper) || this.parent();
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    this.sliderActive = false;
    var elementOptions = this.$slideshow.data();

    defaults.prevArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__prev';
    defaults.nextArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__next';

    this.settings = {};
    this.settings.all = {
      adaptiveHeight: elementOptions.adaptiveHeight,
      arrows: elementOptions.arrows,
      asNavFor: elementOptions.asNavFor,
      autoplay: elementOptions.autoplay,
      autoplaySpeed: elementOptions.speed,
      centerMode: elementOptions.centerMode,
      centerPadding: elementOptions.centerPadding,
      dots: elementOptions.dots,
      draggable: elementOptions.draggable,
      fade: elementOptions.fade,
      focusOnSelect: elementOptions.focusOnSelect,
      infinite: elementOptions.infinite,
      nextArrow: elementOptions.nextArrow,
      prevArrow: elementOptions.prevArrow,
      rows: elementOptions.rows,
      slidesPerRow: elementOptions.perRow,
      slidesToScroll: elementOptions.slidesScroll,
      slidesToShow: elementOptions.slidesShow,
      waitForAnimate: elementOptions.waitForAnimate,
    };
    this.settings.desktop = {
      adaptiveHeight: elementOptions.adaptiveHeightDesktop,
      arrows: elementOptions.arrowsDesktop,
      autoplay: elementOptions.autoplayDesktop,
      autoplaySpeed: elementOptions.speedDesktop,
      centerMode: elementOptions.centerModeDesktop,
      centerPadding: elementOptions.centerPaddingDesktop,
      dots: elementOptions.dotsDesktop,
      focusOnSelect: elementOptions.focusOnSelectDesktop,
      infinite: elementOptions.infiniteDesktop,
      rows: elementOptions.rowsDesktop,
      slidesPerRow: elementOptions.perRowDesktop,
      slidesToScroll: elementOptions.slidesScrollDesktop,
      slidesToShow: elementOptions.slidesShowDesktop,
    };
    this.settings.tablet = {
      adaptiveHeight: elementOptions.adaptiveHeightTablet,
      arrows: elementOptions.arrowsTablet,
      autoplay: elementOptions.autoplayTablet,
      autoplaySpeed: elementOptions.speedTablet,
      centerMode: elementOptions.centerModeTablet,
      centerPadding: elementOptions.centerPaddingTablet,
      dots: elementOptions.dotsTablet,
      focusOnSelect: elementOptions.focusOnSelectTablet,
      infinite: elementOptions.infiniteTablet,
      rows: elementOptions.rowsTablet,
      slidesPerRow: elementOptions.perRowTablet,
      slidesToScroll: elementOptions.slidesScrollTablet,
      slidesToShow: elementOptions.slidesShowTablet,
    };
    this.settings.mobile = {
      adaptiveHeight: elementOptions.adaptiveHeightMobile,
      arrows: elementOptions.arrowsMobile,
      autoplay: elementOptions.autoplayMobile,
      autoplaySpeed: elementOptions.speedMobile,
      centerMode: elementOptions.centerModeMobile,
      centerPadding: elementOptions.centerPaddingMobile,
      dots: elementOptions.dotsMobile,
      focusOnSelect: elementOptions.focusOnSelectMobile,
      infinite: elementOptions.infiniteMobile,
      rows: elementOptions.rowsMobile,
      slidesPerRow: elementOptions.perRowMobile,
      slidesToScroll: elementOptions.slidesScrollMobile,
      slidesToShow: elementOptions.slidesShowMobile,
    };

    _.defaults(this.settings.desktop, this.settings.all);
    _.defaults(this.settings.desktop, defaults);

    _.defaults(this.settings.tablet, this.settings.all);
    _.defaults(this.settings.tablet, defaults);

    _.defaults(this.settings.mobile, this.settings.all);
    _.defaults(this.settings.mobile, defaults);

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));

    var self = this;

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        if (!elementOptions.disableMobile) {
          initSlider(self.$slideshow, self.settings.mobile);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    enquire.register(config.mediaQueryMedium, {
      match: function() {
        if (!elementOptions.disableTablet) {
          initSlider(self.$slideshow, self.settings.tablet);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function() {
        if (!elementOptions.disableDesktop) {
          initSlider(self.$slideshow, self.settings.desktop);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    function initSlider(sliderObj, args) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }

      sliderObj.on('beforeChange.slideshow', function(event, slick, currentSlide, nextSlide) {
        slick.$slider.addClass('slick-transitioning');
      });

      sliderObj.on('afterChange.slideshow', function(event, slick, currentSlide, nextSlide) {
        slick.$slider.removeClass('slick-transitioning');
      });

      sliderObj.slick(args);
      self.sliderActive = true;
    }

    function destroySlider(sliderObj) {
      if (self.sliderActive) {
        sliderObj.off('.slideshow');
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }
    }

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (isMobile.any) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function() {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

/**
* Module to show Recently Viewed Products
*
* Copyright (c) 2014 Caroline Schnapp (11heavens.com)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
* Adapted to use Tinybind logic
*
*/

window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.RecentlyViewed = (function() {

  var config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    onComplete: null,
  };

  var selectors = {
    container: '#recently-viewed-products',
    list: '.recently-viewed-products__list',
  };

  var data = {
    products: [],
  };

  var productHandleQueue = [];
  var wrapper = null;
  var shown = 0;

  tinybind.bind($(selectors.container), {
    data: data
  });

  var cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function(recentlyViewed) {
      localStorage.setItem(this.name, recentlyViewed.join(' '));
    },
    read: function() {
      var recentlyViewed = [];
      var cookieValue = localStorage.getItem(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(' ');
      }
      return recentlyViewed;
    },
    destroy: function() {
      localStorage.removeItem(this.name);
    },
    remove: function(productHandle) {
      var recentlyViewed = this.read();
      var position = $.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var moveAlong = function() {

    if (productHandleQueue.length && shown < config.howManyToShow) {
      $.ajax({
        dataType: 'json',
        url: '/products/' + productHandleQueue[0] + '.js',
        cache: false,
        success: function(product) {
          product.featured_image = {
            src: product.featured_image,
          };

          for (var i = 0; i < product.images.length; i++) {
            product.images[i] = {
              src: product.images[i],
            };
          }

          data.products.push(product);

          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function() {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        }
      });
    } else {
      if (typeof config.onComplete === "function") {
        config.onComplete();
      }
    }

  };

  return {

    showRecentlyViewed: function(params) {

      var params = params || {};

      // Update defaults.
      $.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      // How many products to show.
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      } else {
        $(selectors.container).hide();
      }

    },

    getConfig: function() {
      return config;
    },

    clearList: function() {
      cookie.destroy();
    },

    recordRecentlyViewed: function(params) {

      var params = params || {};

      // Update defaults.
      $.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {

        // What is the product handle on this page.
        var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        // In what position is that product in memory.
        var position = $.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);

      }

    }

  };

})();

theme.ShopTheLook = (function() {
  
  let selectors = {
    container: '#shop-the-look-products',
    list: '.shop-the-look-products__list',
    nextArrow: '.shop-the-look__next',
    prevArrow: '.shop-the-look__prev'
  };
  
  let config = {
    howManyToShow: 10,
    onComplete: function() {
      if ($('.shop-the-look-products__item').length > 1){
        let variantSelection = $('.stl-variant-selection');
        variantSelection.each(function() {
          let value = $(this).val();
          $(this).closest('.product-actions__containter').find('input[name="id"]').val(value);
        });
        variantSelection.on('change', function() {
          let value = $(this).val();
          $(this).closest('.product-actions__containter').find('input[name="id"]').val(value);
        });
        $('.shop-the-look-products__list:not(.slick-initialized)').slick({
          arrows: true,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          nextArrow: $('.shop-the-look__next', '#shop-the-look-products'),
          prevArrow: $('.shop-the-look__prev', '#shop-the-look-products'),
          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2.4
              }
            }
          ]
        });
      } else {
        $(selectors.container).hide();
      }
    },
  };
  
  let data = {
    products: [],
  };
  
  let productHandleQueue = [];
  let shown = 0;
  
  tinybind.bind($(selectors.container), {
    data: data
  });
  
  let moveAlong = function() {    
    if (productHandleQueue.length && shown < config.howManyToShow) {
      $.ajax({
        dataType: 'json',
        url: '/products/' + productHandleQueue[0] + '.js',
        cache: false,
        success: function(product) {
          product.featured_image = {
            src: product.featured_image,
          };          
          for (var i = 0; i < product.images.length; i++) {
            product.images[i] = {
              src: product.images[i],
            };
          }          
          data.products.push(product);          
          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function() {
          productHandleQueue.shift();
          moveAlong();
        }
      });
    } else {
      if (typeof config.onComplete === "function") {
        config.onComplete();
      }
    }    
  };
  
  return {
    
    showShopTheLook: function(params) {
      
      var params = params || {};
      
      $.extend(config, params);
      
      const productHandlesData = $('#shop-the-look-products').data('outfit-product-handles');
      const productHandle = $('#shop-the-look-products').data('product-handle');
      
      productHandleQueue = productHandlesData ? productHandlesData.split(',') : [];
      
      if (productHandleQueue.length > 0) {
        productHandleQueue.unshift(productHandle);
      }
      
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);
      
      if (config.howManyToShow) {
        moveAlong();
      } else {
        $(selectors.container).hide();
      }
    }
  };
  
})();

(function() {
  var selectors = {
    backButton: '.back-to-top',
  };

  var classes = {
    visible: 'back-to-top--visible',
    fade: 'back-to-top--fade',
  };

  var config = {
    showAfter: 300,
    dimAfter: 1200,
    scrollDuration: 700,
  };

  $backButton = $(selectors.backButton);

  if (!$backButton.length) {
    return;
  }

  $(window).on('scroll', function(){
    ( $(this).scrollTop() > config.showAfter ) ? $backButton.addClass(classes.visible) : $backButton.removeClass(classes.visible + ' ' + classes.fade);
    if( $(this).scrollTop() > config.dimAfter ) {
      $backButton.addClass(classes.fade);
    }
  });

  $backButton.on('click', function(evt){
    evt.preventDefault();
    $('body,html').animate({scrollTop: 0}, config.scrollDuration);
  });
})();

/*============================================================================
  Favicon cart counter
==============================================================================*/
window.theme = window.theme || {};

theme.Favicon = (function() {

  if (window.Favico === undefined) {
    return;
  }

  var icon = new Favico({
    bgColor: '#0cbdc9',
    textColor: '#fff',
    fontFamily: 'sans-serif', // Arial, Verdana, Times New Roman, serif, sans-serif, ...
    fontStyle: 'bold', // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
    type: 'circle', // circle, rectangle
    position: 'down', // up, down, left, upleft
    animation: 'none', // slide, fade, pop, popFade, none
    elementId: false, // Image element ID if there is need to attach badge to regular image
    element: false, // DOM element where to change "href" attribute (useful in case of multiple link icon elements)
    dataUrl: false, // Method that will be called for each animation from with data URI parameter
  });

  if (window.shop.cart !== undefined && window.shop.cart.item_count_display > 0) {
    set(window.shop.cart.item_count_display);
  }

  function set(value) {
    icon.badge(value);
  }

  function reset() {
    icon.reset();
  }

  return {
    set: set,
    reset: reset
  };
})();

/*
 * Adapted from Currency tools by Caroline Schnapp
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

window.theme = window.theme || {};

theme.CurrencySelectors = (function() {

  function init() {

    Currency.format = shop.currencyFormat;

    var shopCurrency = shop.currency;

    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    Currency.moneyFormats[shopCurrency].money_with_currency_format = shop.moneyWithCurrencyFormat;
    Currency.moneyFormats[shopCurrency].money_format = shop.moneyFormat || null;

    /* Default currency */
    var defaultCurrency = shop.defaultCurrency;

    /* Cookie currency */
    var cookieCurrency = Currency.cookie.read();

    /* Fix for customer account pages */
    $('span.money span.money').each(function() {
      $(this).parents('span.money').removeClass('money');
    });

    /* Saving the current price */
    $('span.money, span.wk-money').each(function() {
      $(this).attr('data-currency-' + shop.currency, $(this).html());
    });


    // If there's no cookie.
    if (cookieCurrency == null) {
      if (shopCurrency === defaultCurrency) {
        Currency.currentCurrency = defaultCurrency;
      }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if ($('[name=currencies]').length && $('[name=currencies] option[value=' + cookieCurrency + ']').length === 0) {
      Currency.currentCurrency = shopCurrency;
      Currency.cookie.write(shopCurrency);
    }
    else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
    }

    $('[name=currencies]').val(Currency.currentCurrency).on('change', function() {
      var newCurrency = $(this).val();
      $('.selected-currency').text(Currency.currentCurrency);
    });

    var original_selectCallback = window.selectCallback;
    var selectCallback = function(variant, selector) {
      original_selectCallback(variant, selector);
      $('.selected-currency').text(Currency.currentCurrency);
    };

    $(document).on('cart.requestComplete', function(event, cart) {
      $('.selected-currency').text(Currency.currentCurrency);
    });

    $('.selected-currency').text(Currency.currentCurrency);
    $('.currency-picker__wrapper').removeClass('loading');
  }

  return {
    init: init,
  };
})();

theme.CurrencySelectors.init();

window.theme = window.theme || {};

theme.MegaMenu = (function() {
  var selectors = {
    megaMenuDropDown: '.site-nav__dropdown ',
    col1: '.site-nav__childlist-navlist--column-1',
    col2: '.site-nav__childlist-navlist--column-2',
    col3: '.site-nav__childlist-navlist--column-3',
    linksContainer: '.site-nav__links',
    secondLevelDropdown: '.site-nav--has-dropdown-nested > a',
    accordionMobile: '.has-dropdown-mobile',
    mobileRightSideContent: '.mobile-nav__right-side-content'
  };


  function MegaMenu() {
    $(selectors.secondLevelDropdown).on('click', expandDropdown);
    $(selectors.accordionMobile).on('click', expandMobile);
    addStickyHeader();
  }

  function expandMobile() {
    $(this).toggleClass('expanded');
  }

  function expandDropdown(event) {
    event.preventDefault();
    event.stopPropagation();
    $(this).closest('li').toggleClass('expanded');
  }

  function addStickyHeader() {
    var stickyHeaderEl = document.getElementById("shopify-section-header");
    if(stickyHeaderEl) {
      stickyHeaderEl.classList.add('sticky');
      theme.stickyHeader = new StickyState(stickyHeaderEl, {
                scrollClass: {
                  down: 'sticky--down',
                  up: 'sticky--up',
                  none: 'sticky--none',
                  persist: true
                }
            });
    }
  }

  function addRightSideContentToMobile() {
    var elements = $(selectors.mobileRightSideContent);

    for (var index = 0; index < elements.length; index++) {
      var parent = elements[index].dataset.parent;
      var content = $('#SiteNavLabel-'+parent + ' .site-nav__childlist-item--right-side-content');
      var container = document.createElement("div");
      container.innerHTML = content.prop('innerHTML');
      elements[index].appendChild(container);
    }
  }



  return new MegaMenu();
})();

window.theme = window.theme || {};

theme.NewsletterModal = (function() {

  var selectors = {
    modalContainer: '#newsletter-modal',
    successMessage: '.form-success',
  };

  function init() {

    if (!$(selectors.modalContainer).length) {
      return;
    }

    var activationDelay = parseInt($(selectors.modalContainer).attr('data-delay')),
        cookieExpiry = $(selectors.modalContainer).attr('data-expiry'),
        forceModal = JSON.parse($(selectors.modalContainer).attr('data-force-modal')),
        userHasVisited = $.cookie('newsletterModalViewed') || false;

    if (forceModal) {
      activationDelay = 0;
    }

    if (!userHasVisited || forceModal) {
      activateModal(activationDelay, cookieExpiry);
    } else if ($(selectors.successMessage, selectors.modalContainer).length) {
      openModal();
    }

    function activateModal(activationDelay, cookieExpiry) {

      $(document).on('scroll.newsletterModal', function(){
        window.setTimeout(function(){
          openModal();

          $.cookie('newsletterModalViewed', 'true', { expires: cookieExpiry, path: '/' });
        }, activationDelay);

        $(document).off('scroll.newsletterModal');
      });

    }

    function openModal() {
      $.featherlight($(selectors.modalContainer), {
        variant: 'newsletter-modal',
        otherClose: '.od-modal__close',
      });
    }

  }

  return init();

})();

window.theme = window.theme || {};

theme.StickyAddToCart = (function() {

  var selectors = {
    productDetails: '.product__col--details'
  };

  var stickybitsDefaults = {
    useFixed: true
  };

  var defaults = {
    selectors: selectors,
    useStickybits: false,
    stickybits: stickybitsDefaults,
    parent: '#MainContent',
    templateName: 'product-sticky-add-to-cart',
    revealClass: 'show',
    showOnLoad: false
  };

  function StickyAddToCart(options) {

    this.options = _.defaultsDeep(options, defaults);
    this.product = this.options.product;

    if (!this.product) {
      console.error('No product defined');
      return;
    }

    var self = this;

    this._build();
    this._bindReveal();

    this.isHidden = true;
    if (this.options.showOnLoad) {
      this.show();
    }
  }

  StickyAddToCart.prototype = $.extend({}, StickyAddToCart.prototype, {

    _build: function() {
      var self = this;

      var template = theme.utils.getTemplate(this.options.templateName);
      self.$el = $(template);
      $(self.options.parent).prepend(self.$el);

      // Bind StickyBits
      if (self.options.useStickybits) {
        self.$el.stickybits(self.options.stickybits);
      }

      return;
    },

    _bindReveal: function() {
      var self = this;

      var waypointElement = $(selectors.productDetails)[0];

      self.waypoint = new Waypoint({
        element: waypointElement,
        handler: function(direction) {
          if (direction == 'down') {
            self.show();
          } else {
            self.hide();
          }
        },
        offset: function() {
          return -this.element.clientHeight + 150;
        }
      });

    },

    show: function() {
      var self = this;
      if (self.isHidden) {
        self.isHidden = false;
        self.$el.addClass(self.options.revealClass);
      }

    },

    hide: function() {
      var self = this;
      if (!self.isHidden) {
        self.isHidden = true;
        self.$el.removeClass(self.options.revealClass);
      }
    },

    destroy: function() {
      var self = this;
      self.$el.remove();
    }

  });

  return StickyAddToCart;
})();
window.theme = window.theme || {};

var originalOnYouTubePlayerAPIReady = _.noop;

if (typeof onYouTubePlayerAPIReady == 'function') {
  originalOnYouTubePlayerAPIReady = onYouTubePlayerAPIReady;
}

window.onYouTubePlayerAPIReady = function() {
  var youTubeService = _.find(theme.videoServiceAPIs, {'name': 'youtube'});
  youTubeService.runOnReadyQueue();
  originalOnYouTubePlayerAPIReady();
};

theme.videoServiceAPIs = (function() {

    function PlayerServiceAPI(data) {
      _.extend(this, data);
      this._isloaded = false;
      this._isloading = false;
      this._onReadyQueue = [];
    }

    PlayerServiceAPI.prototype = _.extend(PlayerServiceAPI.prototype, {

      load: function(callback) {

        var self = this;

        if (this._isloaded || this._checkIsLoaded()) {
          callback();
          return;
        }

        this._onReadyQueue.push(callback);

        if (this._isloading) {
          return;
        }

        loadJS(this.url, function() {

          if (self.name == 'vimeo') {
            self.runOnReadyQueue();
          }

        });

      },

      runOnReadyQueue: function() {

        this._isloaded = true;

        while (this._onReadyQueue.length) {
          this._onReadyQueue.shift().call();
        }

      }

    });

    return [

      // YouTube Player
      new PlayerServiceAPI({
        name: 'youtube',
        url: 'https://www.youtube.com/iframe_api',
        newPlayer: function(data) {
          return new YT.Player(data.node.id, {
            videoId: data.videoID,
            playerVars: {
              modestbranding: 1,
              rel: 0,
              iv_load_policy: 3,
              showinfo: 0,
              wmode: 'opaque',
              branding: 0,
              autohide: 0,
            },
            events: {
              'onReady': data.onPlayerReady || _.noop,
              'onStateChange': data.onPlayerStateChange || _.noop,
            }
          });
        },
        _checkIsLoaded: function() {
          return (typeof YT != 'undefined' && YT && YT.loaded);
        },
        isPlaying: function(player, event) {
          return (event.data == YT.PlayerState.PLAYING);
        },
        play: function(player) {
          player.playVideo();
        },
        pause: function(player) {
          player.pauseVideo();
        }
      }),

      // Vimeo player
      new PlayerServiceAPI({
        name: 'vimeo',
        url: 'https://player.vimeo.com/api/player.js',
        newPlayer: function(data) {
          var player = new Vimeo.Player(data.node, {
            id: data.videoID,
            byline: false,
            portrait: false,
            title: false
          });
          player.on('play', function() {
            player._isPlaying = true;
            data.onPlayerStateChange() || _.noop
          });
          player.on('pause', function() {
            player._isPlaying = false;
            data.onPlayerStateChange() || _.noop
          });
          player.on('loaded', data.onPlayerReady || _.noop);
          return player;
        },
        isPlaying: function(player, event) {
          return player._isPlaying; // This is a custom attribute not implemented by Vimeo
        },
        _checkIsLoaded: function() {
          return (typeof Vimeo != 'undefined');
        },
        play: function(player) {
          // If multiple Vimeo videos exist on a page this
          // may throw an error. Feel free to ignore this if
          // the correct video is playing.
          player.play();
        },
        pause: function(player) {
          player.pause();
        }
      }),

      // HTML5 player
      new PlayerServiceAPI({
            name: 'html5',
            url: false,
            newPlayer: function(data) {
                var player = data.node;

                player.addEventListener('play', function() {
                    data.onPlayerStateChange() || _.noop;
                });

                player.addEventListener('pause', function() {
                    data.onPlayerStateChange() || _.noop;
                });

                return player;
            },
            isPlaying: function(player, event) {
                return !player.paused;
            },
            _checkIsLoaded: function() {
                return true;
            },
            play: function(player) {
                player.play();
            },
            pause: function(player) {
                player.pause();
            }
        }),
    ];

})();

theme.Video = (function() {

  var SELECTORS = {
    placeholder: '.video__placeholder'
  };

  function Video(container) {

    this.container = container;
    this.videoID = container.dataset.videoId;
    this.autoPlay = (container.dataset.videoAutoplay == 'true');
    this.placeholder = this.container.querySelector(SELECTORS.placeholder);

    if (this.container.dataset.placeholderOverlay) {
      this.additionalOverlay = document.querySelector(this.container.dataset.placeholderOverlay);
      // this.additionalOverlay.classList.add('video-is-paused');
    }

    var playerServiceName = container.dataset.videoType;

    this._loadPlayerServiceAPI(playerServiceName);
  }

  Video.prototype = _.extend(Video.prototype, {

    _loadPlayerServiceAPI: function(playerServiceName) {

      var self = this;

      var type,
          source;

      this.playerService = _.find(theme.videoServiceAPIs, {'name': playerServiceName});

      if (!this.playerService) {
        console.error(new Error('No service found'));
        return;
      }

      this.playerService.load(this._onServiceLoad.bind(this));

    },

    _onServiceLoad: function() {

      if (this.autoPlay) {

        this._bindWaypoint();

      } else {

        if (this.placeholder) {
          this._bindPlaceholder();
        } else {
           this._createPlayer();
        }

      }

    },

    _bindWaypoint: function() {
      var self = this;

        new Waypoint({
          element: this.container,
          offset: '100%',
          handler: function() {
            self._createPlayer(self.play.bind(self));
            this.destroy();
          },
        });

    },

    _bindPlaceholder: function() {

      var self = this;

      this.placeholder.addEventListener('click', function() {
        self._addPlaceholderLoadingState();
        self._createPlayer(self.play.bind(self));
      });

    },

    revealVideo: function() {
      this.container.dataset.videoVisible = true;
      this._removePlaceholderLoadingState();
    },

    _createPlayer: function(onPlayerReady) {

      var videoNode = document.getElementById('video-' + this.videoID);

      this.player = this.playerService.newPlayer({
        node: videoNode,
        videoID: this.videoID,
        onPlayerReady: onPlayerReady || _.noop,
        onPlayerStateChange: this._onStateChange.bind(this),
      });

    },

    _onStateChange: function(event) {

      if (this.playerService.isPlaying(this.player, event)) {

        this.revealVideo();

        if (this.additionalOverlay) {
          this.additionalOverlay.classList.add('video-is-playing');
          this.additionalOverlay.classList.remove('video-is-paused');
        }

      } else {

        if (this.additionalOverlay) {
          this.additionalOverlay.classList.add('video-is-paused');
          this.additionalOverlay.classList.remove('video-is-playing');
        }

      }

    },

    _addPlaceholderLoadingState: function() {
      this.container.classList.add('loading');
    },

    _removePlaceholderLoadingState: function() {
      this.container.classList.remove('loading');
    },

    play: function() {

      try {
        this.playerService.play(this.player);
      } catch(e) {
        console.error(e);
      }

    }

  });

  return Video;

})();

var videoContainers = document.getElementsByClassName('video');

theme.videos = [];

_.each(videoContainers, function(videoContainer) {
  var video = new theme.Video(videoContainer);
  theme.videos.push(video);
});

/*================ Sections ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled){
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '.collection-filters__dropdown--filter',
    sortSelection: '.collection-filters__dropdown--sort',
    defaultSort: '.collection-filters__default-sort',
    filterPlaceholderDesktop: '.collection-filters-placeholder--desktop',
    filterPlaceholderMobile: '.collection-filters-placeholder--mobile',
    filterContentDesktop: '.collection-filters-content--desktop',
    filterContentMobile: '.collection-filters-content--mobile',
    filterSection: '[data-section-type="collection-filters"]',
    filterSectionWrapper: '#shopify-section-collection-filters',
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.initFilters();

    this.$filterSelects = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects); 
    this.$selects.removeClass('hidden');

    this.$filterSelects.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {

    /**
     * Initialises filters
     */
    initFilters: function() {
      var self = this;
      var $filterSectionWrapper = $(selectors.filterSectionWrapper);

      var $filterContentMobile = $(selectors.filterContentMobile, $filterSectionWrapper).html();
      var $filterContentDesktop = $(selectors.filterContentDesktop, $filterSectionWrapper).html();

      $(selectors.filterPlaceholderMobile, this.$container).replaceWith($filterContentMobile);
      $(selectors.filterPlaceholderDesktop, this.$container).replaceWith($filterContentDesktop);
    },

    _onSortChange: function(evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(window.location.search, '');
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      // window.location.href = $(evt.target).val() + window.location.search;
      var newLocation = $(evt.target).val();
      if (window.location.search != '') {
        var currentQueryParams = theme.utils.getQueryParams();
        for (var k in currentQueryParams) {
          if (currentQueryParams.hasOwnProperty(k)) {
            newLocation = theme.utils.updateQueryStringParameter(k, currentQueryParams[k], newLocation);
          }
        }
        var newQueryParams = theme.utils.getQueryParams(newLocation);
        for (var k in newQueryParams) {
          if (newQueryParams.hasOwnProperty(k)) {
            newLocation = theme.utils.updateQueryStringParameter(k, newQueryParams[k], newLocation);
          }
        }
        window.location.href = newLocation;
      }
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + 5 + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelects.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header(container) {
    theme.Header.init(container);
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json-main]',
    productSku: '[data-product-variant-sku]',
    productBinNumber: '[data-bin-number]',
    productPrice: '[data-product-price]',
    productImageWrap: '[data-product-images-wrap]',
    productImageContainer: '[data-product-images]',
    productImages: '[data-product-image]',
    productActiveImage: '[data-product-active-image]',
    productThumbContainer: '[data-product-thumbnails]',
    productThumbs: '[data-product-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    singleOptionValue: '[data-single-option-value]',
    productQtyWrapper: '.product-form__item--quantity',
    productQtySelector: '[data-product-quantity]',
    optionSelector: '[data-option-selector]',
    quantitySelector: '#Quantity',
    wholesaleAdd: '.b2b-selectors__container [data-add-to-cart]',
    wholsaleQuantitySelectors: '.b2b-selectors__container input[type="number"]',
    wholesaleQuantityButtons: '.b2b-selectors__container button',
    loyaltyPointsContainer: '#product-loyalty-points',
    sizeGuideLink: '.product-size-guide',
    productColoursData: 'script#product-colour-data',
    productColoursWrapper: '.js-product-colors',
    priceMeta: '[itemprop="price"]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    this.$qtySelector = $(selectors.productQtySelector);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/styles/settings/variables.scss.liquid // $grid-breakpoints
      mediaQuerySmall: theme.settings.mediaQuery.small,
      mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      sectionId: sectionId,
      sliderActive: false,
      bpSmall: false,
      zoomEnabled: false,
      qtySelectorType: $(selectors.productQtySelector).is('select') ? 'select' : 'input'
    };
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html() && !theme.current.product) {
      return;
    }

    if($(selectors.wholesaleAdd).length) {
      $(selectors.wholesaleAdd).on('click',this.addMultipleItemsToCart);
      $(selectors.wholsaleQuantitySelectors).on('change', this.changeAddToCartButtonState.bind(this))
      $(selectors.wholesaleQuantityButtons).on('click', this.changeWholesaleQuantity.bind(this))

    }

    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.productSingleObject = theme.current.product;
    this.settings.imageSize = this.$featuredImage.length ? slate.Image.imageSize(this.$featuredImage.attr('src')) : 0;
    this.settings.zoomEnabled = $(selectors.productFeaturedImage).hasClass('js-zoom-enabled');

    this.initImageSlider();
    this.initGallery();
    this.initVariants();
    this.initLoyaltyPoints();
    this.initColourOptions();


    var readMoreLink = '<button aria-hidden="true" focusable="false" role="presentation" class="read-more">Read more <svg class="icon icon-fa-caret-down" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L403 749q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/></svg></button>';
    var productDescriptionReadMoreHeight = 200;

    // Only enable readmore if there's a decent amount of text to hide
    if ($('.product__description').innerHeight() >= (productDescriptionReadMoreHeight * 1.175)) {
      $('.product__description').readmore({
        speed: 75,
        collapsedHeight: productDescriptionReadMoreHeight,
        heightMargin: 20,
        moreLink: readMoreLink,
        lessLink: false,
        beforeToggle: function(trigger, element, expanded) {
          $(element).toggleClass('readmore-expanded');
        }
      });
    }

    $(selectors.sizeGuideLink).on('click', this.openSizeChartModal)
  }

  Product.prototype = $.extend({}, Product.prototype, {
    initQuantitySelectors: function() {

      var elem = document.querySelector(selectors.quantitySelector);

      if (!elem) {
        return;
      }

      var quantitySelector = new theme.QuantitySelector(elem);

    },

    openSizeChartModal: function() {
      var self = this;

      new theme.Modal('.sizing-table-container', {});

    },

    initLoyaltyPoints: function() {

      var productPriceNZD = $(selectors.priceMeta).attr('content');
      productPriceNZD = parseInt(productPriceNZD);
      $(selectors.loyaltyPointsContainer).text(productPriceNZD.toString());
    },

    /**
     * Creates linked sliders for product main and thumb images
     */
    initImageSlider: function() {
      var thumbOptions = {
        slidesToShow: 5,
        swipeToSlide: true,
        infinite: true,
        asNavFor: selectors.productImageContainer,
        focusOnSelect: true,
        rows: 0,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      var mainOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        arrows: true,
        infinite: true,
        focusOnSelect: true,
        fade: true,
        adaptiveHeight: true,
        lazyLoad: 'progressive',
        rows: 0,
        prevArrow: selectors.productImageContainer + ' ~ .product__images__prev',
        nextArrow: selectors.productImageContainer + ' ~ .product__images__next',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              fade: false,
              dots: true,
            }
          }
        ]
      };

      $activeProductImage = $(selectors.productActiveImage).first();
      if ($activeProductImage.length > 0) {
        var firstSlide = $activeProductImage.index() || 0;
        mainOptions.initialSlide = firstSlide;
      }

      if ($(selectors.productImageWrap, this.$container).is('[data-vertical]')) {
        thumbOptions = $.extend({}, thumbOptions, {
          vertical: true,
          verticalSwiping: true,
        });
      }

      if (this.productSingleObject.images.length > 1) {
        $(selectors.productThumbContainer).slick(thumbOptions);
      }

      $(selectors.productImageContainer).slick(mainOptions);

      this.settings.sliderActive = true;
    },

    /**
     * Sets up product image lightbox with Photoswipe.js
     */
    initGallery: function() {
      var self = this;
      console.log('init gallery ')
      if (self.settings.zoomEnabled) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = $('[data-pswp-items]').data('pswp-items');

        $(selectors.productImageWrap, this.$container).on('click', '.zoom-js', function(e){
          e.preventDefault();
          var thumbnail = $(this).find('img')[0];
          options = {
            index: $(this).data('index'),
            barsSize: {top:0,bottom:0},
            captionEl: false,
            fullscreenEl: false,
            shareEl: false,
            bgOpacity: 0.96,
            tapToClose: true,
            tapToToggleControls: false,
            history: false,
            getDoubleTapZoom: function(isMouseClick, item) {

              // isMouseClick          - true if mouse, false if double-tap
              // item                  - slide object that is zoomed, usually current
              // item.initialZoomLevel - initial scale ratio of image
              //                         e.g. if viewport is 700px and image is 1400px,
              //                              initialZoomLevel will be 0.5

              if(isMouseClick) {

                  // is mouse click on image or zoom icon

                  // zoom to original
                  return 2;

                  // e.g. for 1400px image:
                  // 0.5 - zooms to 700px
                  // 2   - zooms to 2800px

              } else {

                  // is double-tap

                  // zoom to original if initial zoom is less than 0.7x,
                  // otherwise to 1.5x, to make sure that double-tap gesture always zooms image
                  return item.initialZoomLevel < 0.7 ? 1 : 1.5;
              }
            },
            getThumbBoundsFn: function(index) {
              var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect(),
              thumbInfo = theme.utils.getImgSizeInfo(thumbnail);
              return {x: rect.left + thumbInfo.left, y: rect.top + pageYScroll, w: thumbInfo.width};
            }
          };

          var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          var realViewportWidth,
              useLargeImages = false,
              firstResize = true,
              imageSrcWillChange;

          // gettingData event fires each time PhotoSwipe retrieves image source & size
          gallery.listen('gettingData', function(index, item) {

            realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;

            // Set image source & size based on real viewport width
            if( useLargeImages ) {
              item.src = item.originalImage.src;
              item.w = item.originalImage.w;
              item.h = item.originalImage.h;
              item.msrc = item.originalImage.msrc;
            } else {
              if (realViewportWidth > 1024) {
                item.w = 1600;
              } else if (realViewportWidth > 768) {
                item.w = 1024;
              } else if (realViewportWidth > 640) {
                item.w = 768;
              } else if (realViewportWidth > 480) {
                item.w = 640;
              } else {
                item.w = 480;
              }
              item.w = Math.min(item.w, item[index].originalWidth);
              item.h = Math.round(item.w / item[index].ratio);

              var itemSrcTemplate = decodeURI(item[index].src);
              item.src = itemSrcTemplate.replace('{width}', item.w);

              var $imageElem = $(selectors.productImageContainer + ' [data-slick-index="' + index + '"]:not(.slick-cloned) img');
              item.msrc = $imageElem.prop('currentSrc') || $imageElem.attr('src') || item[index].msrc;
            }

            // It doesn't really matter what will you do here,
            // as long as item.src, item.w and item.h have valid values.
            //
            // Just avoid http requests in this listener, as it fires quite often

          });

          gallery.listen('close', function() {
            if (self.settings.sliderActive) {
              $(selectors.productImageContainer).slick('slickGoTo', this.getCurrentIndex());
            }
          });

          gallery.init();

        });
      }
    },

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
      this.$container.on('variantOptionChange' + this.namespace, this.updateProductOptions.bind(this));
      this.$container.on('variantSKUChange' + this.namespace, this.updateSKU.bind(this));
      this.$container.on('variantBinNumberChange' + this.namespace, this.updateBinNumber.bind(this));
      this.$container.on('variantChange' + this.namespace, function(event) {
        console.log('dispatching', event)
        document.dispatchEvent(new CustomEvent("variant:change", {
          detail: {variant: event.variant}
        }));
      })



      jQuery(selectors.singleOptionSelector).first().prop('selectedIndex', 1);
      jQuery(selectors.singleOptionSelector).first().trigger('change');
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      var self = this,
          quantityAvailable,
          variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }
      if (variant.available) {
        quantityAvailable = Math.min(Math.max(variant.inventory_quantity, 0), self.$qtySelector.attr('data-max'));

        if (self.settings.qtySelectorType == 'select') {
          $('option', self.$qtySelector).remove();

          for (var i = quantityAvailable - 1; i >= 0; i--) {
            self.$qtySelector.prepend('<option ' + (i==0 ? 'selected' : '') + ' value="' + (i + 1) + '">' + (i + 1) + '</option>');
          }
        } else {
          quantityAvailable = quantityAvailable > 0 ? quantityAvailable : 999;
          self.$qtySelector.prop('max', quantityAvailable);
          self.$qtySelector.prop('min', 1);
        }

        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.productQtyWrapper + ' input', this.$container).prop('max', 0);
        $(selectors.productQtyWrapper + ' input', this.$container).prop('min', 0);
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    changeWholesaleQuantity: function(evt) {
      var $this = $(evt.target)

      var $inputEl = $this.closest('.js-qty-select').find('input');

      var inputElValue = parseInt($inputEl.val());

      var newValue = inputElValue;

      if( $this.hasClass('js-qty-select-add') ) {
        if($inputEl.attr("max")) {
          if(inputElValue < parseInt($inputEl.attr("max") )) newValue = inputElValue + 1;
        } else {
          newValue = inputElValue + 1;
        }
      }

      if($this.hasClass('js-qty-select-remove') && inputElValue > 0 ) {
        newValue = inputElValue - 1;
      }

      $inputEl.val(newValue);
      this.changeIfAllHasValue();
    },

    changeIfAllHasValue: function() {
      var disabled = true;
      var quantitySelectors = $(selectors.wholsaleQuantitySelectors);

      for (var i = 0; i < quantitySelectors.length; i++) {
        if($(quantitySelectors[i]).val() > 0) {
          disabled = false
        }
      }

      if(disabled) {
        $(selectors.wholesaleAdd).prop('disabled', true);
      } else {
        $(selectors.wholesaleAdd).prop('disabled', false);
      }
    },

    changeAddToCartButtonState: function(evt) {
      var $this = $(evt.target);


      if(parseInt($this.val()) > parseInt($this.attr("max"))) {
        $this.val($this.attr("max"))
      }
      if(parseInt($this.val()) < 0) {
        $this.val(0)
      }

      this.changeIfAllHasValue();


    },

    addMultipleItemsToCart: function(evt) {
      var $this = $(evt.target);
      var productHandleProperty = this.dataset.productHandleProperty;
      var $container = this.$container;
      var $variants = $('.product-grid-item__variant', $container);
      for (var i = 0; i < $variants.length; i++) {
        var qty = $('input[type="number"]', $variants[i]).val();
        if (qty > 0) {
          var variantId = $($variants[i]).data('variant-id');
    
          CartJS.addItem(variantId, qty, {
            '_handle': productHandleProperty
          }, {
            "success": function(data, textStatus, jqXHR) {
              // Open cart drawer
              theme.CartDrawer.open();
    
              // Update wishlist count
              window._swat.fetch(function(products) {

                var count = products.length;
                $('#wishlist-count').text(count);
              });
    
              $('[data-progress-element]', $container).removeClass('loading');
            }
          });
        } else {
          $('[data-progress-element]', $container).removeClass('loading');
        }
      }
    },
    

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var comparePrefixString = $comparePrice.data('prefix-string') || '';
      var compareSuffixString = $comparePrice.data('suffix-string') || '';

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, shop.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(comparePrefixString + slate.Currency.formatMoney(variant.compare_at_price, shop.moneyFormat) + compareSuffixString);
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }

      var $afterpayInstallments = $('#afterpay_instalments', this.$container);
      if ($afterpayInstallments.length) {
        $afterpayInstallments.html(slate.Currency.formatMoney(variant.price/4, shop.moneyFormat));
      }

      var $laybuyInstallments = $('#laybuy_instalments', this.$container);
      if ($laybuyInstallments.length) {
        $laybuyInstallments.html(slate.Currency.formatMoney(variant.price/6, shop.moneyFormat));
      }
    },

    /**
     * Updates the DOM with specified options
     */
    updateProductOptions: function(evt) {
      var enabledOptions = [];
      var selectedVariant = evt.variant;
      if(selectedVariant) {
        for (var i = 0; i < this.productSingleObject.variants.length; i++) {
          var variant = this.productSingleObject.variants[i];
            if (variant.available) {
              enabledOptions = _.union(enabledOptions, [variant.option1, variant.option2, variant.option3]);
            }
        }

        $(selectors.singleOptionSelector + '[type="radio"]').attr('disabled', 'disabled');
        for (var i = 0; i < enabledOptions.length; i++) {
          $(selectors.singleOptionSelector + '[type="radio"][value="' + $.escapeSelector(enabledOptions[i]) + '"]').removeAttr('disabled');
        }

        if (!selectedVariant.available) {
          var $selectedDisabledOptions = $(selectors.singleOptionSelector + '[type="radio"]:not([data-index="option1"]):disabled:checked');
          if ($selectedDisabledOptions.length) {
            $selectedDisabledOptions.each(function(){
              var $newOption = $(this).siblings(selectors.singleOptionSelector + '[type="radio"]:not([data-index="option1"]):not(:disabled):not(:checked)').eq(0);
              $(this).removeAttr('checked');
              $newOption.attr('checked', 'checked').trigger('click');
            });
          }
        } else {
          $(selectors.singleOptionValue).each(function(){
            var $this = $(this);
            $this.text(selectedVariant.options[$this.data('single-option-value')]);
          });
        }
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var self = this;
      var variant = evt.variant;

      if (self.settings.sliderActive) {
        var imageIndex = $('[data-image-id="' + variant.featured_image.id + '"]:not(.slick-cloned)').closest('.slick-slide').data('slick-index');
        $(selectors.productImageContainer).slick('slickGoTo', imageIndex);
      } else {
        if (this.$featuredImage.length) {
          var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
          this.$featuredImage.attr('src', sizedImgUrl);
        }
      }
    },
    _selectProductColor: function() {
      this.$container.addClass('loading');
    },
    initColourOptions: function() {
      var self = this;
      var colorSwatchEnabled = false;
      //get global colour information
      if (colorSwatchEnabled) {
        var $colorData = $(selectors.productColoursData);

        if ($colorData.length) {
           self.colorData = JSON.parse($colorData.html());
        }else {
          return;
        }
      }
      self.productColorOptions = {};

      var $productColorContainer = $(selectors.productColoursWrapper);

      tinybind.bind($productColorContainer, {
        data: self.productColorOptions,
        methods: {
          selectColor: this._selectProductColor.bind(this),
        }
      });

      var productGroupTag = $productColorContainer.attr('data-group');
      if (productGroupTag) {
        $.get('/collections/all/' + productGroupTag + '?view=json', function(data) {
            var productColorOptions = JSON.parse(data);
            self.productColorOptions.products = productColorOptions;
            console.log(self.productColorOptions.products)
            _.each(self.productColorOptions.products, function(product, index) {
              var color = product.color;

              product.featured_image = product.featured_image.replace('_{width}x','');

              if (colorSwatchEnabled) {
                var colorData = _.find(self.colorData, {'title': color});
              }
              if (product.handle == self.productSingleObject.handle) {
                self.productColorOptions.products[index].url = '#';
                self.productColorOptions.selectedColor = color;
                self.productColorOptions.selectedHandle = product.handle;
              }
            });
        });
      }
    },

    /**
     * Updates the DOM with specified Variant SKU
     */
    updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(selectors.productSku, this.$container).html(variant.sku);
    },

    /**
     * Updates the DOM with specified Variant Bin number
     */
    updateBinNumber: function(evt) {
        var variant = evt.variant;

        const $binVariant = $('[data-bin-number-variant-' + variant.id + ']');
  
        // Update the sku
        $(selectors.productBinNumber, this.$container).val($binVariant.data('value'));
      },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Quotes = (function() {

  var selectors = {
    slideshow: '[data-slideshow]'
  };

  function Quotes(container) {

    this.$container = $(container);
    this.$slideshows = $(selectors.slideshow, this.$container);

    $.each(this.$slideshows, function(index, slideshow) {
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    });

  }

  return Quotes;
})();

theme.slideshows = theme.slideshows || {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};

theme.BrandValueSliders = (function() {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
    slideCount: 0,
    anchorPosition: 'above', // above, below
    anchorElement: false, // '.site-header-lower'
    anchorViewport: 'small' // large, small
  };

  var cache = {
    anchorMarginBottom: 0,
    anchorMarginTop: 0,
    anchorOffset: 0
  }

  var defaults = {
    arrows: false,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    swipeToSlide: true,
    slidesToScroll: 1,
    rows: 0,
  };

  function brandValueSliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.brand-values-wrap';
    var slider = this.slider = '#brand-values-' + sectionId;
    var $slider = $(slider, wrapper);
    var $contentContainer = $('#PageContent');
    var $anchorElement = $(config.anchorElement);

    var mobileOptions = $.extend({}, defaults, {
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      autoplay: $slider.data('autoplay-mobile'),
      autoplaySpeed: $slider.data('speed')
    });

    var sliderActive = false;
    var desktopOptions = $.extend({}, defaults, {
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop')
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if ($anchorElement.length) {
      cache.anchorMarginTop = parseInt($anchorElement.css("marginTop").replace('px', ''));
      cache.anchorMarginBottom = parseInt($anchorElement.css("marginBottom").replace('px', ''));
    }

    enquire.register(config.mediaQuerySmall, {
      deferSetup: true,
      match: function() {
        initSlider($slider, mobileOptions);

        if ($anchorElement.length) {
          $anchorElement.css({
            'margin-top': cache.anchorMarginTop + 'px',
            'margin-bottom': cache.anchorMarginBottom + 'px'
          });

          if (config.anchorViewport == 'small' || config.anchorViewport == 'all') {
            $container.css('position', 'fixed');
            switch (config.anchorPosition) {
              case 'above':
                cache.anchorOffset = $anchorElement.offset().top;
                var anchorAdjustment = {
                  'margin-top': (cache.anchorMarginTop + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'top': cache.anchorOffset + 'px'
                };
                break;
              default:
                cache.anchorOffset = $anchorElement.offset().top + $anchorElement.innerHeight();
                var anchorAdjustment = {
                  'margin-bottom': (cache.anchorMarginBottom + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'top': cache.anchorOffset + 'px'
                };
                break;
            }
          } else {
            var anchorAdjustment = {
              'margin-bottom': cache.anchorMarginBottom + 'px'
            };
            var sliderAdjustment = {
              'position': 'static',
              'top': '0px'
            };
          }

          $anchorElement.css(anchorAdjustment);
          $container.not('.brand-values--cloned').css(sliderAdjustment);
        }
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      deferSetup: true,
      match: function() {
        initSlider($slider, desktopOptions);
        if ($anchorElement.length) {
          $anchorElement.css({
            'margin-top': cache.anchorMarginTop + 'px',
            'margin-bottom': cache.anchorMarginBottom + 'px'
          });

          if (config.anchorViewport == 'large' || config.anchorViewport == 'all') {
            $container.css('position', 'fixed');
            switch (config.anchorPosition) {
              case 'above':
                cache.anchorOffset = $anchorElement.offset().top;
                var anchorAdjustment = {
                  'margin-top': (cache.anchorMarginTop + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'position': 'fixed',
                  'top': cache.anchorOffset + 'px'
                };
                break;
              default:
                cache.anchorOffset = $anchorElement.offset().top + $anchorElement.innerHeight();
                var anchorAdjustment = {
                  'margin-bottom': (cache.anchorMarginBottom + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'position': 'fixed',
                  'top': cache.anchorOffset + 'px'
                };
                break;
            }
          } else {
            var anchorAdjustment = {
              'margin-bottom': cache.anchorMarginBottom + 'px'
            };
            var sliderAdjustment = {
              'position': 'static',
              'top': '0px'
            };
          }

          $anchorElement.css(anchorAdjustment);
          $container.not('.brand-values--cloned').css(sliderAdjustment);
        }
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
        $('.brand-values-clone').empty();
      }

      // Clone brand values content to other site areas
      // #TODO: Attach this to the main slider init so it functions as a slider
      sliderObj.clone().addClass('brand-values--cloned').removeAttr('id').removeAttr('style').appendTo('.brand-values-clone');

      sliderObj.slick(args);
      sliderActive = true;

      if ($anchorElement.length) {
        if ($(window).width() < 750) {
          switch (config.anchorPosition) {
            case 'above':
              $anchorElement.css('margin-top', sliderObj.outerHeight() + 'px');
              break;
            default:
              $anchorElement.css('margin-bottom', sliderObj.outerHeight() + 'px');
              break;
          }
        }
      }
    }
  }

  brandValueSliders.prototype = _.assignIn({}, brandValueSliders.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.brand-values__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return brandValueSliders;
})();

window.theme = window.theme || {};

theme.FeaturedCollection = (function() {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
    slideCount: 0
  };

  var sliderOptions = {
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
  };

  function featuredCollection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.featured-collection-wrap';
    var slider = this.slider = '#featured-collection-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = $.extend({}, sliderOptions, {
      prevArrow: slider + ' ~ .featured-collection__prev',
      nextArrow: slider + ' ~ .featured-collection__next',
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            // dots: true,
            autoplay: $slider.data('autoplay-mobile'),
          }
        },
        {
          breakpoint: 512,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            // dots: true
          }
        }
      ]
    });

    var self = this;

    function appendSlickScrollbar(slick) {
      if (slick.$slides.filter('.slick-active').length != slick.$slides.length) {
        var currentMarkerOffset = slick.currentSlide * 100;
        var scrollbarMarkerWidth = 1 / slick.slideCount * 100;
        slick.$slider.append('<div class="slick-scrollbar"><div class="slick-scrollbar-mark" style="width: ' + scrollbarMarkerWidth + '%"></div></div>');
        $('.slick-scrollbar-mark', slick.$slider).css('transform', 'translateX(' + currentMarkerOffset + '%)');
      }
    }

    $slider.on('init', function(evt, slick){
      self.a11y.bind(this);

      // appendSlickScrollbar(slick);
    });

    $slider.on('reInit', function(evt, slick){
      // appendSlickScrollbar(slick);
    });

    $slider.on('beforeChange', function(evt, slick, currentSlide, nextSlide){
      var currentMarkerOffset = nextSlide * 100;
      $('.slick-scrollbar-mark', slick.$slider).css('transform', 'translateX(' + currentMarkerOffset + '%)');
    });

    initSlider($slider, options);

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;

      var markerRatio = $('.featured-collection .slick-list').width() / $('.featured-collection .slick-track').width();

      // $('input[type="number"]', sliderObj).not('.js-qty-select input[type="number"]').each( function(){
      //   var $el = $(this);
      //   theme.QuantitySelector.init($el);
      // });
    }
  }

  featuredCollection.prototype = _.assignIn({}, featuredCollection.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return featuredCollection;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.FeaturedCollections = (function() {
  var selectors = {
    collectionLink: '.featured_colections__header-item',
  };

  function FeaturedCollections(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;
    var activeCollectionHandle = $('[data-block-id]', $container).first().data('related-collection');

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

    $(selectors.collectionLink + '[data-related-collection=' + activeCollectionHandle + ']', $container).addClass('active');

    $(slideshow).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var nextCollectionHandle = $('[data-slick-index="' + nextSlide + '"]:not(.slick-cloned) [data-related-collection]', $container).data('related-collection');
      if (nextCollectionHandle != activeCollectionHandle) {
        activeCollectionHandle = nextCollectionHandle;

        $(selectors.collectionLink, $container).removeClass('active');
        $(selectors.collectionLink + '[data-related-collection="' + activeCollectionHandle + '"]', $container).addClass('active');
      }
    });

    $(selectors.collectionLink, $container).on('click', function(evt){
      evt.preventDefault();
      var $this = $(this);

      var relatedCollectionHandle = $this.data('related-collection');
      var $slide = $('.slick-slide[data-slick-index="' + $this.data('first-product') + '"]:not(.slick-cloned)', $container).first();
      var slideIndex = $slide.data('slick-index');
      $(slideshow).slick('slickGoTo', slideIndex);
    });
  }

  return FeaturedCollections;
})();

theme.FeaturedCollections.prototype = _.assignIn({}, theme.FeaturedCollections.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});


window.theme = window.theme || {};

theme.FeaturedBrands = (function() {

    var selectors = {
        slideshow: '.slideshow-container',
        nextArrow: '.featured-brands__next',
        prevArrow: '.featured-brands__prev'
    };


    function featuredBrands(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');
        this.$slideshows = $(selectors.slideshow, this.$container);

        $(this.$slideshows).slick({
            arrows: true,
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            nextArrow: selectors.nextArrow,
            prevArrow: selectors.prevArrow,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                    }
                },
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1.4,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                  }
                }
            ]
        });
    }

    featuredBrands.prototype = _.assignIn({}, featuredBrands.prototype, {
    });

  return featuredBrands;
})();

window.theme = window.theme || {};

theme.FeaturedProduct = (function() {

  var selectors = {
    quantitySelector: 'input[type="number"]',
  };

  function FeaturedProduct(container) {
    var qtySelectorElem = container.querySelector(selectors.quantitySelector);

    if (!qtySelectorElem) {
      return;
    }

    var quantitySelector = new theme.QuantitySelector(qtySelectorElem);
  }

  return FeaturedProduct;
})();

window.theme = window.theme || {};

theme.slideshows = theme.slideshows || {};

theme.FeaturedProducts = (function() {

  function FeaturedProducts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshowMasthead = this.slideshow = '#featured-products-masthead-' + sectionId;
    var slideshow = this.slideshow = '#featured-products-' + sectionId;

    theme.slideshows[slideshowMasthead] = new theme.Slideshow(slideshowMasthead);
    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

    $('.featured-products__slide', slideshow).on('mouseenter', function(){
      $(slideshowMasthead).slick('slickGoTo', $(this).parents('.slick-slide').data('slick-index'));
    });

    $('.featured-products__slide', slideshow).on('mouseleave', function(){
      $(slideshowMasthead).slick('slickGoTo', $(slideshow).slick('slickCurrentSlide'));
    });
  }

  return FeaturedProducts;
})();

theme.FeaturedProducts.prototype = _.assignIn({}, theme.FeaturedProducts.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});


window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.ImageRows = (function() {

  function ImageRows(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return ImageRows;
})();

theme.ImageRows.prototype = _.assignIn({}, theme.ImageRows.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};

theme.ContentSliders = (function() {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMedium: theme.settings.mediaQuery.medium,
    mediaQueryLargeUp: theme.settings.mediaQuery.largeUp
  };

  function contentSliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.content-slider-wrap';
    var slider = this.slider = '#content-slider-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = {
      infinite: $slider.data('infinite'),
      prevArrow: slider + ' ~ .content-slider__prev',
      nextArrow: slider + ' ~ .content-slider__next',
      arrows: $slider.data('arrows'),
      dots: $slider.data('dots'),
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop'),
      slidesToScroll: $slider.data('slides-scroll-desktop'),
      rows: $slider.data('rows-desktop'),
      slidesPerRow: $slider.data('per-row-desktop')
    };

    var tabletOptions = $.extend({}, options, {
      slidesToShow: $slider.data('slides-show-tablet'),
      slidesToScroll: $slider.data('slides-scroll-tablet'),
      rows: $slider.data('rows-tablet'),
      slidesPerRow: $slider.data('per-row-tablet')
    });

    var mobileOptions = $.extend({}, options, {
      arrows: $slider.data('arrows-mobile'),
      dots: $slider.data('dots-mobile'),
      autoplay: $slider.data('autoplay-mobile'),
      slidesToShow: $slider.data('slides-show-mobile'),
      slidesToScroll: $slider.data('slides-scroll-mobile'),
      rows: $slider.data('rows-mobile'),
      slidesPerRow: $slider.data('per-row-mobile')
    });

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMedium, {
      match: function() {
        initSlider($slider, tabletOptions);
      }
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function() {
        initSlider($slider, options);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }

    $('.slideshow__video', wrapper).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });
  }

  contentSliders.prototype = _.assignIn({}, contentSliders.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return contentSliders;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.LatestBlogPosts = (function() {
  function LatestBlogPosts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return LatestBlogPosts;
})();

theme.LatestBlogPosts.prototype = _.assignIn({}, theme.LatestBlogPosts.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.ImageGallerySliders = (function() {
  function ImageGallerySliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

    var pswpElement = document.querySelectorAll('.pswp')[0];
    var galleryItems = [];

    $('.image-gallery-item__anchor:not(.slick-cloned .image-gallery-item__anchor)', slideshow).map(function(){
      var $this = $(this);
      var width = $this.data('width');

      galleryItems.push({
        src: $this.attr('href'),
        w: width,
        h: width / $this.data('aspect-ratio'),
      });
    });

    $('.image-gallery-item__anchor').on('click', function(evt){
      evt.preventDefault();

      var thumbnail = $(this).find('img')[0];

      var options = {
        index: $(this).data('index'),
        barsSize: { top:0, bottom:0 },
        captionEl: false,
        fullscreenEl: false,
        shareEl: false,
        bgOpacity: 0.96,
        tapToClose: true,
        tapToToggleControls: false,
        history: false,
        getThumbBoundsFn: function(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect(),
          thumbInfo = theme.utils.getImgSizeInfo(thumbnail);
          return {x: rect.left + thumbInfo.left, y: rect.top + pageYScroll, w: thumbInfo.width};
        }
      };

      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryItems, options);
      gallery.init();
    });
  }

  return ImageGallerySliders;
})();

theme.ImageGallerySliders.prototype = _.assignIn({}, theme.ImageGallerySliders.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};

theme.DashboardDynamicWelcome = (function() {

  var selectors = {
    title: '[data-dynamic-welcome-title]',
    message: '[data-dynamic-welcome]',
    data: '#dynamic-welcome-data'
  };

  function DashboardDynamicWelcome(container) {

    this.$container = $(container);
    this.$title = $(selectors.title);
    this.$message = $(selectors.message);
    this.data = JSON.parse($(selectors.data).html());

    if (!this.$message.length) {
      return;
    }

    var currentDate = new Date();
    var currentHour = currentDate.getHours();

    var message = 'Hello there';
    var timePeriod;
    var icon;

    if (currentHour < 4) {
      timePeriod = 'early_morning';
    } else if (currentHour >= 4 && currentHour < 12) {
      timePeriod = 'morning';
    } else if (currentHour >= 12 && currentHour < 17) {
      timePeriod = 'afternoon';
    } else if (currentHour >= 17 && currentHour < 18) {
      timePeriod = 'evening';
    } else {
      timePeriod = 'night';
    }

    message = this.data[timePeriod];
    icon = theme.utils.getTemplate('dynamic-welcome-icon-' + timePeriod);

    $(selectors.message).html(message);
    $(selectors.title).append(icon);

    this.$title.addClass('fade-in');

  }

  return DashboardDynamicWelcome;

})();
window.theme = window.theme || {};

theme.DashboardPlaceOrder = (function() {
  var selectors = {
    tabsGroup: '.tabs-group',
    tabContent: '[data-tab]',
    accountViewRight: '.account__view-right'
  };

  function DashboardPlaceOrder(container) {

    this.$container = $(container);

    this.$accountViewRight = $(selectors.accountViewRight);
    this.$accountViewRight.addClass('hidden');

    if (!this.$container.length) {
      return;
    }

    this.$tabsGroup = $(selectors.tabsGroup, this.$container);
    this.$tabs = $(selectors.tabContent, this.$container);

    var self = this;

    var activeTab = this.$tabs.length;

    if (window.location.href.indexOf('search') > -1) {
      activeTab = 1;
    }

    if (window.location.href.indexOf('cart') > -1) {
      activeTab = this.$tabs.length;
      this.$accountViewRight.removeClass('hidden');
    }

    if (window.location.href.indexOf('account') > -1) {
      activeTab = 1;
    }

    $.each(this.$tabsGroup, function(index, tabsGroup) {

      window.theme.tabsGroups[tabsGroup] = new theme.TabsGroup(tabsGroup, {
        breakpoint: 0,
        activeTab: activeTab
      });

      window.theme.tabsGroups[tabsGroup].$tabsGroup.on('tabChange', function(evt) {
        var title = $(self.$tabs[evt.tabIndex - 1]).data('tabTitle');
        if (title.toLowerCase() == 'my cart') {
          self.$accountViewRight.removeClass('hidden');
        } else {
          self.$accountViewRight.addClass('hidden');
        }
      });

      window.theme.tabsGroups[tabsGroup].$navContainer.addClass('swipeable').css('overflow-x', 'auto');

      var $cartTab = window.theme.tabsGroups[tabsGroup].$navContainer.children().filter(function() {
        return $(this).data("targetTitle") == 'My Cart';
      });

      var cartCountHtml = '<span rv-class-cart-count--even="cart.item_count_display | modulo 2 | eq 0" rv-class-cart-count--odd="cart.item_count_display | modulo 2 | eq 1" class="cart-count" rv-html="cart.item_count_display">{{ cart.item_count_display }}</span>';

      $cartTab.append(cartCountHtml);
      tinybind.bind($cartTab, {cart: CartJS.cart})

    });


  }

  return DashboardPlaceOrder;
})();
window.theme = window.theme || {};

theme.DashboardReports = (function() {

  var selectors = {
    dropdownButton: '[data-dropdown-button]',
    dropdownOptions: '[data-dropdown-options]'
  };

  function DashboardReports(container) {

    this.$container = $(container);
    this.data = {};

    this.ui = {
      active: {}
    };

    this._bindView();
    this._getReportsData();

  }

  DashboardReports.prototype = $.extend({}, DashboardReports.prototype, {

    _getReportsData: function() {
      var self = this;

      // TODO: Check SessionStorage

      $.ajax({
        url: '/account?view=dashboard-reports-json'
      }).done(function(data) {
        var dataJson = JSON.parse(data.replace(/<!--[\s\S]*?-->/g, ""));
        self.data.reports = dataJson;
        self.ui.loadComplete = true;

        if (!dataJson.reports.length) {
          return;
        }

        self.ui.active = {
          days: dataJson.reports[0].days,
          title: dataJson.reports[0].title
        };

        self._bindDropdown();
      });

    },

    _bindView: function() {
      var self = this;

      var $el = self.$container;
      tinybind.bind($el, {
        ui: self.ui,
        data: self.data,
        actions: {
          toggleDropdown: self._toggleDropdown.bind(self),
          openDropdown: self._openDropdown.bind(self),
          closeDropdown: self._closeDropdown.bind(self),
          changeActiveReport: self._changeActiveReport.bind(self)
        }
      });

    },

    _toggleDropdown: function() {
      var self = this;
      self.ui.showDropdown = !self.ui.showDropdown;
    },

    _openDropdown: function() {
      var self = this;
      self.ui.showDropdown = true;
    },

    _closeDropdown: function() {
      var self = this;
      self.ui.showDropdown = false;
    },

    _changeActiveReport: function() {
      var self = this;

      var $target = $(event.target);
      var reportDays = $target.attr('data-report-days');
      var reportTitle = $target.attr('data-report-title');

      self.ui.active = {
        days: parseInt(reportDays),
        title: reportTitle
      };

      self._closeDropdown();
    },

    _bindDropdown: function() {
      var self = this;

      var $button = $(selectors.dropdownButton, self.$container);
      var $options = $(selectors.dropdownOptions, self.$container);

      self.dropdown = new Popper($button[0], $options[0], {
        placement: 'bottom-end'
      });
    }

  });

  return DashboardReports;

})();
window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.ProductRelatedProducts = (function() {

  var selectors = {
    slideshow: '[data-slideshow]'
  };

  function ProductRelatedProducts(container) {

    this.$container = $(container);
    this.$slideshows = $(selectors.slideshow, this.$container);

    $.each(this.$slideshows, function(index, slideshow) {
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    });

  }

  return ProductRelatedProducts;

})();
window.theme = window.theme || {};

theme.ConstantCart = (function() {

  var selectors = {
    cart: '.cart-drawer__inner',
    constantContainer: '.constant-cart',
    drawerContainer: '#CartDrawer',
    accountViewRight: '.account__view-right'
  };

  var options = {
    breakpoint: 1330
  };

  var breakpoints = {
    desktop: 'screen and (min-width: ' + options.breakpoint + 'px)',
    mobile: 'screen and (max-width: ' + (options.breakpoint - 1) + 'px)'
  };

  function ConstantCart(container) {

    this.$container = $(container);
    this.$constantContainer = $(selectors.constantContainer, this.$container);
    this.$drawerContainer = $(selectors.drawerContainer);
    this.$cart = $(selectors.cart);
    this.$accountViewRight = this.$container.closest(selectors.accountViewRight);
    this.$stickyElement = this.$accountViewRight.children().first();

    var self = this;

    this.$stickyElement.stickybits({stickyBitStickyOffset: 40});

    enquire.register(breakpoints.mobile, {
      match: function() {
        self._makeDrawer();
      }
    });

    enquire.register(breakpoints.desktop, {
      match: function() {
        self._makeConstant();
      }
    });

  }

  ConstantCart.prototype = $.extend({}, ConstantCart.prototype, {

    _makeConstant: function() {
      this.$cart.detach();
      this.$constantContainer.append(this.$cart);

      $('body').addClass('cart-is-constant');
    },

    _makeDrawer: function() {
      this.$cart.detach();
      this.$drawerContainer.append(this.$cart);

      $('body').removeClass('cart-is-constant');

    }

  });

  return ConstantCart;

})();
window.theme = window.theme || {};

theme.StickySubNav = (function() {

  var selectors = {
    subNav: '.sticky-sub-nav'
  }

  var options = {
    stickybits: {}
  }

  function StickySubNav(container) {

      this.$container = $(container);

      this.$subNav = $(selectors.subNav).insertBefore(this.$container.parent());
      this.$subNav.stickybits(options.stickybits);
  }

  return StickySubNav;
})();

window.theme = window.theme || {};

theme.StoreLocator = (function() {

  var selectors = {
    storesDataContainer: 'script#store-locations',
    filtersDataContainer: 'script#store-location-filters',
    mapContainer: '#Map-'
  };

  var defaults = {
    map: {
      zoom: 6,
      center: {
        lat: -40.895021,
        lng: 170.5285246
      },
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true
    },
    rawDataType: 'json',
    googlePlacesFields: [
      'url',
    ],
    enableSearch: true
  };

  function StoreLocator(container) {

    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.mapContainer = document.querySelector(selectors.mapContainer + this.sectionId);

    if (!this.container) {
      return;
    }

    this.data = {
      parsedData: {},
      stores: [],
      groups: [],
      filters: [],
      tags: [],
      activeFilters: [],
      activeStore: null,
      activeGroup: null,
      storesInFilter: [],
      storesInView: [],
    };

    this.methods = {
      focusStore: this._focusStore.bind(this),
      zoomToFitMarkers: this._zoomToFitMarkers.bind(this),
      selectGroup: this._focusGroup.bind(this),
      selectFilter: this._focusFilter.bind(this),
      clearFilter: this._clearFilters.bind(this),
      findUser: this._findUser.bind(this),
    };

    this._prepareData();
    this._bindView();
    this._buildMap();

    if ("geolocation" in navigator) {
      this.data.geolocationEnabled = true;
    }

    this.data.is_ready = true;

  }

  StoreLocator.prototype = _.extend({}, StoreLocator.prototype, {

    _focusFilter: function(event) {

      var id,
          filter;

      id = event.currentTarget.dataset.filterId;
      filter = _.find(this.data.filters, {'id': id});

      if (!filter) {
        console.error(new Error('No filter found!'));
        return;
      }

      if (filter.active) {
        this._setActiveFilter(filter, 'remove');
      } else {
        this._setActiveFilter(filter, 'add');
      }

    },

    _setActiveFilter: function(filter, action, updateMap) {

      var self = this;

      // action = 'add', 'remove', 'replace', 'reset'

      if (!action) {
        console.error('An action must be defined');
        console.error('action = add, remove, replace, reset');
        return;
      }

      this._setActiveStore(false, false);

      switch(action) {

        case 'replace':

          _.each(this.data.activeFilters, function(filter) {
            filter.active = false;
          });

          this.data.activeFilters = [];

          filter.active = true;
          this.data.activeFilters.push(filter);
          break;

        case 'remove':

          filter.active = false;
          _.remove(this.data.activeFilters, {'id': filter.id});
          break;

        case 'add':

          filter.active = true;
          this.data.activeFilters.push(filter);
          break;

        case 'reset':

          _.each(this.data.activeFilters, function(filter) {
            filter.active = false;
          });

          this.data.activeFilters = [];
          break;

      }

      _.each(this.data.stores, function(store, i) {
        var storeInFilter = true;

        _.each(self.data.activeFilters, function(filter) {

          if (!store.tags || store.tags.indexOf(filter.tag) == -1) {
            storeInFilter = false;
          }

        });

        if (storeInFilter) {
          self._addStoreToFilter(store);
        } else {
          self._removeStoreFromFilter(store);
        }

      });

      if (self.data.activeFilters.length == 0) {
        this.data.storesAreFiltered = false;
      } else {
        this.data.storesAreFiltered = true;
      }

      this._getMarkersInView();

      this._toggleFiltersNoResultsMessage();

    },

    _toggleFiltersNoResultsMessage: function() {

      if (this.data.storesAreFiltered && this.data.storesInFilter.length == 0) {
        this.data.filterNoResults = true;
      } else {
        this.data.filterNoResults = false;
      }

    },

    _clearFilters: function() {
      this._setActiveFilter(false, 'reset');
    },

    _addStoreToFilter: function(store) {

      if (store.in_filter == true) {
        return;
      }

      store.in_filter = true;
      store.marker.setMap(this.map);
      store.markerCluster.addMarker(store.marker);
      store.markerCluster.redraw();

      this.data.storesInFilter.push(store);

    },

    _removeStoreFromFilter: function(store) {rules

      if (store.in_filter == false) {
        return;
      }

      store.in_filter = false;
      store.markerCluster.removeMarker(store.marker);
      store.marker.setMap(null);
      store.markerCluster.redraw();

      _.pull(this.data.storesInFilter, store);

    },

    _focusStore: function() {

      var id,
          store;

      id = event.currentTarget.dataset.storeId;
      store = _.find(this.data.stores, {'id': id});

      if (!store) {
        console.error(new Error('No store found!'));
        return;
      }

      // If a link is cliked, only follow the link if the store is active
      if (event.target && event.target.nodeName == 'A') {
        if (store.active) {
          return;
        } else {
          event.preventDefault();
        }
      }

      this._setActiveStore(store);

    },

    _setActiveStore: function(store, updateMap) {

      var self = this;

      var marker,
          markerPosition,
          activeStore,
          currentMapBounds,
          currentMapZoom,
          boundsContainsMarker;

      activeStore = this.data.activeStore;

      if (activeStore) {
        activeStore.active = false;

        if (activeStore.infoWindow) {
          activeStore.infoWindow.close();
        }

      }

      if (store == false) {
        this.data.activeStore = null;
        return;
      }

      if (updateMap != false) {

        marker = store.marker;

        markerPosition = marker.getPosition();
        currentMapBounds = this.map.getBounds();
        boundsContainsMarker =  currentMapBounds.contains(markerPosition);
        currentMapZoom = this.map.getZoom();

        if (!boundsContainsMarker || currentMapZoom < 12) {
          this.map.panTo(markerPosition);
          this.map.setZoom(14);
        }

      }

      if (store.group) {
        this._setActiveGroup(store.group, false);
      }

      this.data.activeStore = store;
      store.active = true;

      if (store.place_id && !store.place && !store.is_loading) {
        this._fetchStoreDetails(store, function() {
          self._openStoreInfoWindow(store);
        });
      } else {
        self._openStoreInfoWindow(store);
      }

    },

    _fetchStoreDetails: function(store, callback) {

      var request;

      store.is_loading = true;

      request = {
        placeId: store.place_id,
        fields: defaults.googlePlacesFields
      };

      function formatOpeningHours(periods) {
        // Formats opening hours provided by Google Places API

        var days,
            dayNames,
            dayIndex,
            dayTitle,
            daysString,
            openAmPm,
            openHours,
            openMinutes,
            openTime,
            closeAmPm,
            closeHours,
            closeMinutes,
            closeTime,
            timesString;

        days = [];
        dayNames = ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'];

        _.each(periods, function(period) {

          dayIndex = period.open.day;
          dayTitle = dayNames[dayIndex];

          openAmPm = (period.open.hours < 12 ? 'am' : 'pm');
          openHours = (period.open.hours < 12 ? period.open.hours : period.open.hours - 12);
          openMinutes = (period.open.minutes ? ':' + period.open.minutes : '');
          openTime = openHours + openMinutes + openAmPm;

          closeAmPm = (period.close.hours < 12 ? 'am' : 'pm');
          closeHours = (period.close.hours < 12 ? period.close.hours : period.close.hours - 12);
          closeMinutes = (period.close.minutes ? ':' + period.close.minutes : '');
          closeTime = closeHours + closeMinutes + closeAmPm;

          timesString = openTime + ' - ' + closeTime;

          daysString = dayTitle;

          function TimePeriod(options) {
            _.extend(this, options);
          }

          days.push(new TimePeriod({
            startDay: dayTitle,
            endDay: dayTitle,
            daysString: daysString,
            timesString: timesString,
            open: openTime,
            close: closeTime,
          }));

        });

        _.each(days, function(day, i) {
          var nextDay;

          nextDay = days[i + 1];

          if (nextDay && day.timesString == nextDay.timesString) {
            nextDay.startDay = day.startDay;
            nextDay.daysString = nextDay.startDay + ' - ' + nextDay.endDay;
            day.toDelete = true;
          }

        });

        _.remove(days, {'toDelete': true});

        return days;

      }

      this.placesService.getDetails(request, function(place, status) {

        if (status === google.maps.places.PlacesServiceStatus.OK) {

          store.place = place;

          store.google_url = place.url;

          store.is_loading = false;

          if (callback && typeof callback == 'function') {
            callback();
          }

        } else {
          console.error(new Error('Error receiving data from Places service'));

          if (callback && typeof callback == 'function') {
            callback();
          }
        }

      });

    },

    _openStoreInfoWindow: function(store) {

      var self = this;

      var marker;

      marker = store.marker;

      if (!store.infoWindow) {
        store.infoWindowContent = document.createElement('div');
        store.infoWindowContent.innerHTML = theme.utils.getTemplate('store-location-info-popup');

        tinybind.bind(store.infoWindowContent, {
          store: store
        });

        store.infoWindow = new google.maps.InfoWindow({
          content: store.infoWindowContent,
        });
      }

      store.infoWindow.open(self.map, store.marker);

    },

    _focusGroup: function(event) {

      var id,
          group;

      id = event.currentTarget.value;

      if (id == '' || id =='none') {
        this._setActiveGroup(false);
        return;
      }

      group = _.find(this.data.groups, {'id': id});

      if (!group) {
        console.error(new Error('No group found!'));
        return;
      }

      this._setActiveGroup(group);

    },

    _setActiveGroup: function(group, updateMap) {

      var self = this;

      var center,
          address,
          markerPosition,
          activeGroup;

      activeGroup = this.data.activeGroup;
      if (activeGroup) {
        activeGroup.active = false;
      }

      if (group == false) {
        this.data.activeGroup = null;
        this._zoomToFitMarkers();
        this._setActiveStore(false, false);
        return;
      }

      this.data.activeGroup = group;
      group.active = true;

      if (updateMap == false) {
        return;
      }

      this._setActiveStore(false, false);

      if (group.markers.length > 1) {

        bounds = new google.maps.LatLngBounds();

        _.each(group.markers, function(marker, i) {
          bounds.extend(marker.getPosition());
        });

        self.map.fitBounds(bounds);

      } else {

        markerPosition = group.markers[0].getPosition();

        this.map.panTo(markerPosition);
        this.map.setZoom(14);

      }


    },

    _prepareData: function() {

      var self = this;

      this._getData(processData);

      function processData() {
        self._prepareStoresData();
        self._prepareStoresTagsData();
        self._prepareGroupsData();
        self._prepareFiltersData();
      }

    },

    _getData: function(callback) {

      var dataContainer,
          rawData,
          parsedData,
          parseOptions,
          rawDataType;

      dataContainer = document.querySelector(selectors.storesDataContainer);

      rawDataType = defaults.rawDataType;

      if (!dataContainer) {
        console.error(new Error('Missing data container'));
        return;
      }

      rawData = dataContainer.innerHTML;

      switch(rawDataType) {

        case 'json':

          this.data.parsedData.data = JSON.parse(rawData);
          callback();
          return;

        case 'csv':

          parseOptions = {
            header: true,
            dynamicTyping: true
          };

          this.data.parsedData = Papa.parse(rawData, parseOptions);
          callback();
          return;

        default:

          this.data.parsedData.data = rawData;
          callback();
          return;

      }

    },

    _prepareStoresData: function() {

      var self = this;

      var locationMarkerSVG,
          googleMapsSearchURLPrefix;

      locationMarkerSVG = theme.utils.getTemplate('store-location-marker-icon');
      googleMapsSearchURLPrefix = 'https://www.google.com/maps/search/';

      function Store(data) {

        _.extend(this, data);

        this.id = theme.utils.handleize(this.title);
        this.icon = locationMarkerSVG;
        this.google_url = googleMapsSearchURLPrefix + theme.utils.handleize(this.title).replace(/\-/g, '+') + '+' + theme.utils.handleize(this.street).replace(/\-/g, '+');
        this.opening_hours = _.map(this.opening_hours.split(/,/), function(period) {
          return _.map(period.replace(/:/, '#').split(/#/), _.trim);
        });
      }

      if (self.data.parsedData.errors && self.data.parsedData.errors.length > 0) {
        console.error(new Error('There was an error parsing data'));
        console.error(data.parsedData.errors);
        return;
      }

      _.each(self.data.parsedData.data, function(value) {

        var store,
            locationData,
            existingArea;

        // Build store data
        store = new Store(value);
        self.data.stores.push(store);

      });

      // Sort stores by title
      self.data.stores = _.orderBy(self.data.stores, ['title'], ['city'], ['street']);

    },

    _prepareStoresTagsData: function() {

      var self = this;

      function Tag(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(this.data.stores, function(store, i) {
        var existingTag,
            tagString,
            tags;

        if (store.tags && typeof store.tags == 'string') {

          tags = store.tags.split(',');

          store.tags = [];

          _.each(tags, function(tagString) {

            tagString = theme.utils.handleize(tagString);

            existingTag = _.find(self.data.tags, {'title': tagString });

            if (!existingTag) {

              tag = new Tag({ title: tagString });
              self.data.tags.push(tag);


            } else {
              tag = existingTag;
            }

            store.tags.push(tag);

          });

        }

      });

    },

    _prepareGroupsData: function() {

      var self = this;

      function Group(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(this.data.stores, function(store, i) {
        var locationData,
            existingGroup;

        if (store.group && typeof store.group == 'string') {

          existingGroup = _.find(self.data.groups, {'title': store.group });

          if (!existingGroup) {
            locationData = {
              title: store.group
            };

            group = new Group(locationData);
            self.data.groups.push(group);
            group.stores = [];

          } else {
            group = existingGroup;
          }

          store.group = group;

          group.stores.push(store);

        }

      });

    },

    _prepareFiltersData: function() {

      var self = this;

      var dataContainer,
          rawData,
          jsonData;

      dataContainer = document.querySelector(selectors.filtersDataContainer);

      if (!dataContainer) {
        console.error(new Error('Missing data container'));
        return;
      }

      rawData = dataContainer.innerHTML;
      jsonData = JSON.parse(rawData);

      function Filter(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(jsonData, function(value) {
        var filter,
            tag;

        value.tag = _.find(self.data.tags, {'title': value.tag });

        if (value.tag) {
          value.tag.icon = value.icon;
        }

        filter = new Filter(value);
        self.data.filters.push(filter);

      });

    },

    _bindView: function() {

      tinybind.bind(this.container, {
        data: this.data,
        methods: this.methods
      });

    },

    _buildMap: function() {

      var self = this;

      var googleMapsAPIURL,
          googleMapsAPIKEY,
          googleMapsAdditionalLibraries;

      googleMapsAPIURL = 'https://maps.googleapis.com/maps/api/js?key=';
      googleMapsAPIKEY = shop.keys.googleMaps;
      googleMapsAdditionalLibraries = '&libraries=places';

      if (!googleMapsAPIKEY) {
        return console.error(new Error('Google Maps API key is required. You can set this up as as Store metafield: '))
      }

      var options = defaults.map;

      function initMap() {
        self.geocoder = new google.maps.Geocoder();
        self.map = new google.maps.Map(self.mapContainer, options);
        self.placesService = new google.maps.places.PlacesService(self.map);
        self._addMapMarkers();

        if (defaults.enableSearch) {
          self._prepareSearch();
        }
      }

      loadJS(googleMapsAPIURL + googleMapsAPIKEY + googleMapsAdditionalLibraries, initMap);

    },

    _addMapMarkers: function() {

      var self = this;

      _.each(this.data.stores, function(store, i) {
        var position,
            icon;

        position = {
          'lat': store.lat,
          'lng': store.long
        };

        icon = store.icon;

        store.marker = new google.maps.Marker({
          position: position,
          map: self.map,
          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(28, 40),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(14, 40),
            scaledSize: new google.maps.Size(28, 40)
          },
          optimized: false
        });

        if (store.group) {
          store.group.markers = store.group.markers || [];
          store.group.markers.push(store.marker);
        }

        store.marker.addListener('click', function() {
          self._setActiveStore(store);
        });
      });

      this._clusterMarkers();
      this._zoomToFitMarkers();
      this._bindMapListners();

    },

    _clusterMarkers: function() {
      var self = this;

      var clusterMarkerSVG = theme.utils.getTemplate('store-location-marker-icon');

      _.each(this.data.groups, function(group, i) {

        var clusterStyles = [
          {
            width: 28,
            height: 40,
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(clusterMarkerSVG),
            textColor: 'transparent',
            textSize: 0,
            iconAnchor: [50, 100],
          }
        ];

        group.markerCluster = new MarkerClusterer(self.map, group.markers, {
          gridSize: 30,
          styles: clusterStyles,
          zoomOnClick: true,
        });

        _.each(group.stores, function(store) {
          store.markerCluster = group.markerCluster;
        });

      });

    },

    _zoomToFitMarkers: function() {

      var bounds = new google.maps.LatLngBounds();

      _.each(this.data.stores, function(store, i) {
        bounds.extend(store.marker.getPosition());
      });

      this.map.fitBounds(bounds);

    },

    _bindMapListners: function() {

      var self = this;

      this.map.addListener('bounds_changed', _.debounce(this._getMarkersInView.bind(self), 50));

    },

    _unbindMapListners: function() {

      var self = this;

      google.maps.event.clearListeners(this.map, 'bounds_changed');

    },

    _getMarkersInView: function() {

      var self = this;

      this.data.storesInView = [];
      this.data.storesInActiveGroup = [];

      var bounds = this.map.getBounds();

      _.each(this.data.stores, function(store, i) {
        var markerPosition,
            boundsContainsMarker;

        markerPosition = store.marker.getPosition();
        boundsContainsMarker =  bounds.contains(markerPosition);

        if (boundsContainsMarker && (!self.data.storesAreFiltered || self.data.storesAreFiltered && store.in_filter)) {
          store.in_view = true;
          self.data.storesInView.push(store);
        } else {
          store.in_view = false;
        }

        if (store.group == self.data.activeGroup) {
          store.in_active_group = true;
          self.data.storesInActiveGroup.push(store);
        } else {
           store.in_active_group = false;
        }

      });

      if (this.data.storesInView && this.data.storesInView.length == 1) {
        var store = this.data.storesInView[0];

        if (store != self.data.activeStore) {
          this._setActiveStore(store, false);
        }

      }

    },

    _findUser: function() {

      var self = this;

      this.data.geolocationLoading = true;

      function success(position) {
        var pos;

        pos = {
          lat: position.coords.latitude,
          long: position.coords.longitude
        };

        userLocation = new google.maps.LatLng(pos.lat, pos.long);

        self._updateUserMarker(userLocation);

        self._findClosestStore(userLocation);
        self.data.geolocationLoading = false;
      }

      function error() {

        self.data.geolocationLoading = false;
        self.data.geolocationEnabled = false;

        iziToast.error({
          title: 'We couldn\'t find your location',
          position: 'bottomCenter',
          theme: 'light',
        });

      }

      navigator.geolocation.getCurrentPosition(success, error);

    },

    _findClosestStore: function(latLng) {

      var self = this;

      var closestStore,
          bounds,
          userLocation;

      bounds = new google.maps.LatLngBounds();

      closestStore = getClosestStore(latLng);

      self._setActiveStore(closestStore, false);

      bounds.extend(closestStore.marker.getPosition());
      bounds.extend(latLng);

      self.map.fitBounds(bounds);

      function getClosestStore(latLng) {

        // https://stackoverflow.com/questions/4057665/google-maps-api-v3-find-nearest-markers
        var lat = latLng.lat();
        var long = latLng.lng();
        var R = 6371; // radius of earth in km
        var distances = [];
        var closest = -1;

        var closestStore = null;

        function rad(x) {return x*Math.PI/180;}

        _.each(self.data.stores, function(store, i) {

            var mlat = store.lat;
            var mlng = store.long;

            var dLat  = rad(mlat - lat);
            var dLong = rad(mlng - long);
            var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            var d = R * c;
            distances[i] = d;

            if ( closest == -1 || d < distances[closest] ) {
                closest = i;
                closestStore = store;
            }

        });

        return closestStore;

      }

    },

    _updateUserMarker: function(latLng) {

      var self = this;

      var pos,
          icon,
          user,
          locationMarkerSVG;

      if (!latLng) {
        console.error(new Error('latLng must be defined'));
        return;
      }

      function User(data) {
        _.extend(this, data);
      }

      if (!this.data.user) {

        locationMarkerSVG = theme.utils.getTemplate('user-location-marker-icon');
        this.data.user = new User({
          icon: locationMarkerSVG
        });

      }

      user = this.data.user;

      user.latLng = latLng;

      if (!user.marker) {
        icon = user.icon;

        user.marker = new google.maps.Marker({
          position: user.latLng,
          map: self.map,

          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 12),
            scaledSize: new google.maps.Size(24, 24)
          },

          optimized: false

        });

      } else {

        user.marker.setPosition(user.latLng);

      }

    },

    _prepareSearch: function() {

      this.data.searchEnabled = true;

      var self = this;


      var searchField;

      // If the search box breaks it is because we are
      // using TinyBind but searching for the input field
      // with an ID. Perhaps use a tinybind binder to
      // reference the input field.
      searchField = document.getElementById('store-locator-search')

      this.autocomplete = new google.maps.places.Autocomplete(searchField);

      // #todo: Autocomplete.setFields()

      this.autocomplete.addListener('place_changed', function() {

        var place;

        place = self.autocomplete.getPlace();

        if (!place.geometry) {

          iziToast.error({
            title: 'We couldn\'t find this location',
            position: 'bottomCenter',
            theme: 'light',
          });

          return;
        }

        self._findClosestStore(place.geometry.location);
        self._updateSearchMarker(place.geometry.location);

      });
    },

    _updateSearchMarker: function(latLng) {

      var self = this;

      var pos,
          icon,
          locationMarkerSVG;

      if (!latLng) {
        console.error(new Error('latLng must be defined'));
        return;
      }

      function Search(data) {
        _.extend(this, data);
      }

      if (!this.data.search) {

        locationMarkerSVG = theme.utils.getTemplate('search-location-marker-icon');
        this.data.search = new Search({
          icon: locationMarkerSVG
        });

      }

      search = this.data.search;
      search.latLng = latLng;

      if (!search.marker) {

        icon = search.icon;

        search.marker = new google.maps.Marker({
          position: search.latLng,
          map: self.map,

          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 12),
            scaledSize: new google.maps.Size(24, 24)
          },

          optimized: false

        });

      } else {

        search.marker.setPosition(search.latLng);

      }

    },


  });

  return StoreLocator;

})();
window.theme = window.theme || {};

theme.Releases = (function() {

    var selectors = {
        slideshow: '.releases__cards-slides-container',
        nextArrow: '.releases__next',
        prevArrow: '.releases__prev',
        card: '.releases__card-container',
        shopNowLink: '.card__link-container',
        dropdowns: '.release__card-dropdown-container'
    };

    var self = this;
    function releases(container) {
        var $container = this.$container = $(container);
        this.slickSlider = this._initSlick();
        this._initEventListeners();
        this._setTodaysRelease();
    }

    releases.prototype = _.assignIn({}, releases.prototype, {
        _initSlick: function() {
            this.$slideshows = $(selectors.slideshow, this.$container);
            var slickSlider = $(this.$slideshows).slick({
                arrows: false,
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                nextArrow: selectors.nextArrow,
                prevArrow: selectors.prevArrow,
                accessibility: true,
                adaptiveHeight: true,
                responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 3.5,
                        slidesToScroll: 1,
                        arrows: true
                      }
                    },
                    {
                      breakpoint: 900,
                      settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1,
                        arrows: true
                      }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 1.5,
                          slidesToScroll: 1,
                          arrows: true
                        }
                    }
                ]
            });
            return slickSlider;
        },

        _setTodaysRelease: function() {
            var today = ((new Date()).getDay())-1;
            this._setActiveCard(today);
            $(selectors.shopNowLink, selectors.card + '[data-release-index='+today+']').addClass('active')
        },

        _initEventListeners: function() {
            $(selectors.card).on('click', this._changeActiveCard.bind(this))
        },

        _setActiveCard(cardNo) {
            $(selectors.card).removeClass('active');
            $(selectors.card + '[data-release-index="'+cardNo+'"]').addClass('active')

            $(selectors.dropdowns).removeClass('active');
            $(selectors.dropdowns + '[data-release-dropdown-index="'+cardNo+'"]').addClass('active')

            this.slickSlider.slick('slickGoTo', cardNo)
        },

        _changeActiveCard: function() {
            $currentCard = $(event.currentTarget)
            var clicked = $currentCard.data('release-index')
            this._setActiveCard(clicked);
        }
    });

  return releases;
})();

window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.RelatedItems = (function() {

  var selectors = {
    slideshow: '[data-slideshow]'
  };

  function RelatedItems(container) {

    this.$container = $(container);
    this.$slideshows = $(selectors.slideshow, this.$container);

    $.each(this.$slideshows, function(index, slideshow) {
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    });

  }

  return RelatedItems;

})();

theme.PageReview = (function() {
  var selectors = {
    reviewDataContainer: 'script#js-page-review'
  };

  function PageReview(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;

    if (!this.container) {
      return;
    }

    this.data = {
      parsedData: {},
      reviews: []
    };

    this._prepareData();
    this._bindView();

    this.data.is_ready = true;

    $('.review-slider').on('init', function(event, slick, currentSlide, nextSlide){
      setHeight();
    });
    var reviewSlide = new theme.Slideshow($('.review-slider'));
    $('.review-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      setHeight();
    });

    function setHeight() {
      var mostHeight = 0;
      $('.review-slider .slick-active .review-block').each(function(index) {
        var length = $('.review-slider .slick-active').length;
        if (length > 1) {
          if (mostHeight < $(this).outerHeight()) {
            mostHeight = Math.ceil($(this).outerHeight());
          }
          if (index === (length - 1)) {
            $('.review-slider .slick-track').height(mostHeight+2);
          }
        }
      })
    }

  }

  PageReview.prototype = _.extend({}, PageReview.prototype, {
    _prepareData: function() {

      var self = this;

      this._getData(processData);

      function processData() {
        self._prepareStoresData();
      }

    },

    _getData: function(callback) {

      var dataContainer,
          rawData,
          parsedData,
          parseOptions,
          rawDataType;

      dataContainer = document.querySelector(selectors.reviewDataContainer);

      rawDataType = 'json';

      if (!dataContainer) {
        console.error(new Error('Missing data container'));
        return;
      }

      rawData = dataContainer.innerHTML;

      switch(rawDataType) {

        case 'json':

          this.data.parsedData.data = JSON.parse(rawData);
          callback();
          return;

        case 'csv':

          parseOptions = {
            header: true,
            dynamicTyping: true
          };

          this.data.parsedData = Papa.parse(rawData, parseOptions);
          callback();
          return;

        default:

          this.data.parsedData.data = rawData;
          callback();
          return;

      }

    },

    _prepareStoresData: function() {

      var self = this;

      function Review(data) {

        _.extend(this, data);
      }

      if (self.data.parsedData.errors && self.data.parsedData.errors.length > 0) {
        console.error(new Error('There was an error parsing data'));
        console.error(data.parsedData.errors);
        return;
      }

      _.each(self.data.parsedData.data, function(value) {

        var review,
            locationData,
            existingArea;

        // Build page data
        review = new Review(value);
        self.data.reviews.push(review);

      });

      // Sort reviews by priority
      self.data.reviews = _.orderBy(self.data.reviews, ['order_of_priority']);

    },

    _bindView: function() {

      tinybind.bind(this.container, {
        data: this.data
      });

    },
  });

  return PageReview;
})();
window.theme = window.theme || {};

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if ($newAddressForm.length) {

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {

  var config = {
    recoverPasswordForm: '#RecoverPassword',
    newCustomerForm: '#NewCustomer',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
    HideNewCustomerLink: '#HideNewCustomerLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();
  newCustomerSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  $(config.newCustomerForm).on('click', onShowHideNewCustomerForm);
  $(config.HideNewCustomerLink).on('click', onShowHideNewCustomerForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();

    if (!$('#RecoverEmail').val()) {
      var enteredEmail = $('#CustomerEmail').val();
      $('#RecoverEmail').val(enteredEmail);
    }

    toggleRecoverPasswordForm();
  }

  function onShowHideNewCustomerForm(evt) {
    evt.preventDefault();

    if (!$('#CreateEmail').val()) {
      var enteredEmail = $('#CustomerEmail').val();
      $('#CreateEmail').val(enteredEmail);
    }

    toggleNewCustomerForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }

    if (hash === '#create') {
      toggleNewCustomerForm();
    }

  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  function toggleNewCustomerForm() {
    $('#NewCustomerForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  function newCustomerSuccess() {
    var $formState = $('.new-customer-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#NewCustomerSuccess').removeClass('hide');
  }
})();


theme.currencyPicker = (function() {
  document.addEventListener('easylocation_render', function() { init()} )

  function init() {
    var locationData = window.easylocation.locationData;
    var selectors = {
      closeModal: '.currency-modal__close',
      modalContainer: '.currency-popup__container',
      currencyOption: '.currency-popup__container .option',
    }
    var cookieCurrency = $.cookie('countryCurrencySelected');
    var countriesWithCurrencies = ['US', 'AU', 'NZ'];
    if ($(selectors.modalContainer).length) {

      $(selectors.closeModal).on('click', function(event) { $(selectors.modalContainer).removeClass('open') });
      $(selectors.currencyOption).on('click', selectCurrency);

      if(!cookieCurrency && countriesWithCurrencies.indexOf(locationData.country.iso_code) < 0) {
        $(selectors.modalContainer).addClass('open');
      }
    }

    function selectCurrency(event) {
      var selectedCurrency = $(event.target).closest("[data-currency]").data('currency').toUpperCase();
      setStoreCurrency(selectedCurrency);
      console.log(selectedCurrency);
      event.target.form.submit();
    }

    function setStoreCurrency(selectedCurrency) {
      Currency.cookie.write(selectedCurrency);
      Currency.currentCurrency = selectedCurrency;
      $('.currency-picker').val(selectedCurrency.toString())
      $.cookie('countryCurrencySelected', true);
    }
  }

})();

window.theme = window.theme || {};

theme.RegisterPage = (function() {
  var selectors = {
    registerPage: '.register-page',
  };

  if (!$(selectors.registerPage).length) {
    return;
  }

  var validateABN = function(abn) {
    var isValid = true;
    abn = abn.replace(/[^0-9]/g, '');
    isValid &= abn && /^\d{11}$/.test(abn);

    if(isValid){
      var weightedSum = 0;
      var weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
      for (var i = 0; i < weight.length; i++) {
        weightedSum += (parseInt(abn[i]) - ((i === 0) ? 1 : 0)) * weight[i];
      }
      isValid &= ((weightedSum % 89) === 0);
    }

    return isValid;
  };

  var abnField = document.getElementById('CustomerFormABN');
  if (abnField !== undefined && abnField !== null) {
    abnField.addEventListener('input', function (event) {
      if (abnField.validity.typeMismatch || validateABN(abnField.value) != true) {
        abnField.setCustomValidity('Please enter a valid ABN.');
      } else {
        abnField.setCustomValidity('');
      }
    });
  }

  if ($('#CustomerFormCustomerType').length) {
    updateRegisterFormFields($('#CustomerFormCustomerType').val());

    $('#CustomerFormCustomerType').on('change', function(){
      updateRegisterFormFields($(this).val());
    });
  }

  $('.form-element--product-interest label:last-child input').on('change', function() {
    $('.form-element--product-interest label input').not(this).prop('checked', this.checked);
  });

  $('.form-element--product-interest label:not(:last-child) input').on('change', function() {
    $('.form-element--product-interest label:last-child input').prop('checked', false);
  });

  function updateRegisterFormFields(selector) {
    var activeGroup = theme.utils.handleize(selector);
    var activeSelector = '.form-element--' + activeGroup;

    $('.form-element--toggles').not(activeSelector).hide();
    $('.form-element--toggles').not(activeSelector).removeClass('form-element--visible');
    $('.form-element--toggles').not(activeSelector).prop('disabled', true);

    $(activeSelector).show();
    $(activeSelector).addClass('form-element--visible');
    $(activeSelector).prop('disabled', false);

    $('input[name="tags"]').val(activeGroup);
  };

})();

window.theme = window.theme || {};

theme.Password = (function() {
  var selectors = {
    passwordPage: '.password-page',
    loginModal: '#LoginModal',
    focusOnOpen: '#Password'
  };

  if (!$(selectors.passwordPage).length) {
    return;
  }

  initModal();

  function initModal() {

    var $loginModal = $(selectors.loginModal);

    if (!$loginModal.length) {
      return;
    }

    var passwordModal = new theme.Modals(selectors.loginModal, 'login-modal', {
      focusOnOpen: selectors.focusOnOpen
    });

    // Open modal if errors exist
    if ($loginModal.find('.errors').length) {
      passwordModal.open();
    }

  }
})();

(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });

})();

window.theme = window.theme || {};

theme.CollectionBundleBuilder = (function() {
  var cache = {};

  var selectors = {

  };

  const bildYourBundleVariantId = 32892276473959;

  function CollectionBundleBuilder(container) {
    this.$container = $(container);
    window.openBundleQuickView = this.openQuickView
    if (!this.$container.length) {
      return;
    }
    this.data = {
      selectedBundle: {
        products: []
      }
    }

    this.data.selectedBundle = this.loadSelectedBundle();
    $(document).on('click', '.btn--add-to-bundle', this.addItemToBundle.bind(this))
    $(document).on('click', '.btn--add-bundle-to-cart', this.addBundleToCart.bind(this))
    $(document).on('click', '.btn--quick-view', this.openQuickView.bind(this))
    $("#quick-view-bundle-modal .backdrop, #quick-view-bundle-modal .close").on('click', this.closeQuickView.bind(this))
    $(document).on('click', '.btn--remove-from-bundle', this.removeItemFromBundle.bind(this))
    this.bind();

    this.initSlider();
  }

  CollectionBundleBuilder.prototype = $.extend({}, CollectionBundleBuilder.prototype, {
    
    loadSelectedBundle: function(){
      var self = this;

      var data = localStorage.getItem('selectedBundle');
      var selectedBundle = JSON.parse(data);
      if(!selectedBundle) selectedBundle = {
        products: []
      }
      return selectedBundle;
    },

    addBundleToCart: function() {
      const currentTimestamp = new Date().getTime();
      const totalQuantity = this.data.selectedBundle.products.reduce((acc, currVal) => { return acc + currVal.quantity}, 0) + 1;
      const bundleItem = {
        id: bildYourBundleVariantId,
        quantity: 1,
        properties: {
          ...(this.data.selectedBundle.products.reduce((acc, currVal) => {
            if(acc[currVal.title]) {
              return { ...acc, [currVal.title]: acc[currVal.title] + currVal.quantity }
            } else {
              return { ...acc, [currVal.title]: currVal.quantity }
            }
          }, {})),
          _bundleQuan: totalQuantity,
          ...(totalQuantity >= 3 ? {_propId: "87166861679"} : {}),
          _optionGroup: `bundle:build-your-own-bundle:${currentTimestamp}`
        }
      }
      var uniqueVariants = [...new Set(this.data.selectedBundle.products.map(p => p.variant_id))];
      var self = this;
      const bundleProducts = uniqueVariants.map(variant_id => {
        const tot = self.data.selectedBundle.products
                      .filter(p => p.variant_id === variant_id)
                      .reduce((acc, currVal) => { return acc + currVal.quantity}, 0);
        return {
          quantity: tot,
          id: variant_id,
          properties: {
            Bundle: "BUILD YOUR OWN BUNDLE",
            _hidden: "true",
            _bundleQuan: totalQuantity,
            _optionGroup: `bundle:build-your-own-bundle:${currentTimestamp}`,
            ...(totalQuantity >= 3 ? {_propId: "87166861679"} : {})
          }
        }
      })
      const items = [
        bundleItem,
        ...bundleProducts
      ]
      $.post('/cart/add.js', {
        items: items
      }).done(function(data) {
        console.log('finished', data);
        CartJS.getCart().then(res => {
          theme.drawers.CartDrawer.open();
        })
      }).catch(function(error) {
        if(error.responseText) {
          var errorJson = JSON.parse(error.responseText);
          console.log(errorJson);
          if(errorJson.description) {
            iziToast.show({
              message: errorJson.description,
              color: 'red',
              position: 'bottomCenter'
            });
          }
        }
      });
    },

    openQuickView: function(event){
      event.preventDefault();
      event.stopPropagation();
      var itemHandle = $(event.target).attr("data-bundle-handle");
      if(!itemHandle) itemHandle = $(event.target).closest("button").attr("data-bundle-handle");
      fetch(`/products/${itemHandle}?view=bundle-quick-view`)
        .then(res => res.text())
        .then(html => {
          console.log(html);
          const productHtml = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-single').outerHTML;
          $("#quick-view-bundle-modal .product-container").html(productHtml);
          new theme.SimpleAccordion(".product-single__details-accordion");
          theme.current.product = JSON.parse($("#quick-view-bundle-modal [data-product-json]").html())
          new theme.Product(".product-container")
          $("#quick-view-bundle-modal").addClass("open")
        })
    },

    closeQuickView: function(event){
      event.preventDefault();
      event.stopPropagation();
      $("#quick-view-bundle-modal").removeClass("open")
    },

    initSlider: function(initialSlide) {
      var currentSliderHtml = $(".bundle-products-slider-template").html();
      $(".bundle-products-slider").removeClass("slick-slider").removeClass("slick-initialized").html(currentSliderHtml);
      this.slider = $(".bundle-products-slider").slick({
        slidesToShow: isMobile.any ? 1 : 3,
        infinite: false,
        variableWidth: true,
        nextArrow: `<button class="slick-arrow--next"><svg fill="none" viewBox="0 0 10 18"> <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m1.13408 1.13409 7.73183 8.00349-7.73183 7.99652"/></svg></button>`,
        prevArrow: `<button class="slick-arrow--prev"><svg fill="none" viewBox="0 0 10 18"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.86592 16.8659 1.13409 8.86242 8.86592.865906"/></svg></button>`,
        ...(initialSlide && initialSlide > 3 ? {initialSlide} : {})
      });
    },

    removeItemFromBundle: function(event){
      const productIndex = $(event.target).attr("data-bundle-index");
      this.data.selectedBundle.products.splice(productIndex, 1);
      localStorage.setItem('selectedBundle', JSON.stringify(this.data.selectedBundle));
      this.initSlider(productIndex - 2);
    },
    addItemToBundle: function(event) {
      console.log('addding item')
      event.preventDefault();
      event.stopPropagation();
      var quantity = 1;
      const quantitySelector = $(event.target).closest("form").find('[name="quantity"]');
      if(quantitySelector.length) { quantity = quantitySelector.val() }

      const itemHandle = $(event.target).attr("data-bundle-handle");
      const product = theme.current.collection.products.find(prod => prod.handle === itemHandle);
      const bundleProduct = {
        vendor: product.vendor,
        title: product.title,
        price: product.price * quantity,
        id: product.id,
        variant_id: product.selected_or_first_available_variant.id,
        quantity: quantity,
        featured_image: `<img id="ovgallery-main-image" class="orbitvu-gallery-main-image orbitvu-lightbox-cursor" src="${product.featured_image.src}" loading ="lazy" alt="${product.title}" title="${product.title}" style="touch-action: auto; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">`
      }
      console.log({product});
      this.data.selectedBundle.products = [
        bundleProduct,
        ...this.data.selectedBundle.products
      ]
      localStorage.setItem('selectedBundle', JSON.stringify(this.data.selectedBundle));
      this.initSlider();
      $("#quick-view-bundle-modal").removeClass("open")
    },

    tempSetBundle: function(){
      var self = this;
      var bundle = {
        title: 'MOTHER LIKE NO OTHER',
        subtitle: 'Receive 10% when you purchase two or more items',
        products: [
          {
            vendor: 'Sweat Republic',
            title: 'SR RESISTANCE BANDS (3 PACK)',
            price: '3900',
            id: 4676864311399,
            variant_id: 32755047366759,
            featured_image: '<img id="ovgallery-main-image" class="orbitvu-gallery-main-image orbitvu-lightbox-cursor" src="//cdn.shopify.com/s/files/1/0251/0743/1527/products/SWEATREPUBLIC_17JUNE_2020_1_400x728.jpg?v=1608149878" loading="lazy" alt="Sweat Republic Resistance Bands (3 Pack)" title="Sweat Republic Resistance Bands (3 Pack)" srcset="//cdn.shopify.com/s/files/1/0251/0743/1527/products/SWEATREPUBLIC_17JUNE_2020_1_450x.jpg?v=1608149878 450w, //cdn.shopify.com/s/files/1/0251/0743/1527/products/SWEATREPUBLIC_17JUNE_2020_1_800x.jpg?v=1608149878 800w" sizes="(min-width: 1008px) 450pw, 100vw" style="touch-action: auto; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">'
          }
        ]
        
      };
      
      localStorage.setItem('selectedBundle', JSON.stringify(bundle));

    },

    bind: function() {
      var self = this;

      tinybind.bind(self.$container, {
        data: self.data,
      });
    },

  });

  return CollectionBundleBuilder;

})();

$(document).ready(function() {

  var collectionTextBanner = $('.collection__header-description-banner');
  if(collectionTextBanner){
    var bannerTextCount = collectionTextBanner.find('.collection__header-description > p').text().length;

    if (bannerTextCount <= 99) {
      collectionTextBanner.addClass('description-banner__short-on-mobile');
    }

    if (bannerTextCount <= 229) {
      collectionTextBanner.addClass('description-banner__short-on-desktop');
    }
  }

  $('.bc-sf-filter-tree-mobile-button').on('click', toggleFiltersMenu);

  $('.close-button-container').on('click', toggleFiltersMenu);

  function toggleFiltersMenu() {
    var filterMenu = $('#bc-sf-filter-tree');
    var openClass = 'bc-sf-filter-tree-mobile-open'
    if(filterMenu.hasClass(openClass)) {
      filterMenu.removeClass(openClass)
      $('.collection-section header').css('display', 'block')
      $('#bc-sf-filter-tree').css('display', 'none');
      $('.filter-mobile-top-bar').removeClass('open');
      $('.filter-backdrop').removeClass('show');
      $('.collection__product-count').css('display', 'block')
    } else {
      filterMenu.addClass(openClass)
      $('.collection-section header').css('display', 'none')
      $('#bc-sf-filter-tree').css('display', 'block');
      $('.filter-mobile-top-bar').addClass('open');
      $('.filter-backdrop').addClass('show');
      $('.collection__product-count').css('display', 'none')
    }
  }

  // Object-fit polyfill initialise
  objectFitImages();

  // Hacky IE Lazysizes fix until we find a better solution or drop IE
  if (isMSIE) {
    var lazyImageChecker = window.setInterval(function(){
      if(!$('img.lazyload').length) { window.clearInterval(lazyImageChecker); }
      $('img.lazyloading').each(function(){
        var imageSrc = $(this).attr('data-src');
        $(this).removeClass('lazyloading');
        $(this).get(0).src = imageSrc;
      });
    }, 3000);
  }

  var sections = new slate.Sections();
  sections.register('cart-template', theme.Cart);
  // sections.register('gift-product', theme.GiftProduct);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('sticky-sub-nav', theme.StickySubNav);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
  sections.register('brand-values', theme.BrandValueSliders);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('featured-collections', theme.FeaturedCollections);
  sections.register('featured-brands', theme.FeaturedBrands);
  sections.register('releases', theme.Releases);
  sections.register('featured-product', theme.FeaturedProduct);
  sections.register('featured-products', theme.FeaturedProducts);
  sections.register('image-row', theme.ImageRows);
  sections.register('content-slider', theme.ContentSliders);
  sections.register('latest-blog-posts', theme.LatestBlogPosts);
  sections.register('image-gallery-slider', theme.ImageGallerySliders);
  sections.register('instagram-feature', theme.Instagram);
  sections.register('store-locator', theme.StoreLocator);
  sections.register('section-review', theme.PageReview);
  sections.register('video-mp4', theme.mp4Video);
  sections.register('lookbook__slider', theme.ArticleLookbookSlider);
  sections.register('template-collection-bundle-builder', theme.CollectionBundleBuilder);


  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });
  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="youtube-nocookie.com/embed"],' +
    '.rte iframe[src*="youtu.be"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Setup progress bar plugin
  if ('NProgress' in window) {
    NProgress.configure({ showSpinner: false });
  }

  // Show/record recently viewed products
  if (theme.RecentlyViewed) {
    theme.RecentlyViewed.showRecentlyViewed();
    theme.RecentlyViewed.recordRecentlyViewed();
  }

  // Show shop the look products
  if (theme.ShopTheLook) {
    theme.ShopTheLook.showShopTheLook();
  }


  // Transition helpers
  $('[data-prepare-transition="hover"]').on('mouseenter', function(){
    var activeClass = $(this).data('data-prepare-transition-class') || 'hover';
    $(this).prepareTransition().addClass(activeClass);
  });

  $('[data-prepare-transition="hover"]').on('mouseleave', function(){
    var activeClass = $(this).data('data-prepare-transition-class') || 'hover';
    $(this).prepareTransition().removeClass(activeClass);
  });


  // Update 'last viewed of type' text to match last viewed object, e.g. breadcrumbs

  $('[data-last-viewed]').each(function(){
    var $this = $(this);
    var type = $this.data('last-viewed');
    var typeVar = 'lastViewed' + type.charAt(0).toUpperCase() + type.slice(1);
    var lastViewed = sessionStorage[typeVar];

    if (lastViewed !== undefined) {
      type += 's';
      var relatedObjects = $this.data('related-' + type);
      if (relatedObjects[lastViewed] !== undefined) {
        $this.text(relatedObjects[lastViewed].title);
      }
    }
  });


  document.querySelectorAll('[data-viewport-container]').forEach(function(elem){
    if (elem.scrollWidth > elem.clientWidth) {
      elem.classList.add('force-visibility');
    }
  });


  // add/remove transparent header background

  var $transparentHeader = $('.template-index .site-header.site-header--transparent');

  if($transparentHeader.length) {
    var waypointElement = $('#PageContent');
    self.waypoint = new Waypoint({
      element: waypointElement,
      handler: function(direction) {
        if (direction == 'down') {
          $transparentHeader.addClass('site-header--scrolled');
        } else {
          $transparentHeader.removeClass('site-header--scrolled');
        }
      },
      offset: function() {
        var height = window.innerHeight * -1;
        return height;
      }
    });
  }
  //Loyalty Lion extra elements
  $(document).on('click', '.lion-loyalty-widget', function() {
    $element = '<div class="lion-loyalty-splash-item lion-loyalty-splash-item--rule"><div class="lion-loyalty-splash-item__icon lion-icon lion-icon__rule--custom"></div><div class="lion-loyalty-splash-item__info"><div class="lion-loyalty-splash-item__title">Join our VIP Facebook Page</div><div class="lion-loyalty-splash-item__value">50 points</div></div></div>'
    $element2 = '<div class="lion-loyalty-splash-item lion-loyalty-splash-item--rule"><div class="lion-loyalty-splash-item__icon lion-icon lion-icon__rule--custom"></div><div class="lion-loyalty-splash-item__info"><div class="lion-loyalty-splash-item__title">Post a photo on Augustine VIP page</div><div class="lion-loyalty-splash-item__value">35 points</div></div></div>'
    var containerSelector = '.lion-loyalty-splash-column--rules .lion-loyalty-splash-column__items';

    var checkExist = setInterval(function() {
       if ($(containerSelector).length) {
          $(containerSelector).append($element);
         $(containerSelector).append($element2);
          clearInterval(checkExist);
       }
    }, 100);
  });
  // Show password buttons
  $('.form-vertical__password-toggle').on('click', function(){
    var $input = $($(this).siblings('input'));

    $(this).toggleClass('active');

    if ($input.attr('type') == 'password') {
      $input.attr('type', 'text');
    } else {
      $input.attr('type', 'password');
    }
  });


  // Init CSS Custom Property polyfill
  cssVars();


  if (window.location.hostname == 'localhost') {
    document.documentElement.classList.add('localhost');
  }

  try {
    var colorPrimary = getComputedStyle(document.body).getPropertyValue('--color-primary').trim();
    $('meta[name=theme-color]').attr('content', colorPrimary);
  } catch (err) {
    console.error(err);
  }

  // Submit customer forms with Accentuate
  var asyncForms = document.querySelectorAll('[data-async-submit]');

  for (var i = asyncForms.length - 1; i >= 0; i--) {
    var asyncForm = asyncForms[i];
    $(asyncForm).on('submit.asyncSubmit', function() {
      event.preventDefault();
      asyncSubmitForm(asyncForm);
    });
  }

  function asyncSubmitForm(form) {

    var submitButton = form.querySelector('[type="submit"]');
    form.classList.add('loading');
    submitButton.classList.add('loading');

    var $form = $(form);
    loadJS('https://app.accentuate.io/dist/proxy.js', function() {

      $form.off('submit.asyncSubmit');

      Accentuate($form, function() {
        setTimeout(function() {
          window.location.reload();
        }, 500);
      });

      $form.submit();

    });

  }

   if($('.form--success').length > 0) {
     $('html, body').animate({
       scrollTop: $('.form--success').offset().top
     }, 'slow');
   }

   (function() {
    var tabs = $('[data-mobile-tab]');
    var tabContent = document.createElement('div');
    tabContent.setAttribute('class', 'mobile-tab__list');
    if (tabs.length) {
      tabs.each(function() {
        var tabHead = $(this).find('[data-mobile-tab-title]').attr('data-mobile-tab-title');
        var tabId = $(this).attr('id');
        var tabItem = document.createElement('div');
        tabItem.setAttribute('data-tab', tabId);
        tabItem.setAttribute('class', 'mobile-tab__item');
        tabItem.append(tabHead);
        tabContent.append(tabItem);
      })
      var tabBlock = document.createElement('div');
      $('#mobile-tabs').append(tabContent);
    }

    if ($('[data-tab]').length) {
      $('[data-tab]').on('click', function() {
        var tabToShow = $(this).attr('data-tab');
        $('[data-tab]').removeClass('active');
        $('[data-mobile-tab]').removeClass('active');
        $(this).addClass('active');
        $('#'+tabToShow).addClass('active');
      })
      $('[data-tab]').first().trigger('click');
    }
   })()

    theme.lookbook = (function() {

        var $blogLookbook = $('.template-blog-lookbook, .template-product'),
            $lookbook = $('.lookbook'),
            lookbookCTA = '.lookbook-grid-item__actions',
            lookbooClose = '.lookbook-modal__close',
            lookbookProductSelect =  '.lookbook-product__select',
            playButton = '.video__play',
            pauseButton = '.video__pause',
            moreColorsCTA = '.more-colours__cta';

        if (!$lookbook.length) {
            return;
        }

        if ( $('.lookbook-grid').children().length < 1 ) {
          $('.lookbook').hide();
        }

        function updateVariantId() {
          var selectedVariant = $(this).find(":selected"),
              variantId = selectedVariant.val(),
              $addToCartButton = $($(this).next()[0]);

            if ((selectedVariant).hasClass('variant-unavailable')) {
                $addToCartButton.attr('disabled', 'true');
            } else {
                $addToCartButton.attr("data-cart-add", variantId).removeAttr('disabled');
            }
        };

        function closeLookbookModal () {
            $('.lookbook-modal-wrapper').addClass('hidden');
            $('body').removeClass('lookbook-modal-open');
            ($blogLookbook.find('.video__video-container')).each(function () {
                this.pause();
            });
        };

        function playLookbookVideo() {
            $video = $(this).closest('.lookbook-modal').find('.video__video-container')[0];
            $video.play();
            $(this).closest('.lookbook-modal').find('.video__pause').css('visibility','visible');
        };

        function pauseLookbookVideo() {
            var $video = $(this).closest('.lookbook-modal').find('.video__video-container')[0];
            $video.pause();
            $(this).closest('.lookbook-modal').find('.video__pause').css('visibility','hidden');
        };


        function openLookbookModal() {
            var target = $(this).data('modal'),
            lookbookModalWrapper = $('.lookbook-modal-wrapper' + '[data-modal=' + target + ']');

            if(lookbookModalWrapper.length) {
                lookbookModalWrapper.removeClass('hidden');
                $('body').addClass('lookbook-modal-open');
                document.dispatchEvent(new CustomEvent("swym:lookbook", {
                  detail: {target}
                }));
            } else {
                var articleUrl = $(this).data('article-url');
                $('body').addClass('lookbook-modal-open');
                $.ajax({
                    url: articleUrl,
                    type: 'GET'
                }).done(function (articleData) {
                    $('#PageContainer').append($(articleData).find('.lookbook-modal-container').html());
                    $(this).removeData('article-url');
                    document.dispatchEvent(new CustomEvent("swym:lookbook", {
                      detail: {target}
                    }));
                });
            }
        }

        function loadMorePosts() {

            moreButon = $('#load-more').last();
            nextUrl = $(moreButon).find('span').data("next");
            view = $('.lookbook-viewed').last()
            currentPage = $(view).find('.lookbook-viewed__count').data("current-page");

            $('#load-more').on('click', function () {
                triggered = true;

                $.ajax({
                    url: nextUrl,
                    type: 'GET'
                }).done(function (data) {
                    $('.lookbook-grid').append($(data).find('.lookbook-grid').html());

                    triggered = false;

                    var nextButton = $(data).find('#load-more');
                    nextUrl = $(nextButton).find('span').data("next");
                    var nextView = $(data).find('.lookbook-viewed');
                    currentPage = $(nextView).find('.lookbook-viewed__count').data("current-page");
                    if (nextUrl !== 'undefined' && nextUrl !== '' && nextUrl.length) {
                        getNextUrl(nextUrl);
                    } else {
                        moreButon.remove();
                    }
                    getCurrentPage(currentPage);
                });

            function getNextUrl(nextUrl) {
                $('#load-more').find('span').attr("data-next", nextUrl);
            }

            function getCurrentPage(currentPage) {
                $('.lookbook-viewed__count').attr("data-current-page", currentPage);
            }

                //progress bar
                currentPage = currentPage + 1;
                lookbookPerPage = $('.lookbook').data('looks-per-page');
                lookbookTotal = $('.lookbook').data('looks-total');
                viewing = currentPage * lookbookPerPage;

                if (viewing >= lookbookTotal) {
                    viewing = lookbookTotal
                };

                $(".lookbook-viewed__count").html(viewing);
                $('.lookbook-viewed__bar').css('width', (viewing / lookbookTotal * 100) + '%')
            });
        };

        $lookbook.on('click', lookbookCTA, openLookbookModal);

        $blogLookbook.on('change', lookbookProductSelect, updateVariantId);

        $blogLookbook.on('click', lookbooClose, closeLookbookModal);


        $(document).on('keydown', function (evt) {
            if (evt.which == 27) {
                closeLookbookModal();
            }
        });

        $blogLookbook.on('click', playButton, playLookbookVideo);

        $blogLookbook.on('click', pauseButton, pauseLookbookVideo);

        $blogLookbook.on('click', moreColorsCTA , function () {
            $(this).closest('.more-colours').toggleClass('active');
        });

        loadMorePosts();
    })();

    window.theme = window.theme || {};
    theme.ArticleLookbookSlider = (function () {
      function ArticleLookbookSlider() {
        $('.lookbook__slider').slick({
          dots: false,
          arrow: true,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-chevron-left" viewbox="0 0 284.49 498.98" aria-hidden="true" focusable="false" role="presentation"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-chevron-right" viewbox="0 0 284.49 498.98" aria-hidden="true" focusable="false" role="presentation"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"/></svg></button>'
        });
      }
      return ArticleLookbookSlider();
    })();

    theme.mp4Video = (function () {
        var selectors = {
            soundСontrollers: '.sound-controllers',
            soundOn: '.sound-controllers__on',
            soundOff: '.sound-controllers__off',
            video: '.video-mp4-wrapper .video__video-container'
        };

        var $video =  $(selectors.video)[0];

        $(selectors.soundOn).on('click', function () {
            $video.muted = false;
            $(this).css('display', 'none');
            $(selectors.soundOff).css('display', 'block');
        });

        $(selectors.soundOff).on('click', function () {
            $video.muted = true;
            $(this).css('display', 'none');
            $(selectors.soundOn).css('display', 'block');
        });
    })();

});

// QUICK VIEW -------------------------------------------------------------------------------
theme.QuickView = (function() {
  $('body').on('click', '.js-quick-shop-link', function (e) {
    e.preventDefault(); //Set productData object based on data attributes
    var modalSelector = $('#quick_shop_product_' + $(this).attr('data-id') );

   var modalQuickView = $.featherlight(modalSelector,{
      afterContent: function(e) {
        quickViewInit(this);
        $(this.$content).find('form[action="/cart/add"]').on('submit', function(e) {
          $.featherlight.current().close();
        });
        document.dispatchEvent(new CustomEvent("swym:quick-view"));
      }
    });
  });

  function quickViewInit(data) {
    var popupContent = $(data.$content);
    var productHandle = popupContent.attr('data-handle');
    var thumbs = popupContent.find('.thumb-item');
    var selectors = popupContent.find('.option-selector-radio');
    var formButton = popupContent.find('.product-form__cart-submit');
    var notifyForm = popupContent.find('.product_notify_form');
    var priceText = popupContent.find('.product__price-text');
    var skuText = popupContent.find('.product__sku');
    var variantInput = popupContent.find('.product_variant_id');

    // IMAGES INIT
    var slideshow = popupContent.find('.product__main-image').slick();

    thumbs.first().addClass('active');

    thumbs.on('click', function (e) {
      let newUrl = $(this).find('img').attr('src')
      $('.quick_shop_popup_content .product-main-image').attr('src', newUrl);

      $(this).siblings('.thumb-item').removeClass('active');
      $(this).addClass('active');

      $(slideshow).slick('slickGoTo',$(this).index());
    });

    $(slideshow).on('beforeChange', function(e, s, cS, nS){
      thumbs.removeClass('active').eq(nS).addClass('active');
    });

    // SELECTORS INIT
    $(selectors).on('click', function(e){
      $(this).siblings('.option-selector-radio').removeClass('active');
      $(this).addClass('active');

      $(this).parent().parent().find('.single-option-name i').html( ': ' + $(this).find('input').val() );
    });

    // SHOW NOTIFY FORM
    $(popupContent).find('.notify_message a').on('click', function(e){
      e.preventDefault();
      $(popupContent).find('.notify_message').slideUp(300);
      $(popupContent).find('.contact-form').slideDown(300);
    });
    $(popupContent).find('.BIS_trigger').on('click', function(e){
      if(!BIS) return
      event.preventDefault();
      event.stopPropagation();
      var prodHandle = $(this).data('handle');
      var productData = theme.current.collection.products.find(function(p) { return p.handle == prodHandle });

      BIS.popover = BIS.createPopover({
        productHandle: prodHandle,
        product: productData,
        button: {
          visible: false
        }
      })
      BIS.popover.toggle();

      $.featherlight.current().close();
    });

    // ADD/REMOVE TO WISHLIST

    $(popupContent).find('.swym-button').on('click', function(e){
        let prodId = $(this).attr('data-product-id');
        let addBtn = $('#product-grid-item-' + prodId).find('.wishlist-add .swym-button');
    });

    // GET SELECTED VARIANT
    function getVariant(prod) {
      var selectedVariant = false;
      var selectedOptioins = [];
      var inputs = popupContent.find('.product_form_selectors .option-selector-radio input');

      for (let i = 0; i < inputs.length; i++) {
        if ( inputs[i].checked ) {
          selectedOptioins.push($(inputs[i]).val());
        }
      }
      for (let l = 0; l < prod.variants.length; l++) {
        let variantOption = prod.variants[l].title.split(' / ');

        let entrance = 0
        for (let j = 0; j < variantOption.length; j++) {

          for (let k = 0; k < selectedOptioins.length; k++) {
            const element = selectedOptioins[k];
            if ( selectedOptioins[k] === variantOption[j] ) {
              entrance ++
            }
          }
        }
        if ( entrance === variantOption.length ) {
          selectedVariant = prod.variants[l];
          break;
        }
      }
      return selectedVariant;
    }


    // TRACK AVAILABILITY
    function availabilityCheck(variant) {
      // Update Values
      if (variant) {
        // change variant id
        $(variantInput).val(variant.id);

        // change price
        $(priceText).html(slate.Currency.formatMoney(variant.price, shop.moneyWithCurrencyFormat));

        // change sku
        $(skuText).html(variant.sku);
      }

      // change button
      if ( variant && variant.available ) {
        $(formButton).attr('disabled', false);
        $(formButton).find('.button_text').html('ADD TO BAG');
        $(notifyForm).slideUp(300);

        $(notifyForm).find('.notify_message').show();
        $(notifyForm).find('.contact-form').hide();
      } else {
        $(formButton).attr('disabled', true);
        $(formButton).find('.button_text').html('SOLD OUT');
        $(notifyForm).slideDown(300);
      }
    }


    // MARKING NOT AVAILABLE OPTIONS
    function indicateAvailableOptions(variants, optSize) {
      let inputs = popupContent.find('.product_form_selectors .option-selector-radio input');
      let selectedOptioins = [];
      let availableArr = [];

      for (let i = 0; i < inputs.length; i++) {
        if ( inputs[i].checked ) {
          selectedOptioins.push(inputs[i].value);
        }
      }

      if ( optSize > 1 ) {
        for (let l = 0; l < variants.length; l++) {
          let title = variants[l].title;
          let optionsArr = variants[l].title.split(' / ');

          for (let j = 0; j < selectedOptioins.length; j++) {
            if ( optionsArr.indexOf(selectedOptioins[j] ) + 1 && variants[l].available ) {
              if (optionsArr.length > 1) {
                var otherVal = optionsArr.filter( item => item !== selectedOptioins[j] );
                availableArr.push(otherVal);
              } else {
                availableArr.push(selectedOptioins[j]);
              }
            }
          }
        }

        availableArr = availableArr.flat();

      } else {

        for (let l = 0; l < variants.length; l++) {
          if ( variants[l].available ) {
            availableArr.push(variants[l].title);
          }
        }
      }

      $(inputs).parent().addClass('missing');
      $(inputs).each(function() {
        let inputVal = this.value;

        for (let i = 0; i < availableArr.length; i++) {
          if ( inputVal == availableArr[i] ) {
            $(this).parent().removeClass('missing');
          }
        }
      });
    }


    // GET PRODUCT JSON AND VALIDATE PRODUCT FORM
    theme.utils.getProductJSON(productHandle, function(p) {
      product = JSON.parse(p);

      // INIT VARIANT OPTIONS
      $(selectors).find('input').on('click', function(e) {

        var variant = getVariant(product);

        availabilityCheck(variant);

        indicateAvailableOptions(product.variants, product.options_size);

      });

      // SELECT FIRST SIZE OPTIONS ASTER INIT
      $(popupContent).find('.option-selector-size input').first().trigger('click');
    });

  }

})();


(function() {
  const selectors = {
    stepNumber: ".stylist-quiz-step-number"
  };

  $('body').on('click', '.btn-pseudo-continue', function(){
    let $pseudoBtn = $('.btn-pseudo-continue');
    let currentStep = $pseudoBtn.attr( "data-stepnumber");
    let nextStep = Number(currentStep) + 1;

    $pseudoBtn.html('Continue')

    let validationStatus = 0;
    let countValidationField = 0;
    let validationCheckboxes = $(`.stylist-quiz-${currentStep} .js-stylist-quiz-checkbox`);
    let validationRadio = $(`.stylist-quiz-${currentStep} .js-stylist-quiz-radio`);
    let validationTextarea = $(`.stylist-quiz-${currentStep} .js-stylist-quiz-textarea`);

    if(validationCheckboxes.length>0){
      validationCheckboxes.each(function( index, checkbox ) {
        countValidationField = countValidationField+1;
        let checkboxInputsChecked = $(checkbox).find('input[type="checkbox"]:checked');

        if(checkboxInputsChecked.length>0){
          validationStatus=validationStatus+1;
          $(checkbox).prev('.error-field-text').remove();
        }else{
          $(checkbox).prev('.error-field-text').remove();
          $(checkbox).before("<p class='error-field-text'>This field cannot be empty</p>");
        }

      });
    }

    if(validationRadio.length>0){
      console.log(validationRadio);
      validationRadio.each(function( index, radio ) {
        countValidationField = countValidationField+1;
        let radioInputsChecked = $(radio).find('input[type="radio"]:checked');

        if(radioInputsChecked.length==1){
          validationStatus=validationStatus+1;
          $(radio).prev('.error-field-text').remove();
        }else{
          $(radio).prev('.error-field-text').remove();
          $(radio).before("<p class='error-field-text'>This field cannot be empty</p>");
        }

      });
    }

    if(validationTextarea.length>0){
      validationTextarea.each(function( index, textarea ) {
        countValidationField = countValidationField+1;
        let validationTextareaValue = $(textarea).val();
        if(validationTextareaValue.length>0){
          validationStatus=validationStatus+1;
          $(textarea).next('.error-field-text').remove();
        }else{
          $(textarea).next('.error-field-text').remove();
          $(textarea).after("<p class='error-field-text'>This field cannot be empty</p>");
        }
      });
    }

    if(validationStatus==countValidationField){

      if(currentStep==10){
        $('#stylist_form').submit();
      }else{
        $(`.stylist-quiz-${currentStep}`).addClass('not-active-step');
        $(`.stylist-quiz-${nextStep}`).removeClass('not-active-step');
        $(`.progress-steps-lines__step${nextStep}`).addClass('active_step');

        $(selectors.stepNumber).text(nextStep);
      }
        $pseudoBtn.attr( "data-stepnumber", nextStep );
        $("html, body").animate({ scrollTop: 0 }, "slow");

      if(nextStep>0){
        $('.stylist-quiz-back-btn').removeAttr("disabled");
      }
    }
  });

  $('body').on('click', '.stylist-quiz-back-btn', function(){
    let $pseudoBtn = $('.btn-pseudo-continue');
    let currentStep = $pseudoBtn.attr( "data-stepnumber");
    let prevStep = Number(currentStep) - 1;
    $(`.stylist-quiz-${currentStep}`).addClass('not-active-step');
    $(`.stylist-quiz-${prevStep}`).removeClass('not-active-step');
    $(`.progress-steps-lines__step${currentStep}`).removeClass('active_step');


    $(selectors.stepNumber).text(prevStep !== 0 ? prevStep : '');

   if(prevStep==0){
      $('.stylist-quiz-back-btn').prop("disabled", true);
     $pseudoBtn.html('Start now')
    }
      $pseudoBtn.attr( "data-stepnumber", prevStep);
      $("html, body").animate({ scrollTop: 0 }, "slow");

  });

})();

// QUICK VIEW ADD TO CART


if($('.gift-bundle-info-block-items').length>0){
  $('.gift-bundle-info-block-items').slick({
    infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 899,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }

  ]
});
}


 document.addEventListener("DOMContentLoaded", function() {
    function swymCallbackFn(){
      
      function SwymCounter() {
        var counter = document.querySelector('.swym-wishlist__counter');
        if(!counter){
          return;
        }
        window._swat.renderWishlistCount(document.querySelector('.swym-wishlist__counter'), function(cnt, elem){
        }, 500);
      }

      function getSwymProducts() {
        window._swat.fetch(function(wishlistProducts) {
          document.dispatchEvent(new CustomEvent('wishlistLoaded', { detail: {products: wishlistProducts} }));
          return;
        }, function(error) {
          console.log("There was an error while fetching the wishlist", error)
        });
      }

      function bindEvents(){
        document.addEventListener('getWishlist', function(){
          getSwymProducts();
        });
        document.addEventListener('removeWishlistItem', function(event){
          let product = event.detail;
          removeProduct(product);
        });
        document.addEventListener('addWishlistItem', function(event){
          console.log('add product to wishlist')
          let product = event.detail;
          addProduct(product);
        });
      }

      function removeProduct(product){
        window._swat.removeFromWishList(product, function(wishlistProducts) {
          getSwymProducts();
        }, function(error){
          console.log("There was an error while removing product from the wishlist", error)
        });
      }

      function addProduct(product){
        window._swat.addToWishList(product, function(wishlistProducts) {
          getSwymProducts();
        }, function(error){
          console.log("There was an error while removing product from the wishlist", error)
        });
      }

      SwymCounter();
      getSwymProducts();
      bindEvents();
      
    }
    if(!window.SwymCallbacks){
        window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn)
  });


